{
  "common": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "add": "إضافة",
    "search": "بحث",
    "loading": "جاري التحميل...",
    "error": "خطأ",
    "success": "نجاح",
    "back": "رجوع",
    "next": "التالي",
    "previous": "السابق",
    "close": "إغلاق",
    "appName": "{brand}",
    "searchPlaceholder": "بحث...",
    "connectionReconnecting": "جاري إعادة الاتصال...",
    "connectionLostClickRetry": "فقد الاتصال. انقر لإعادة المحاولة.",
    "connectionOffline": "غير متصل",
    "searchExpandedPlaceholder": "البحث في الميزات أو المستندات...",
    "searchPromptEmpty": "اكتب للبحث في الميزات أو المستندات ذات الصلة",
    "searchSectionApplication": "التطبيق",
    "searchSectionDocumentation": "التوثيق",
    "searchNoFeatureResults": "لا توجد ميزات مطابقة لهذا الاستعلام",
    "searchNoDocResults": "لا يوجد توثيق مطابق لهذا الاستعلام",
    "description": "وصف",
    "preview": "معاينة",
    "addTag": "إضافة علامة...",
    "searchProjects": "البحث في المشاريع...",
    "searchModels": "البحث عن النماذج...",
    "all": "الكل",
    "favorites": "المفضلة",
    "searchResource": "بحث في {{resource}}...",
    "selectAll": "تحديد الكل",
    "clearAll": "مسح الكل",
    "resetToDefault": "إعادة التعيين إلى الافتراضي",
    "noOptionsAvailable": "لا توجد خيارات متاحة",
    "noMoreItems": "لا توجد عناصر أخرى",
    "clearSearch": "مسح البحث",
    "apply": "تطبيق",
    "clear": "مسح",
    "yes": "نعم",
    "no": "لا",
    "notResource": "ليس {{resource}}",
    "afterDate": "بعد {{date}}",
    "beforeDate": "قبل {{date}}",
    "removeFilter": "إزالة فلتر {{label}}",
    "removeFilterWithColon": "إزالة الفلتر: {{label}}",
    "showResource": "إظهار {{resource}}",
    "hideResource": "إخفاء {{resource}}",
    "saveChanges": "حفظ التغييرات",
    "processing": "جاري المعالجة...",
    "copy": "نسخ",
    "copied": "تم النسخ",
    "or": "أو",
    "filters": "عوامل التصفية",
    "searchItem": "البحث في {{item}}...",
    "searchItemAria": "البحث في {{item}}",
    "searchPrompts": "البحث في المطالبات...",
    "showItem": "عرض {{item}}",
    "hideItem": "إخفاء {{item}}"
  },
  "productDocs": {
    "title": "Product documentation",
    "lead": "Guides for getting started, models, tools, Agent Studio, observability, and administration — served from the same site as the platform.",
    "openNewTab": "Open in new tab",
    "openSameWindow": "Open in this window",
    "hint": "Docs are not shown inside the app shell because some login or edge responses set X-Frame-Options: DENY on pages that are not meant to be embedded. Opening in a new tab or full window keeps clickjacking protection intact and is the recommended way to read documentation."
  },
  "agentStore": {
    "title": "متجر الوكلاء",
    "subtitle": "اكتشف وكلاء الذكاء الاصطناعي للمؤسسات وانشرهم",
    "search": "ابحث عن الوكلاء بالاسم...",
    "manage": "إدارة",
    "manageTooltip": "إدارة متجر الوكلاء",
    "loading": "جارٍ تحميل الوكلاء...",
    "all": "الكل",
    "allAgents": "جميع الوكلاء",
    "allAgentsCount": "جميع الوكلاء ({{count}})",
    "resultsFound_zero": "لم يتم العثور على وكلاء",
    "resultsFound_one": "تم العثور على وكيل واحد",
    "resultsFound_two": "تم العثور على وكيلين",
    "resultsFound_few": "تم العثور على {{count}} وكلاء",
    "resultsFound_many": "تم العثور على {{count}} وكيلاً",
    "resultsFound_other": "تم العثور على {{count}} وكيل",
    "view": "عرض",
    "open": "فتح",
    "openApp": "فتح التطبيق",
    "pending": "قيد الانتظار",
    "subscribe": "اشتراك",
    "unnamedAgent": "وكيل",
    "categoryOther": "أخرى",
    "noDescription": "لا يوجد وصف متاح",
    "noAgents": "لم يتم العثور على وكلاء",
    "noAgentsInCategory": "لم يتم العثور على وكلاء في {{category}}",
    "tryAdjusting": "حاول تعديل معايير البحث أو التصفية"
  },
  "catalogFilters": {
    "filters": "عوامل التصفية",
    "filtersApplied": "عوامل التصفية ({{count}} مطبقة)",
    "clearAll": "مسح الكل",
    "creator": "المُنشئ",
    "allCreators": "جميع المُنشئين",
    "searchCreators": "ابحث عن المُنشئين...",
    "rating": "التقييم",
    "allRatings": "جميع التقييمات",
    "rating5": "5 نجوم",
    "rating4Up": "4 نجوم فأكثر",
    "rating3Up": "3 نجوم فأكثر",
    "allOf": "جميع {{label}}"
  },
  "nav": {
    "home": "الرئيسية",
    "ideate": "منصة ذكاء القرار",
    "solutions": "الحلول",
    "agentStore": "متجر الوكلاء",
    "workflowStore": "متجر سير العمل",
    "projects": "المشاريع",
    "data": "البيانات",
    "agentStudio": "استوديو الوكلاء",
    "agentWorkflows": "سير عمل الوكلاء",
    "registry": "السجل",
    "registryUnified": "السجل",
    "aiTransparency": "شفافية الذكاء الاصطناعي",
    "workflowRegistry": "سجل سير العمل",
    "agentDeployments": "نشر الوكلاء",
    "workflowDeployments": "نشر سير العمل",
    "workflowStoreBrowse": "تصفح سير العمل",
    "workflowStoreManage": "إدارة متجر سير العمل",
    "workflowStoreAbout": "تفاصيل سير العمل",
    "simulations": "المحاكاة",
    "evalsSimulations": "التقييمات والمحاكاة",
    "monitoring": "المراقبة",
    "cache": "التخزين المؤقت",
    "agentEvals": "تقييمات الوكلاء",
    "evalTemplates": "قوالب التقييم",
    "benchmarks": "المعايير",
    "environments": "البيئات",
    "evaluations": "التقييمات",
    "agents": "الوكلاء",
    "models": "النماذج",
    "tools": "الأدوات",
    "prompts": "المطالبات",
    "skills": "المهارات",
    "knowledge": "المعرفة",
    "connections": "الاتصالات",
    "docs": "الوثائق",
    "admin": "الإدارة",
    "platformAdmin": "إدارة المنصة",
    "settings": "الإعدادات",
    "chat": "الدردشة",
    "goToHome": "الذهاب إلى الرئيسية",
    "userMenu": "قائمة المستخدم",
    "account": "الحساب",
    "switchRole": "تبديل الدور",
    "tenant": "المستأجر",
    "logout": "تسجيل الخروج",
    "help": "المساعدة",
    "helpDocumentation": "المساعدة والوثائق",
    "themeDarkModeTitle": "الوضع الداكن",
    "themeLightModeTitle": "الوضع الفاتح",
    "themeSwitchToDarkAria": "التبديل إلى الوضع الداكن",
    "themeSwitchToLightAria": "التبديل إلى الوضع الفاتح",
    "sections": {
      "agentDevelop": "تطوير الوكلاء",
      "observability": "قابلية المراقبة",
      "agentOps": "عمليات الوكلاء",
      "resources": "الموارد",
      "admin": "الإدارة",
      "aiBlueprints": "المخططات",
      "enterpriseOntology": "أنطولوجيا المؤسسة"
    },
    "blueprints": "المخططات",
    "autopilot": "منصة ذكاء القرار",
    "brandMilkyway": "{brand}",
    "brandPlatform": "منصة {brand}",
    "switchToMilkyway": "{brand}",
    "switchToPlatform": "منصة {brand}",
    "ontologyCanvas": "لوحة الأنطولوجيا",
    "dataModels": "نماذج البيانات",
    "kpiLibrary": "مكتبة مؤشرات الأداء",
    "migrationsStudio": "استوديو الهجرة",
    "dataPipelines": "استوديو البيانات",
    "pipelineDesigner": "استوديو تعلم الآلة",
    "dataExplorer": "مستكشف البيانات",
    "dataObservability": "قابلية مراقبة البيانات",
    "switchToDataflow": "استوديو أنطولوجيا {brand}"
  },
  "settings": {
    "title": "الإعدادات",
    "description": "إدارة إعدادات حسابك وتفضيلاتك",
    "profile": "ملف المستخدم",
    "appearance": "المظهر",
    "language": "اللغة",
    "languageDescription": "اختر لغتك المفضلة",
    "theme": "السمة",
    "light": "فاتح",
    "dark": "داكن",
    "appearanceHeading": "المظهر",
    "appearanceSubtitle": "خصص شكل وأسلوب مساحة عملك",
    "colorTheme": "سمة اللون",
    "colorThemeDescription": "اختر لوحة ألوان للتطبيق",
    "displayModeSection": "وضع العرض",
    "displayModeDescription": "اختر بين الوضع الفاتح والداكن",
    "themeDefaultBadge": "افتراضي",
    "loadingAppearance": "جاري تحميل إعدادات المظهر...",
    "notifications": {
      "title": "الإشعارات"
    },
    "integrations": {
      "title": "عمليات الدمج"
    }
  },
  "models": {
    "title": "النماذج",
    "addModel": "إضافة نموذج",
    "editModel": "تعديل نموذج",
    "modelName": "اسم النموذج",
    "provider": "المزود",
    "baseUrl": "رابط الأساس",
    "chat": "الدردشة",
    "deleteConfirm": "هل أنت متأكد أنك تريد حذف هذا النموذج؟",
    "noModels": "لم يتم العثور على نماذج في المشروع المرتبط",
    "filterProvider": "المزود",
    "filterStatus": "الحالة",
    "filterCreator": "المنشئ",
    "statusActive": "نشط",
    "statusDeprecated": "مهمل",
    "columnModelName": "اسم النموذج",
    "columnProvider": "المزود",
    "columnStatus": "الحالة",
    "columnAccess": "الوصول",
    "columnCreatedBy": "تم الإنشاء بواسطة",
    "columnCreatedAt": "تاريخ الإنشاء",
    "columnUpdatedAt": "تاريخ التحديث",
    "columnActions": "الإجراءات",
    "actionChat": "محادثة",
    "actionTestConnection": "اختبار الاتصال",
    "actionSetDefault": "تعيين كافتراضي",
    "actionRemoveDefault": "إزالة كافتراضي",
    "actionManageAccess": "إدارة الوصول",
    "actionExport": "تصدير",
    "actionEdit": "تعديل",
    "actionDelete": "حذف",
    "bulkExportSelected": "تصدير المحدد",
    "bulkDeleteSelected": "حذف المحدد",
    "modelArena": "ساحة النماذج",
    "modelArenaTitle": "مقارنة نموذجين في ساحة النماذج",
    "pricingCatalog": "كتالوج الأسعار",
    "pricingCatalogTitle": "عرض وتعديل فترات التسعير بالدولار لكل مليون",
    "deleteModalTitle": "حذف النموذج",
    "deleteModalMessage": "هل أنت متأكد من حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
    "bulkDeleteModalTitle": "حذف النماذج المحددة",
    "bulkDeleteModalMessage": "هل أنت متأكد من حذف {{count}} نموذج؟ لا يمكن التراجع عن هذا الإجراء.",
    "bulkDeleteModalConfirm": "حذف {{count}} نموذج",
    "loadingModels": "جاري تحميل النماذج...",
    "favorites": "المفضلة",
    "filterBarTitle": "الفلاتر",
    "searchPlaceholder": "البحث في النماذج...",
    "defaultModelTooltip": "النموذج الافتراضي",
    "pricing": {
      "title": "كتالوج الأسعار",
      "description": "بالدولار الأمريكي لكل مليون رمز — مرتبة حسب أرخص تكلفة إدخال بين النماذج المرئية. استخدم {{endpoint}} لمقارنة المزودين.",
      "descriptionPrefix": "بالدولار الأمريكي لكل مليون رمز — مرتبة حسب أرخص تكلفة إدخال بين النماذج المرئية. استخدم",
      "descriptionSuffix": "لمقارنة المزودين.",
      "allProviders": "جميع المزودين",
      "fromInput": "من ${{price}}/in",
      "fromInputTooltip": "من ${{price}} / 1 مليون إدخال (النماذج المرئية)",
      "viewMore": "عرض {{count}} إضافي",
      "searchPlaceholder": "البحث عن النماذج أو المزودين…",
      "emptyMessage": "لم يتم العثور على نماذج.",
      "loadingMessage": "جاري تحميل كتالوج الأسعار…",
      "loadModelsFailed": "فشل تحميل النماذج",
      "harvestSuccess": "اكتمل جمع الأسعار: {{summary}}",
      "harvestFailed": "فشل جمع الأسعار",
      "modelsPriced": "تم تسعير {{count}} نموذج",
      "modelsPriced_plural": "تم تسعير {{count}} نموذج",
      "skippedCount": "تم تخطي {{count}}",
      "errorsCount": "{{count}} خطأ",
      "errorsCount_plural": "{{count}} أخطاء",
      "viewHistory": "عرض السجل",
      "noPricing": "لا توجد أسعار",
      "live": "مباشر",
      "notOpenEnded": "غير مفتوح النهاية",
      "notOpenEndedTooltip": "الصف الأخير هو فترة مغلقة — تأكد من وجود فترة مفتوحة للتسعير المستقبلي.",
      "columns": {
        "model": "النموذج",
        "inputRate": "معدل الإدخال",
        "outputRate": "معدل الإخراج",
        "interval": "الفترة",
        "source": "المصدر"
      },
      "history": {
        "title": "سجل الأسعار",
        "subtitle": "سجل الأسعار الكامل. يتم سرد صف الكتالوج النشط أولاً؛ يمكن تعديل الفترات اليدوية والأسعار المجمعة (تصبح تعديلات التجميع تجاوزات يدوية). يمكن حذف الفترات اليدوية فقط.",
        "currentCatalogRate": "معدل الكتالوج الحالي",
        "liveOpenEnded": "مباشر (مفتوح النهاية)",
        "notOpenEnded": "غير مفتوح النهاية",
        "notOpenEndedTooltip": "لا توجد فترة مفتوحة النهاية — يتم عرض أحدث فترة مغلقة كبديل.",
        "searchPlaceholder": "البحث في المصدر، التواريخ، المعدلات…",
        "emptyMessage": "لا توجد صفوف في سجل الأسعار تطابق هذا البحث.",
        "loadingMessage": "جاري تحميل سجل الأسعار…",
        "failedToLoad": "فشل تحميل سجل الأسعار",
        "refresh": "تحديث",
        "addManualInterval": "إضافة فترة يدوية",
        "activeRate": "المعدل النشط",
        "historical": "سجل سابق",
        "effectiveFrom": "يسري من",
        "effectiveUntil": "يسري حتى",
        "unit": "الوحدة",
        "inputRate": "معدل الإدخال",
        "outputRate": "معدل الإخراج",
        "source": "المصدر",
        "deleteModalTitle": "حذف فترة التسعير",
        "deleteModalMessage": "هل أنت متأكد من حذف فترة التسعير اليدوية هذه؟ لا يمكن التراجع عن هذا الإجراء.",
        "delete": "حذف",
        "intervalAdded": "تمت إضافة فترة التسعير",
        "intervalUpdated": "تم تحديث فترة التسعير",
        "intervalDeleted": "تم حذف فترة التسعير",
        "failedToAdd": "فشل إضافة فترة التسعير",
        "failedToUpdate": "فشل تحديث فترة التسعير",
        "failedToDelete": "فشل حذف فترة التسعير",
        "units": {
          "perMinute": "لكل دقيقة",
          "perMillionChars": "لكل مليون حرف",
          "perMillionTokens": "لكل مليون رمز"
        }
      },
      "modal": {
        "addTitle": "إضافة فترة تسعير",
        "editTitle": "تعديل فترة التسعير",
        "model": "النموذج",
        "selectModel": "اختر نموذجاً...",
        "effectiveFrom": "يسري من",
        "effectiveUntil": "يسري حتى",
        "effectiveUntilHelp": "اختياري — اتركه فارغاً لفترة مفتوحة النهاية (التسعير النشط حالياً).",
        "unit": "الوحدة",
        "unitOptions": {
          "tokens": "لكل 1 مليون رمز (LLM / التضمين)",
          "minute": "لكل دقيقة (STT / الصوت)",
          "chars": "لكل 1 مليون حرف (TTS)"
        },
        "fieldLabels": {
          "usdPerMinute": "دولار لكل دقيقة",
          "outputPriceOptional": "سعر الإخراج (اختياري)",
          "inputPriceOptional": "سعر الإدخال (اختياري)",
          "usdPer1MChars": "دولار لكل 1 مليون حرف",
          "inputUsdPer1MTokens": "دولار الإدخال لكل 1 مليون رمز",
          "outputUsdPer1MTokens": "دولار الإخراج لكل 1 مليون رمز"
        },
        "validation": {
          "selectModel": "يرجى تحديد نموذج",
          "effectiveFromRequired": "تاريخ البدء مطلوب",
          "effectiveFromFormat": "يجب أن يكون تاريخ البدء بتنسيق YYYY-MM-DD",
          "effectiveUntilFormat": "يجب أن يكون تاريخ الانتهاء بتنسيق YYYY-MM-DD",
          "effectiveUntilAfterFrom": "يجب أن يكون تاريخ الانتهاء في أو بعد تاريخ البدء",
          "inputNonNegative": "يجب أن يكون دولار الإدخال رقماً غير سالب",
          "outputNonNegative": "يجب أن يكون دولار الإخراج رقماً غير سالب"
        },
        "cancel": "إلغاء",
        "save": "حفظ الفترة",
        "add": "إضافة الفترة",
        "saving": "جاري الحفظ..."
      }
    },
    "form": {
      "addTitle": "إضافة نموذج",
      "editTitle": "تعديل النموذج",
      "loadingQuota": "جاري تحميل الحصة...",
      "modelType": "نوع النموذج",
      "cannotChangeTypeAfterCreation": "لا يمكن التغيير بعد الإنشاء ({{type}})",
      "provider": "المزود",
      "providerTooltip": "حدد مزود الذكاء الاصطناعي. يتم عرض {{count}} مزود متوافق مع نوع النموذج المحدد.",
      "showingEmbeddingProviders": "عرض {{count}} من المزودين الذين يدعمون التضمين",
      "showingTypeProviders": "عرض {{count}} من مزودي {{type}}",
      "providerLockedTooltip": "لا يمكن تغيير المزود بعد الإنشاء.",
      "selectModel": "تحديد النموذج",
      "optionalTemplate": "(قالب اختياري)",
      "discoverFallbackTooltip": "يفضل استخدام الاكتشاف أعلاه لنقاط نهاية مساحة العمل المباشرة؛ القوالب هي خيار احتياطي.",
      "availableModelsTooltip": "اختر من نماذج {{provider}} {{type}} المتاحة ({{count}} متاح)",
      "selectAModel": "اختر نموذجاً",
      "selectATypeModel": "اختر نموذج {{type}}",
      "discovered": "تم اكتشافه",
      "baseUrl": "عنوان URL الأساسي",
      "baseUrlTooltip": "مطلوب للمزودين المحليين مثل Ollama أو LM Studio. اتركه فارغاً لمزودي السحابة.",
      "apiKeyRef": "مرجع مفتاح API",
      "apiKeyRefTooltip": "اسم متغير البيئة الذي يحتوي على مفتاح API للمزود (تم تكوينه في نشر الخلفية).",
      "displayName": "الاسم المعروض",
      "displayNameModelIdSetTooltip": "سيتم تعيين معرف النموذج من النموذج المحدد أعلاه.",
      "displayNameAutoGeneratedTooltip": "سيتم إنشاء معرف النموذج تلقائياً من الاسم المعروض إذا لم يتم تحديد نموذج.",
      "fullModelNamePreview": "معاينة اسم النموذج الكامل:",
      "displayNamePlaceholder": "مثال: Chat Completion",
      "apiVersion": "إصدار API",
      "apiVersionTooltip": "إصدار API المطلوب بواسطة البوابة",
      "paramProfile": "ملف تعريف المعلمات",
      "defaultParams": "المعلمات الافتراضية (JSON)",
      "defaultParamsTooltip": "كائن JSON اختياري يحتوي على معلمات افتراضية يتم إرسالها إلى النموذج مع كل طلب (مثل temperature و max_tokens).",
      "testSuccess": "✓ نجح اختبار الاتصال",
      "testFailed": "✗ فشل اختبار الاتصال",
      "modelResponse": "استجابة النموذج:",
      "testing": "جاري الاختبار...",
      "testConnection": "اختبار الاتصال",
      "testConnectionTitle": "اختبار الاتصال قبل الحفظ",
      "addModel": "إضافة نموذج",
      "adding": "جاري الإضافة...",
      "saving": "جاري الحفظ...",
      "quotaExceeded": "تم تجاوز حصة النماذج",
      "noChangesToSave": "لا توجد تغييرات للحفظ",
      "selectProvider": "اختر مزوداً"
    },
    "tags": {
      "llm": "نص",
      "image": "صورة",
      "embedding": "تضمين",
      "audio": "صوت",
      "video": "فيديو",
      "reranker": "إعادة ترتيب",
      "tts": "تحويل النص إلى كلام",
      "stt": "تحويل الكلام إلى نص"
    },
    "tagDescriptions": {
      "llm": "تولد النماذج النصية استجابات لغوية لمهام الدردشة والإكمال",
      "image": "تولد نماذج الصور أو تعدل أو تحلل المحتوى المرئي",
      "embedding": "تحول نماذج التضمين النصوص إلى متجهات للبحث الدلالي والمطابقة",
      "audio": "تعالج النماذج الصوتية وتولد الصوت والموسيقى",
      "video": "تولد نماذج الفيديو وتعدل محتوى الفيديو",
      "reranker": "تسجل نماذج إعادة الترتيب المستندات وترتبها حسب الصلة بالاستعلام",
      "tts": "تولد النماذج الصوتية كلاماً منطوقاً من النص — ليست للدردشة أو إكمال النص",
      "stt": "تحول نماذج النسخ الصوت إلى نص — ليست للدردشة أو إكمال النص"
    },
    "emptyState": {
      "permissionDenied": "ليس لديك إذن لعرض النماذج. اتصل بالمسؤول للحصول على إذن الوصول.",
      "noResultsSearch": "لم يتم العثور على نماذج تطابق بحثك.",
      "default": "لم يتم العثور على نماذج. قم بإنشاء أول نموذج للبدء."
    }
  },
  "chat": {
    "title": "الدردشة",
    "placeholder": "اكتب رسالتك...",
    "send": "إرسال",
    "modelNotSelected": "لم يتم اختيار نموذج",
    "modelNotFound": "النموذج غير موجود",
    "failedToLoad": "فشل تحميل النموذج",
    "failedToSend": "فشل إرسال الرسالة",
    "ollamaNotRunning": "لا يمكن الاتصال بـ Ollama. تأكد من تشغيل Ollama: ollama serve",
    "modelNotFoundOllama": "النموذج غير موجود أو Ollama لا يعمل. يرجى التحقق من تثبيت Ollama.",
    "modelArena": {
      "title": "ساحة النماذج",
      "vs": "مقابل",
      "selectModel": "اختر نموذجاً",
      "startConversation": "ابدأ محادثة",
      "processing": "جارٍ المعالجة...",
      "recording": "جارٍ التسجيل...",
      "record": "تسجيل",
      "stop": "إيقاف",
      "or": "أو",
      "uploadAudio": "رفع الصوت",
      "query": "الاستعلام",
      "documents": "المستندات (واحد في كل سطر، 2 على الأقل)",
      "compare": "مقارنة",
      "enterInput": "أدخل المدخلات...",
      "noImageOrText": "لم يتم إرجاع صورة أو نص",
      "noVideoReturned": "لم يتم إرجاع فيديو",
      "copied": "تم النسخ",
      "copy": "نسخ",
      "copyResponse": "نسخ الرد",
      "startRecording": "بدء التسجيل",
      "stopRecording": "إيقاف التسجيل",
      "cannotChangeModel": "لا يمكن تغيير النموذج بعد بدء المحادثة",
      "cannotChangeType": "لا يمكن تغيير نوع النموذج بعد بدء المحادثة",
      "noModelsAvailable": "لا توجد نماذج متاحة",
      "addAnotherModel": "أضف نموذجاً آخر للمقارنة",
      "onlyOneModelAvailable": "نموذج واحد فقط متاح. تتطلب ساحة النماذج نموذجين مختلفين للمقارنة.",
      "sameModelSelected": "لقد اخترت نفس النموذج في كلا الجانبين. يرجى اختيار نموذج مختلف للبدء.",
      "startBeforeRating": "ابدأ محادثة قبل تقييم هذه الجلسة",
      "restoreView": "استعادة العرض المقسّم",
      "expandLeft": "توسيع اللوحة اليسرى",
      "expandRight": "توسيع اللوحة اليمنى",
      "selectModel2": "اختر نموذجاً...",
      "searchModels": "ابحث عن النماذج...",
      "syncedToBoth": "{{placeholder}} (متزامن مع الجانبين)",
      "placeholders": {
        "searchQuery": "أدخل استعلام البحث...",
        "rerankDocs": "نص المستند 1...\nنص المستند 2...\nنص المستند 3...",
        "tts": "أدخل النص للتوليف...",
        "image": "صف الصورة المراد إنشاؤها...",
        "video": "صف الفيديو المراد إنشاؤه... (قد يستغرق بضع دقائق)"
      },
      "types": {
        "llm": "نص",
        "image": "صورة",
        "audio": "صوت",
        "video": "فيديو",
        "reranker": "إعادة ترتيب",
        "tts": "كلام",
        "stt": "نسخ"
      },
      "typeDescriptions": {
        "llm": "نماذج النص تولّد استجابات لغوية للدردشة والإكمال",
        "image": "نماذج الصور تولّد أو تعدّل الصور من مطالبات نصية",
        "audio": "نماذج الصوت تعالج أو تولّد محتوى صوتي غير كلامي",
        "video": "نماذج الفيديو تولّد أو تحلل محتوى الفيديو",
        "reranker": "نماذج إعادة الترتيب تعيد ترتيب المستندات لتحسين صلة RAG",
        "tts": "نماذج الكلام تولّد صوتاً من النص",
        "stt": "نماذج النسخ تحوّل الصوت إلى نص"
      }
    },
    "newChat": "محادثة جديدة",
    "newSession": "محادثة جديدة",
    "endOfSessions": "نهاية الجلسات",
    "noSessionsYet": "لا توجد جلسات ساحة نماذج بعد",
    "startNewConversation": "ابدأ محادثة جديدة",
    "startConversation": "ابدأ محادثة",
    "startConversationWithModel": "ابدأ محادثة مع هذا النموذج",
    "configuration": "الإعدادات",
    "collapseConfig": "طي",
    "expandConfig": "الإعدادات",
    "backToModels": "العودة إلى النماذج",
    "refreshSessions": "تحديث الجلسات",
    "activeSessionEmpty": "الجلسة النشطة فارغة",
    "newModelArena": "ساحة نماذج جديدة",
    "loadingDot": "جارٍ التحميل...",
    "loadingMore": "تحميل المزيد...",
    "sessionRenamed": "تمت إعادة تسمية الجلسة",
    "failedToRename": "فشلت إعادة تسمية الجلسة",
    "sessionDeleted": "تم حذف الجلسة بنجاح",
    "failedToDelete": "فشل حذف الجلسة",
    "deleteSession": "حذف جلسة ساحة النماذج",
    "deleteSessionConfirm": "هل أنت متأكد من أنك تريد حذف جلسة ساحة النماذج هذه؟ سيؤدي ذلك أيضًا إلى حذف جلسات النموذجين الفرديين. لا يمكن التراجع عن هذا الإجراء.",
    "rename": "إعادة التسمية",
    "delete": "حذف",
    "save": "حفظ",
    "cancel": "إلغاء",
    "selectPrompt": "اختر نصًا توجيهيًا...",
    "searchPrompts": "ابحث عن النصوص التوجيهية...",
    "selectSkills": "اختر المهارات...",
    "searchSkills": "ابحث عن المهارات...",
    "version": "الإصدار",
    "rateSession": "تقييم الجلسة",
    "rateThisSession": "تقييم هذه الجلسة",
    "updateFeedback": "تحديث الملاحظات",
    "helpful": "مفيد",
    "notHelpful": "غير مفيد",
    "rated": "مقيّم {{value}}/10",
    "feedbackProvided": "تم تقديم الملاحظات",
    "startBeforeRating": "ابدأ محادثة قبل تقييم هذه الجلسة",
    "selectHelpful": "الرجاء تحديد مفيد أو غير مفيد قبل الإرسال",
    "failedToSaveComparisonFeedback": "فشل حفظ ملاحظات المقارنة",
    "feedbackSubmitted": "تم إرسال الملاحظات بنجاح",
    "failedToSubmitSessionFeedback": "فشل إرسال ملاحظات الجلسة",
    "promptTemplate": "قالب الموجه",
    "skills": "المهارات",
    "model": "النموذج",
    "sttModel": "تحويل الكلام إلى نص (المرفقات)",
    "knowledge": "المعرفة",
    "tools": "الأدوات",
    "settings": "الإعدادات"
  },
  "admin": {
    "title": "الإدارة",
    "users": "المستخدمون",
    "roles": "الأدوار",
    "pending": "قيد الانتظار",
    "active": "نشط"
  },
  "solutions": {
    "title": "الحلول",
    "subtitle": "اكتشف وشارك المستودعات والتعليمات البرمجية مع روابط سريعة لـ QA و UAT والإنتاج.",
    "addSolution": "إضافة حل",
    "dialogTitle": "إضافة حل",
    "editDialogTitle": "تعديل حل",
    "submit": "إضافة إلى الكتالوج",
    "submitEdit": "حفظ التغييرات",
    "empty": "لا توجد حلول بعد. أضف الحل الأول لمساعدة فريقك في العثور على البيئات بشكل أسرع.",
    "openGithub": "فتح مستودع GitHub",
    "designPrototype": "نموذج التصميم",
    "openDesignPrototype": "فتح نموذج التصميم (Figma، إلخ.)",
    "editSolution": "تعديل الحل",
    "deleteSolution": "حذف الحل",
    "deleteSelected": "حذف المحدد",
    "openEditor": "فتح المحرر",
    "sourceGithub": "رابط GitHub",
    "sourceCode": "ملفات الكود",
    "codeHint": "بعد الإنشاء، سيتم نقلك إلى محرر الكود لإضافة وتعديل الملفات.",
    "shortcutHint": "تلميح: Ctrl/⌘ + Enter يرسل النموذج.",
    "toast": {
      "created": "تم إضافة الحل إلى الكتالوج.",
      "updated": "تم تحديث الحل.",
      "deleted": "تم حذف الحل.",
      "bulkDeleted": "تم حذف {{deleted}} حل. تم تخطي {{skipped}}.",
      "conflict": "تم تغيير هذا الحل في مكان آخر. أعد تحميل الصفحة لتحميل أحدث إصدار."
    },
    "fields": {
      "name": "اسم الحل",
      "description": "الوصف",
      "githubUrl": "رابط مستودع GitHub",
      "designPrototypeUrl": "رابط نموذج التصميم",
      "sourceType": "نوع المصدر",
      "tags": "الوسوم",
      "owner": "المالك"
    },
    "placeholders": {
      "description": "ملخص قصير (2-3 أسطر)",
      "designPrototypeUrl": "https://www.figma.com/design/..."
    },
    "validation": {
      "nameRequired": "الاسم مطلوب.",
      "nameTooLong": "يجب ألا يتجاوز الاسم {{max}} حرفًا.",
      "descriptionTooLong": "يجب ألا يتجاوز الوصف {{max}} حرفًا.",
      "githubRequired": "رابط GitHub مطلوب.",
      "githubInvalid": "أدخل رابط مستودع GitHub صالح (https).",
      "urlInvalid": "يجب أن يكون رابط http(s) صالح."
    },
    "confirmDeleteTitle": "حذف الحل",
    "confirmDeleteMessage": "هل أنت متأكد أنك تريد حذف \"{{name}}\"؟ سيؤدي هذا إلى إزالة الحل وجميع ملفاته بشكل دائم.",
    "confirmBulkDeleteTitle": "حذف الحلول المحددة",
    "confirmBulkDeleteMessage": "هل أنت متأكد أنك تريد حذف {{count}} حل؟ سيؤدي هذا إلى إزالة الحلول وجميع ملفاتها بشكل دائم.",
    "editor": {
      "explorer": "المستكشف",
      "newFile": "ملف جديد",
      "noFiles": "لا توجد ملفات بعد.",
      "addFirstFile": "إضافة ملف",
      "selectFile": "اختر ملفًا من المستكشف لبدء التعديل.",
      "noFileSelected": "لم يتم اختيار ملف",
      "saveChanges": "حفظ التغييرات",
      "saved": "تم الحفظ",
      "unsavedChanges": "تغييرات غير محفوظة",
      "deleteFile": "حذف الملف",
      "confirmDelete": "حذف \"{{file}}\"؟ لا يمكن التراجع عن هذا.",
      "delete": "حذف",
      "fileExists": "ملف بهذا المسار موجود بالفعل.",
      "notFound": "الحل غير موجود.",
      "backToList": "العودة إلى الحلول",
      "settings": "الإعدادات",
      "metadataTitle": "إعدادات الحل",
      "metadataSaved": "تم حفظ الإعدادات.",
      "switchToDark": "الوضع الداكن",
      "switchToLight": "الوضع الفاتح",
      "lineCol": "سطر {{line}}، عمود {{col}}",
      "newFolder": "مجلد جديد",
      "folderNamePlaceholder": "اسم-المجلد",
      "folderExists": "مجلد بهذا الاسم موجود بالفعل في هذا المستوى.",
      "deleteFolder": "حذف المجلد",
      "confirmDeleteFolder": "حذف المجلد \"{{folder}}\" وجميع محتوياته؟ لا يمكن التراجع عن هذا.",
      "newFileInFolder": "ملف جديد في المجلد",
      "newSubfolder": "مجلد فرعي جديد",
      "uploadZip": "تحميل ملف Zip",
      "uploadZipTitle": "تحميل ملف .zip لاستيراد الملفات والمجلدات",
      "zipUploading": "جاري استخراج الملف...",
      "zipSuccess": "تم استيراد {{count}} ملفات من أرشيف zip.",
      "zipSuccessWithSkips": "تم استيراد {{count}} ملفات (تم تخطي {{skipped}}).",
      "zipError": "فشل تحميل ملف zip.",
      "zipDragHint": "أفلت ملف .zip هنا للاستيراد",
      "binaryFileNotEditable": "ملف ثنائي — غير قابل للتعديل في محرر الكود.",
      "downloadFile": "تحميل الملف",
      "renameFile": "إعادة تسمية",
      "renamePlaceholder": "اسم-جديد",
      "moveFile": "نقل / إعادة تسمية",
      "movePlaceholder": "new/path/to/file.ts"
    }
  },
  "tenant": {
    "switch": "تبديل المستأجر",
    "subdomain": "النطاق الفرعي:"
  },
  "ontology": {
    "canvasTitle": "لوحة الأنطولوجيا",
    "canvasSubtitle": "تتبع البيانات من المصدر إلى تحليلات تعلم الآلة",
    "dataModelsTitle": "نماذج البيانات",
    "dataModelsSubtitle": "كتالوج نماذج بيانات المؤسسة عبر الصناعات",
    "kpiLibraryTitle": "مكتبة مؤشرات الأداء",
    "kpiLibrarySubtitle": "تعاريف مؤشرات الأداء للأعمال وكتالوج المقاييس",
    "migrationsStudioTitle": "استوديو الهجرة",
    "migrationsStudioSubtitle": "تنسيق الاكتشاف من خلال التحول مع وكلاء هجرة الذكاء الاصطناعي، والتحقق، والنسب في مساحة عمل واحدة.",
    "pipelinesTitle": "استوديو البيانات",
    "pipelinesSubtitle": "تسليم الهجرة، وسير عمل المنسق، والمعالجة المرتبطة بمؤشرات الأداء في كتالوج واحد",
    "observabilityTitle": "قابلية مراقبة البيانات",
    "observabilitySubtitle": "مراقبة صحة خطوط الأنابيب وتتبع حداثة البيانات",
    "nodesSelected": "تم اختيار {{count}} عقد",
    "overview": "نظرة عامة",
    "lineage": "النسب",
    "buildTimeline": "الجدول الزمني للبناء",
    "dataHealth": "صحة البيانات",
    "allFamilies": "جميع العائلات",
    "allTypes": "جميع الأنواع",
    "mustHave": "يجب أن يتوفر",
    "goodToHave": "من الجيد توفره",
    "totalKpis": "إجمالي مؤشرات الأداء",
    "families": "العائلات",
    "export": "تصدير CSV",
    "healthy": "سليم",
    "degraded": "متدهور",
    "critical": "حرج",
    "running": "جاري التشغيل",
    "completed": "مكتمل",
    "failed": "فاشل",
    "scheduled": "مجدول",
    "published": "منشور",
    "draft": "مسودة",
    "impactAnalysis": "تحليل التأثير",
    "impactActive": "التأثير نشط",
    "viewDataSample": "عرض عينة البيانات",
    "resourceOverview": "نظرة عامة على الموارد",
    "pipelineDrawerCode": "الكود",
    "pipelineDrawerRuns": "عمليات التشغيل",
    "pipelineDrawerMetadata": "البيانات الوصفية",
    "pipelineDrawerNoCode": "لم يتم تسجيل كود تحويل لهذه العقدة بعد. اربط مستودعًا أو انشر من منشئ خطوط الأنابيب.",
    "pipelineDrawerNoPipeline": "لم يتم العثور على خط أنابيب بيانات مرتبط لهذه العقدة.",
    "pipelineDrawerNoRuns": "لا يوجد سجل تشغيل متاح لخط الأنابيب المرتبط.",
    "pipelineDrawerNoMetadata": "لا توجد معلمات إضافية بخلاف نص التحويل.",
    "pipelineLinkedJob": "خط أنابيب مرتبط",
    "pipelineNodeParams": "المعلمات",
    "nodeInfoSection": "معلومات العقدة",
    "exportCard": "تصدير…",
    "exportCardTitleDataModel": "تصدير نموذج البيانات",
    "exportCardTitleOntology": "تصدير الأنطولوجيا",
    "exportCardTitleKpi": "تصدير مؤشرات الأداء",
    "exportCardSubtitle": "اختر تنسيق الملف ثم قم بالتنزيل.",
    "exportCardDownload": "تنزيل",
    "exportCardCancel": "إلغاء",
    "exportFormatPortableJson": "JSON قابل للنقل (ذهاب وإياب عبر إنشاء نموذج بيانات)",
    "exportFormatPortableYaml": "YAML قابل للنقل (نفس محتوى JSON)",
    "exportFormatDdl": "SQL DDL",
    "exportFormatDrawio": "Draw.io XML",
    "exportFormatTurtle": "Turtle (.ttl)",
    "exportFormatRdfXml": "RDF/XML",
    "exportFormatJsonLd": "JSON-LD",
    "version": "الإصدار",
    "versions": "الإصدارات",
    "latest": "الأحدث",
    "compareVersions": "مقارنة",
    "neo4jGraph": "الرسم البياني للشبكة",
    "diffAdded": "أُضيف",
    "diffRemoved": "أُزيل",
    "diffUnchanged": "دون تغيير",
    "diffNoChanges": "لا توجد تغييرات",
    "diffSelectTwo": "حدد إصدارين مختلفين للمقارنة.",
    "exportFormatCsv": "CSV (للاستيراد في نسخة أخرى)",
    "exportFormatKpiJson": "لقطة JSON (نسخ احتياطي / أدوات)",
    "exportKpiJsonNote": "يطابق ملف CSV استيراد CSV الخاص بمكتبة مؤشرات الأداء. أما JSON فهو للنسخ الاحتياطي أو الأدوات الخارجية؛ ولا يوجد استيراد JSON حتى الآن.",
    "unknownHealth": "غير معروف",
    "sourceChip": "المصدر",
    "dataExplorer": "مستكشف البيانات",
    "openInDataExplorerAriaLabel": "فتح في مستكشف البيانات",
    "pipelineRunHistoryUnavailable": "سجل تشغيل خط الأنابيب غير متاح بعد من الخلفية.",
    "viewSample": "عرض العينة",
    "metadataSectionTitle": "البيانات الوصفية",
    "kvOwner": "المالك",
    "kvDescription": "الوصف",
    "kvPipeline": "خط الأنابيب",
    "kvSchedule": "الجدولة",
    "kvUpdated": "تاريخ التحديث",
    "kvType": "النوع",
    "kvLastUpdated": "آخر تحديث",
    "category": {
      "data_source": "مصدر البيانات",
      "data_extract": "استخراج البيانات",
      "pipeline_builder_dataset": "مجموعة بيانات أداة بناء خط الأنابيب",
      "python_transform": "تحويل بايثون",
      "python_script_transform": "سكربت تحويل بايثون",
      "virtual_table": "جدول افتراضي",
      "fusion_sync": "مزامنة Fusion",
      "fusion_sheet": "ورقة Fusion",
      "kpi_node": "عقدة مؤشر أداء",
      "ml_model": "نموذج تعلم آلي"
    },
    "stage": {
      "source": "المصادر",
      "ingestion": "الاستيعاب",
      "transformation": "التحويل",
      "kpi": "طبقة مؤشرات الأداء",
      "ml_analytics": "التعلم الآلي والتحليلات"
    },
    "toolbar": {
      "tools": "الأدوات",
      "layout": "التخطيط",
      "undo": "تراجع",
      "redo": "إعادة",
      "clean": "تنظيف",
      "select": "تحديد",
      "expand": "توسيع",
      "color": "اللون",
      "find": "بحث",
      "remove": "إزالة",
      "align": "محاذاة",
      "flow": "التدفق"
    },
    "legend": {
      "categoryLegend": "مفتاح الفئات",
      "closeLegend": "إغلاق المفتاح"
    },
    "studio": {
      "loadingOntologies": "جارٍ تحميل الأنطولوجيات…",
      "loadingPrevOntologies": "جارٍ تحميل الأنطولوجيات السابقة…",
      "loadingMoreOntologies": "جارٍ تحميل المزيد من الأنطولوجيات…",
      "industryFilterLabel": "الصناعة",
      "allIndustries": "جميع الصناعات",
      "domainFilterLabel": "النطاق",
      "allDomains": "جميع النطاقات",
      "subdomainFilterLabel": "النطاق الفرعي",
      "allSubdomains": "جميع النطاقات الفرعية",
      "failedToDeleteOntology": "فشل حذف الأنطولوجيا",
      "ontologyImportedToast": "تم استيراد الأنطولوجيا \"{{name}}\"",
      "pageTitle": "استوديو الأنطولوجيا",
      "pageSubtitle": "تصفح أو استورد أو أنشئ أنطولوجيات OWL/TTL باستخدام الذكاء الاصطناعي من نموذج بيانات. تظهر الأنطولوجيات الناتجة عن أداة التنميط هنا تلقائيًا بعد اكتمال التنميط في استوديو الترحيل.",
      "evaluateButton": "تقييم",
      "createOntologyButton": "إنشاء أنطولوجيا",
      "ontologiesKpiLabel": "الأنطولوجيات",
      "yourOntologiesHeading": "أنطولوجياتك",
      "importTooltipBold": "استيراد",
      "importTooltipRest": "ملف OWL/TTL لتسجيل أنطولوجيا جديدة. يتم تسجيل الأنطولوجيات الناتجة عن سير عمل أداة التنميط هنا تلقائيًا.",
      "filtersTitle": "عوامل التصفية",
      "searchPlaceholder": "البحث في الأنطولوجيات…",
      "clearSearchAriaLabel": "مسح البحث",
      "noOntologiesMatch": "لا توجد أنطولوجيات مطابقة لبحثك. أنشئ أنطولوجيا عن طريق استيراد OWL/TTL أو البناء بالذكاء الاصطناعي من نموذج بيانات، أو شغّل أداة التنميط في استوديو الترحيل لتسجيل أنطولوجيا تلقائيًا.",
      "ontologyActionsAriaLabel": "إجراءات الأنطولوجيا لـ {{name}}",
      "renameMenuItem": "إعادة تسمية",
      "industryTagsMenuItem": "علامات الصناعة",
      "deleteMenuItem": "حذف",
      "owlFileBadge": "ملف OWL",
      "versionsCount": "{{count}} إصدارات",
      "classesLabel": "فئات",
      "individualsLabel": "أفراد",
      "removeFromCatalogTitle": "إزالة من الكتالوج",
      "removeFromCatalogMessage": "إزالة \"{{name}}\" من استوديو الأنطولوجيا؟ يتم حذف الأنطولوجيا حذفًا مرنًا (إزالتها من الكتالوج). قد تظهر الروابط المباشرة إلى عارض OWL كمفقودة حتى تقوم بالاستيراد مرة أخرى.",
      "couldNotExportOntology": "تعذّر تصدير الأنطولوجيا",
      "industryTagsUpdated": "تم تحديث علامات الصناعة",
      "couldNotUpdateIndustryTags": "تعذّر تحديث علامات الصناعة",
      "industryDialogTitle": "علامات الصناعة",
      "industryDialogSubtitle": "فلتر الكتالوج والشارات لـ {{name}}.",
      "unspecifiedOption": "غير محدد",
      "industryFieldLabel": "الصناعة",
      "saveButton": "حفظ",
      "savingButton": "جارٍ الحفظ…",
      "closeAriaLabel": "إغلاق",
      "renameDialogTitle": "إعادة تسمية أنطولوجيا OWL",
      "renameDialogSubtitle": "الاسم المعروض على البطاقات والقوائم (حتى {{maxLength}} حرفًا).",
      "nameFieldLabel": "الاسم",
      "nameRequiredError": "الاسم مطلوب",
      "nameMustContainLetterError": "يجب أن يحتوي الاسم على حرف أو رقم واحد على الأقل",
      "renameFailedError": "فشلت إعادة التسمية"
    },
    "justNow": "الآن",
    "hoursAgo": "قبل {{hours}} ساعة",
    "daysAgo": "قبل {{days}} يوم",
    "chooser": {
      "subtitle": "استورد ملف OWL/TTL موجودًا، أو أنشئ أنطولوجيا كثيفة بالذكاء الاصطناعي من نموذج بيانات مسجَّل وأسئلة الكفاءة.",
      "buildWithAiTitle": "بناء الأنطولوجيا بالذكاء الاصطناعي",
      "buildWithAiDesc": "اختر نموذج بيانات، راجع أسئلة الكفاءة، وقم بتوليف OWL",
      "uploadTitle": "رفع OWL/TTL",
      "uploadDesc": "رفع ملف أنطولوجيا موجود"
    },
    "import": {
      "title": "استيراد أنطولوجيا OWL/TTL",
      "subtitle": "قم برفع ملف Turtle ‏(.ttl) أو OWL أو RDF/XML أو JSON-LD لإنشاء أنطولوجيا.",
      "industryHint": "يُخزَّن على بطاقة الكتالوج ويُستخدم للتصفية إلى جانب نماذج البيانات ومؤشرات الأداء.",
      "nameLabel": "اسم الأنطولوجيا (اختياري)",
      "namePlaceholder": "استبدال العنوان المكتشف تلقائيًا من الملف",
      "nameHint": "يظهر على بطاقة الكتالوج. اتركه فارغًا لاستخدام العنوان من ملف OWL.",
      "ontologyNameFieldLabel": "اسم الأنطولوجيا",
      "dropPrompt": "أفلت ملف TTL/OWL هنا، أو انقر للتصفح",
      "filePreviewHeader": "معاينة الملف",
      "importingButton": "جارٍ الاستيراد...",
      "importButton": "استيراد الأنطولوجيا",
      "importFailed": "فشل الاستيراد"
    },
    "builder": {
      "backToStudioAriaLabel": "العودة إلى استوديو الأنطولوجيا",
      "pageTitle": "بناء الأنطولوجيا بالذكاء الاصطناعي",
      "pageSubtitle": "سمِّ الأنطولوجيا، اختر نموذج بيانات، راجع أسئلة الكفاءة، ثم قم بتوليف OWL وتسجيله في الكتالوج. آمن عند التحديث — يمكنك فتح الجلسة مرة أخرى في أي وقت.",
      "loadFailed": "فشل تحميل نماذج البيانات",
      "resumeFailed": "تعذّر استئناف جلسة الأنطولوجيا",
      "sessionDiscarded": "تم تجاهل الجلسة",
      "discardFailed": "فشل تجاهل الجلسة",
      "nameSpecialCharsError": "لا يمكن أن يتكون اسم الأنطولوجيا من رموز خاصة فقط",
      "domainSpecialCharsError": "لا يمكن أن يتكون النطاق من رموز خاصة فقط",
      "subdomainSpecialCharsError": "لا يمكن أن يتكون النطاق الفرعي من رموز خاصة فقط",
      "enterNamePrompt": "أدخل اسم الأنطولوجيا للمتابعة",
      "enterDomainPrompt": "أدخل نطاقًا للمتابعة",
      "selectDataModelPrompt": "حدد نموذج بيانات للمتابعة",
      "selectOntologyLlmPrompt": "حدد نموذج LLM للأنطولوجيا للمتابعة",
      "startFailed": "فشل بدء أداة بناء الأنطولوجيا",
      "updateCqFailed": "فشل تحديث أسئلة الكفاءة",
      "sendMessageFailed": "فشل إرسال الرسالة",
      "synthesisFailed": "فشل التوليف",
      "registeredToast": "تم تسجيل {{name}}",
      "ontologyFallback": "الأنطولوجيا",
      "registrationFailed": "فشل التسجيل",
      "dataModelFilterLabel": "نموذج البيانات",
      "selectDataModelPlaceholder": "تحديد نموذج بيانات…",
      "noDataModelsRegistered": "لا توجد نماذج بيانات مسجَّلة",
      "modeFilterLabel": "الوضع",
      "modeGuided": "موجّه — مراجعة كل سؤال كفاءة",
      "modeExpress": "سريع — مسار قبول أسرع",
      "ontologyLlmFilterLabel": "نموذج LLM للأنطولوجيا",
      "selectOntologyLlmPlaceholder": "تحديد نموذج LLM للأنطولوجيا…",
      "noChatModelsRegistered": "لا توجد نماذج محادثة مسجَّلة",
      "enrichmentLlmFilterLabel": "نموذج LLM للإثراء",
      "selectEnrichmentLlmPlaceholder": "تحديد نموذج LLM للإثراء (اختياري)…",
      "stepSourceTitle": "المصدر",
      "stepSourceDesc": "سمِّ الأنطولوجيا واختر نموذج البيانات الذي يحدد مفاهيمك",
      "stepQuestionsTitle": "الأسئلة",
      "stepQuestionsDesc": "اقبل أو ارفض أو نقّح أسئلة الكفاءة المستندة إلى ذلك النموذج",
      "stepOntologyTitle": "الأنطولوجيا",
      "stepOntologyDesc": "توليف فئات وخصائص وبديهيات OWL المتحقق منها",
      "stepRegisterTitle": "التسجيل",
      "stepRegisterDesc": "النشر في كتالوج الأنطولوجيا للاستوديو والوكلاء",
      "sourceFormSubtitle": "سمِّ الأنطولوجيا واختر نموذج البيانات لتأسيس مفاهيمها.",
      "ontologyNameLabel": "اسم الأنطولوجيا",
      "ontologyNamePlaceholder": "مثال: أنطولوجيا مجال البراءات",
      "domainLabel": "النطاق",
      "domainPlaceholder": "مثال: الرعاية الصحية، الملكية الفكرية",
      "subdomainLabel": "النطاق الفرعي",
      "subdomainPlaceholder": "مثال: المطالبات، ملاحقة البراءات",
      "loadingModels": "جارٍ تحميل النماذج…",
      "loadingChatModels": "جارٍ تحميل نماذج المحادثة…",
      "enrichToggleTitle": "إثراء البيانات الوصفية قبل توليف OWL",
      "enrichToggleDesc": "استخدام نموذج LLM لتوسيع التعريفات والتسميات قبل توليد الفئات.",
      "startBuildingButton": "بدء البناء",
      "backToBuilderAriaLabel": "العودة إلى بناء الأنطولوجيا بالذكاء الاصطناعي",
      "ontologyBuilderFallback": "أداة بناء الأنطولوجيا",
      "dataModelFallback": "نموذج البيانات",
      "chatEmptyLine1": "تبدأ مقابلة الأنطولوجيا هنا.",
      "chatEmptyLine2": "راجع أسئلة الكفاءة المقترحة، ثم اقبل ما يجب على العمل الإجابة عنه.",
      "roleYou": "أنت",
      "roleAssistant": "المساعد",
      "workingStatus": "جارٍ العمل…",
      "startingSessionStatus": "جارٍ بدء الجلسة…",
      "synthesizingStatus": "جارٍ التوليف",
      "chatInputPlaceholder": "تحدث بحرية — صف أسئلة العمل، أو: قبول الكل · التالي · متابعة…",
      "expandSidePanel": "توسيع اللوحة الجانبية",
      "collapseSidePanel": "طي اللوحة الجانبية",
      "reflectionHeading": "التأمل والتقييم",
      "scoreFallback": "النتيجة {{score}}",
      "addMoreQuestionsButton": "إضافة المزيد من أسئلة الأنطولوجيا",
      "registerLead": "سمِّ الأنطولوجيا وانشرها في الكتالوج. عاين الرسم البياني المسودة أدناه، ثم أكّد فحص الملف الشخصي قبل التسجيل.",
      "graphReviewNudge": "نصيحة: افتح OntoGraf أو Neo4j أعلاه لمراجعة البنية قبل التسجيل.",
      "industryLabel": "الصناعة",
      "registerToCatalogButton": "تسجيل في الكتالوج",
      "resumingSession": "جارٍ استئناف جلسة الأنطولوجيا…"
    },
    "viewer": {
      "loadSummaryFailed": "فشل تحميل الملخص",
      "generatingSummary": "جارٍ إنشاء ملخص الأنطولوجيا…",
      "retry": "إعادة المحاولة",
      "regenerateSummaryTitle": "إعادة إنشاء الملخص",
      "regenerateButton": "إعادة الإنشاء",
      "classesLabel": "الفئات",
      "objectPropsLabel": "خصائص الكائن",
      "dataPropsLabel": "خصائص البيانات",
      "individualsLabel": "الأفراد",
      "aboutThisOntology": "حول هذه الأنطولوجيا",
      "cachedSummary": "ملخص مخزَّن مؤقتًا",
      "overview": "نظرة عامة",
      "noSummaryYet": "لا يوجد ملخص متاح بعد. استخدم إعادة الإنشاء لإنشاء واحد.",
      "propertiesLabel": "الخصائص",
      "moreCount": "+{{count}} أخرى",
      "showLess": "عرض أقل",
      "tab": {
        "about": "حول الأنطولوجيا",
        "ontograf": "OntoGraf",
        "neo4j-graph": "الرسم البياني للشبكة",
        "object-properties": "خصائص الكائن",
        "data-properties": "خصائص البيانات",
        "annotation-properties": "التعليقات التوضيحية",
        "individuals": "الأفراد",
        "compare": "مقارنة"
      },
      "group": {
        "about": "حول",
        "explore": "استكشاف",
        "compare": "مقارنة"
      },
      "ontologyNotFound": "الأنطولوجيا غير موجودة",
      "couldNotLoadOntology": "تعذّر تحميل الأنطولوجيا",
      "backButton": "رجوع",
      "noGraphData": "لا توجد بيانات رسم بياني متاحة",
      "compareNeedsTwoVersions": "تتطلب مقارنة الإصدارات وجود إصدارين على الأقل في هذه العائلة.",
      "backToOntologies": "الأنطولوجيات",
      "builtWithAi": "أُنشئ بالذكاء الاصطناعي",
      "ontologyViewsAriaLabel": "طرق عرض الأنطولوجيا",
      "viewGroupsAriaLabel": "مجموعات العرض",
      "exploreViewsAriaLabel": "طرق عرض الاستكشاف",
      "faqTitle": "الأسئلة الشائعة",
      "configureFaqAriaLabel": "تكوين الأسئلة الشائعة",
      "exportTurtleTitle": "تصدير بصيغة Turtle",
      "classHierarchyAriaLabel": "تسلسل الفئات",
      "expandClassHierarchy": "توسيع تسلسل الفئات",
      "showClassHierarchy": "إظهار تسلسل الفئات",
      "collapseClassHierarchy": "طي تسلسل الفئات",
      "collapseHierarchyPanel": "طي لوحة التسلسل",
      "askOntologyTitle": "اسأل الأنطولوجيا",
      "askOntologySubtitle": "استعلم عن الفئات والخصائص والعلاقات.",
      "askOntologyGreeting": "اسأل عن الفئات أو التسلسلات الهرمية أو العلاقات في هذه الأنطولوجيا.",
      "loading": "جارٍ التحميل...",
      "name": "الاسم",
      "domain": "النطاق المصدر",
      "range": "النطاق الهدف",
      "characteristics": "الخصائص",
      "kind": {
        "object": "الكائن",
        "data": "البيانات",
        "annotation": "التعليق التوضيحي"
      },
      "noPropertiesForClass": "لا توجد خصائص {{kind}} لهذا الصنف.",
      "noPropertiesFound": "لم يتم العثور على خصائص {{kind}}.",
      "iriLabel": "IRI",
      "unspecified": "(غير محدد)",
      "annotationsLabel": "التعليقات التوضيحية",
      "typesLabel": "الأنواع",
      "viewLabel": "العرض",
      "groupedByClass": "مجمّعة حسب الصنف",
      "flatList": "قائمة مسطحة",
      "loadingIndividuals": "جارٍ تحميل الأفراد…",
      "noIndividualsForClass": "لا يوجد أفراد لهذا الصنف.",
      "noIndividualsFound": "لم يتم العثور على أفراد.",
      "dataPropertiesLabel": "خصائص البيانات",
      "objectPropertiesLabel": "خصائص الكائن"
    },
    "dataModels": {
      "cancel": "إلغاء",
      "close": "إغلاق",
      "description": "الوصف",
      "industryVertical": "القطاع الصناعي",
      "modelName": "اسم النموذج",
      "nameInvalidChars": "يمكن أن يحتوي اسم النموذج على أحرف وأرقام ومسافات وشرطات وشرطات سفلية فقط",
      "nameNeedsAlphanumeric": "يجب أن يحتوي اسم النموذج على أحرف أو أرقام",
      "nameRequired": "اسم النموذج مطلوب",
      "save": "حفظ",
      "saving": "جارٍ الحفظ…",
      "selectIndustry": "اختر القطاع",
      "status": {
        "draft": "مسودة",
        "published": "منشور"
      },
      "createDialog": {
        "addColumn": "إضافة عمود",
        "addEntity": "إضافة كيان",
        "back": "رجوع",
        "columnNamePlaceholder": "اسم_العمود",
        "columns": "الأعمدة",
        "continue": "متابعة",
        "createFailed": "تعذر إنشاء نموذج البيانات",
        "createModel": "إنشاء النموذج",
        "createdSummary": "تم إنشاء {{name}} كمسودة تحتوي على {{count}} كيان.",
        "createdSummaryWithColumns": "تم إنشاء {{name}} كمسودة تحتوي على {{count}} كيان و{{columns}} عمود.",
        "createdTitle": "تم إنشاء نموذج البيانات",
        "creating": "جارٍ الإنشاء...",
        "descriptionPlaceholder": "صف الغرض من نموذج البيانات هذا ونطاقه...",
        "dimension": "بُعد",
        "done": "تم",
        "duplicateEntityName": "تمت إضافة اسم الكيان نفسه مسبقًا",
        "enterModelName": "أدخل اسم النموذج",
        "entityNameInvalidChars": "يمكن أن يحتوي اسم الكيان على أحرف وأرقام وشرطات سفلية فقط",
        "entityNameNeedsAlphanumeric": "يجب أن يحتوي اسم الكيان على أحرف أو أرقام",
        "entityNamePlaceholder": "اسم الكيان (مثال: Customer)",
        "fillOutField": "يرجى تعبئة هذا الحقل.",
        "foreignKey": "مفتاح أجنبي",
        "missingIndustry": "القطاع غير محدد",
        "missingModelName": "اسم النموذج غير محدد",
        "modelNamePlaceholder": "مثال: نموذج بيانات البيع بالتجزئة الشائع",
        "modelNameRequired": "اسم النموذج *",
        "modelSummary": "ملخص النموذج",
        "needMoreEntities": "أضف كيانين على الأقل لتعريف العلاقات.",
        "noColumnsYet": "لا توجد أعمدة بعد. اختياري عند الإنشاء — يمكنك إضافتها لاحقًا في عرض تفاصيل النموذج.",
        "noEntitiesYet": "لم تتم إضافة أي كيانات بعد. ابدأ الكتابة أعلاه لإضافة جداول.",
        "nullable": "قابل للقيمة الفارغة",
        "primaryKey": "مفتاح أساسي",
        "removeColumn": "إزالة العمود",
        "removeEntity": "إزالة {{name}}",
        "selectIndustryVertical": "اختر قطاعًا صناعيًا",
        "step1Desc": "الاسم والقطاع والوصف",
        "step1Label": "معلومات أساسية",
        "step2Desc": "إضافة الجداول والأعمدة",
        "step2Intro": "أضف الكيانات (الجداول)، ثم عرّف أعمدة كل منها.",
        "step2Label": "تعريف الكيانات",
        "step3Desc": "تعريف المفاتيح الأجنبية والروابط",
        "step3Intro": "عرّف العلاقات بين الكيانات.",
        "step3Label": "العلاقات",
        "step4Desc": "التحقق والنشر",
        "step4Label": "المراجعة والإنشاء",
        "subtitle": "تعريف نموذج بيانات مؤسسي جديد",
        "summaryColumns": "الأعمدة (المسماة):",
        "summaryEntities": "الكيانات:",
        "summaryIndustry": "القطاع:",
        "summaryName": "الاسم:",
        "summaryRelationships": "العلاقات:",
        "title": "إنشاء نموذج بيانات",
        "typePlaceholder": "النوع"
      },
      "detail": {
        "add": "إضافة",
        "addColumnTitle": "إضافة عمود",
        "back": "رجوع",
        "backToDataModels": "العودة إلى نماذج البيانات",
        "cardinality": "الكاردينالية",
        "chooseBothTables": "اختر كلا الجدولين",
        "columnNameRequired": "اسم العمود مطلوب",
        "couldNotAddRelationship": "تعذرت إضافة العلاقة",
        "couldNotApplyDdl": "تعذر تطبيق DDL",
        "couldNotDeleteColumn": "تعذر حذف العمود",
        "couldNotDeleteRelationship": "تعذر حذف العلاقة",
        "couldNotLoadDdl": "تعذر تحميل تصدير DDL",
        "couldNotSaveColumn": "تعذر حفظ العمود",
        "couldNotUpdateRelationship": "تعذر تحديث العلاقة",
        "dataType": "نوع البيانات",
        "ddlCouldNotExportYet": "-- تعذر تصدير DDL حتى الآن.\n",
        "ddlUnavailableLargeModel": "-- تصدير DDL متاح من قائمة التصدير للنماذج الكبيرة.\n",
        "ddlValidationPassed": "نجح التحقق من DDL",
        "deleteColumnAria": "حذف العمود {{name}}",
        "deleteColumnMessage": "سيؤدي هذا إلى إزالة العمود من كيان نموذج البيانات.",
        "deleteColumnTitle": "حذف العمود",
        "deleteRelationshipAria": "حذف العلاقة",
        "deleteRelationshipMessage": "إزالة هذه العلاقة من النموذج.",
        "deleteRelationshipTitle": "حذف العلاقة",
        "diagramExported": "تم تصدير المخطط",
        "drawioDownloaded": "تم تنزيل مخطط Draw.io",
        "drawioExportFailed": "فشل تصدير Draw.io",
        "editColumnAria": "تعديل العمود {{name}}",
        "editColumnTitle": "تعديل العمود",
        "editRelationshipAria": "تعديل العلاقة",
        "editRelationshipTitle": "تعديل العلاقة",
        "exportFailed": "فشل التصدير",
        "fkColumnSource": "عمود المفتاح الأجنبي (المصدر)",
        "foreignKeys": "المفاتيح الأجنبية",
        "jsonSnapshotDownloaded": "تم تنزيل لقطة JSON",
        "modelNotFound": "النموذج غير موجود",
        "modelUpdatedFromDdl": "تم تحديث النموذج من DDL",
        "name": "الاسم",
        "noColumnsYet": "لا توجد أعمدة بعد. أضف عمودًا لتعريف هذا الكيان.",
        "noDirectRelationships": "لا توجد علاقات مباشرة",
        "nothingToExport": "لا يوجد شيء للتصدير",
        "nullableColumns": "أعمدة قابلة للقيمة الفارغة",
        "optional": "اختياري",
        "optionalCapitalized": "اختياري",
        "primaryKeys": "المفاتيح الأساسية",
        "recordCount": "عدد السجلات",
        "relationshipAdded": "تمت إضافة العلاقة",
        "snapshotExportFailed": "فشل تصدير اللقطة",
        "svgExportFailed": "فشل تصدير SVG",
        "svgExported": "تم تصدير SVG",
        "tab": {
          "columns": "الأعمدة",
          "relationships": "العلاقات",
          "stats": "الإحصاءات"
        },
        "tooManyTablesForImage": "يحتوي هذا النموذج على {{count}} جدول — كبير جدًا لعرضه كصورة في المتصفح. استخدم \"التصدير كـ Draw.io\" بدلاً من ذلك.",
        "validation": "التحقق",
        "validationFailed": "فشل التحقق",
        "viewMode": "عرض",
        "modifyMode": "تعديل",
        "searchTablesPlaceholder": "البحث في الجداول والأعمدة…",
        "filterErDiagramAriaLabel": "تصفية مخطط العلاقات",
        "exportAsPng": "تصدير كـ PNG",
        "exportAsSvg": "تصدير كـ SVG",
        "exportJsonSnapshot": "تصدير لقطة JSON",
        "exportAsDrawio": "تصدير كـ Draw.io",
        "relationshipButton": "علاقة",
        "modelMetricsAriaLabel": "مقاييس النموذج",
        "entitiesLabel": "الكيانات",
        "entAbbrev": "كيان",
        "relationshipsLabel": "العلاقات",
        "relAbbrev": "علاقة",
        "totalRecordsLabel": "إجمالي السجلات",
        "recAbbrev": "سجل",
        "linkedKpisLabel": "مؤشرات الأداء المرتبطة",
        "kpiAbbrev": "KPI",
        "noEntitiesYet": "لا توجد كيانات بعد",
        "noEntitiesDescription": "طبّق DDL على اليسار أو استورد نموذجًا لملء هذا المخطط.",
        "askDataModelTitle": "اسأل نموذج البيانات",
        "askDataModelSubtitle": "استعلم عن الكيانات والأعمدة والعلاقات.",
        "askDataModelGreeting": "اسأل عن الجداول أو الأعمدة أو العلاقات أو الإحصاءات في نموذج البيانات هذا.",
        "addRelationshipTitle": "إضافة علاقة",
        "addRelationshipSubtitle": "من ← إلى · عمود مفتاح خارجي اختياري في جدول المصدر",
        "fromTable": "من جدول",
        "toTable": "إلى جدول",
        "selectEllipsis": "اختر…",
        "fkColumnOnSource": "عمود المفتاح الخارجي (في المصدر)",
        "optionalLowercase": "اختياري",
        "ddlRefreshTitle": "استبدال المحرر من تصدير الخادم",
        "ddlRefresh": "تحديث",
        "ddlSwitchToModifyValidate": "بدّل إلى وضع التعديل للتحقق",
        "ddlValidate": "تحقق",
        "ddlSwitchToModifyApply": "بدّل إلى وضع التعديل للتطبيق",
        "ddlApply": "تطبيق"
      },
      "editDialog": {
        "invalidName": "اسم نموذج غير صالح",
        "saveChanges": "حفظ التغييرات",
        "subtitle": "تحديث الاسم والقطاع والوصف",
        "title": "تعديل نموذج البيانات",
        "updateFailed": "تعذر تحديث نموذج البيانات",
        "updated": "تم تحديث نموذج البيانات"
      },
      "importDialog": {
        "analyzing": "جارٍ التحليل...",
        "chooseFile": "اختيار ملف",
        "chooseFiles": "اختيار ملفات",
        "close": "إغلاق",
        "createFromSampleData": "الإنشاء من بيانات عينة",
        "createdSummary": "تم إنشاء \"{{name}}\": {{entities}} كيان، {{columns}} عمود، {{relationships}} علاقة.",
        "csvFilesLabel": "ملفات CSV (ملف واحد لكل جدول، حتى 30)",
        "downloadSampleHint": "قم بتنزيل ملف عينة لمعرفة التخطيط المتوقع",
        "excelWorkbook": "مصنف Excel",
        "fileLabel": "الملف: {{name}} ({{size}} كيلوبايت)",
        "formatContent": "محتوى {{label}}",
        "import": "استيراد",
        "importAsDataModel": "استيراد كنموذج بيانات",
        "importFailed": "فشل الاستيراد",
        "importFailedTitle": "فشل الاستيراد",
        "importFormat": "تنسيق الاستيراد",
        "importSuccessful": "نجح الاستيراد",
        "importWithVisionModel": "استيراد باستخدام نموذج رؤية",
        "importedSummary": "تم استيراد \"{{name}}\": {{entities}} كيان، {{columns}} عمود، {{relationships}} علاقة.",
        "importing": "جارٍ الاستيراد...",
        "inferredModelNamePlaceholder": "اسم النموذج المستنتج",
        "loadSample": "تحميل عينة",
        "mediaFileTypes": "ملف (PNG، JPEG، GIF، WebP، PDF، TXT، MD)",
        "mediaHelp": "قم برفع لقطة شاشة لمخطط ER أو ملف PDF مُصدَّر أو نص غير منظم. تستخدم المعالجة نموذج المستأجر الخاص بك على منصة {{brand}}؛ قد تستغرق الملفات الكبيرة بضع دقائق.",
        "modelNameOptional": "اسم النموذج (اختياري)",
        "noFormatsAvailable": "لا تتوفر تنسيقات استيراد من الخادم.",
        "noImportModelConfigured": "لم يتم تكوين نموذج استيراد.",
        "noImportModelLlmHint": "اطلب من مسؤول المستأجر فتح الإدارة ← الإعدادات العامة ← أنطولوجيا المؤسسة واختيار نموذج لغوي كبير قبل استخدام هذا التبويب.",
        "noImportModelVisionHint": "اطلب من مسؤول المستأجر فتح الإدارة ← الإعدادات العامة ← أنطولوجيا المؤسسة واختيار نموذج لغوي كبير يدعم الرؤية قبل استخدام هذا التبويب.",
        "overrideTitleNoName": "تجاوز العنوان إذا لم يكن للملف اسم واضح",
        "overrideTitlePlaceholder": "تجاوز العنوان المكتشف تلقائيًا",
        "placeholderCsv": "الصق CSV بترميز UTF-8 أو ارفع ملف .csv: إما جدوليًا (الصف 1 = الأعمدة؛ الصف 2 اختياري = الأنواع) أو شبكة قاموس بيانات (اسم الجدول / اسم العمود / نوع البيانات / مفتاح أساسي اختياري / الجدول المرجعي).",
        "placeholderDbml": "الصق DBML الخاص بك (تعريفات الجداول وأسطر Ref)...",
        "placeholderDdl": "الصق عبارات CREATE TABLE هنا...",
        "placeholderDrawio": "الصق محتوى XML الخاص بـ Draw.io...",
        "placeholderJson": "الصق JSON المحمول من {{brand}} — بنفس شكل تصدير نموذج البيانات ← JSON محمول (كيانات + علاقات).",
        "placeholderJsonSchema": "الصق JSON Schema مع التعريفات...",
        "placeholderMermaid": "الصق كتلة erDiagram الخاصة بك...",
        "placeholderPlantuml": "الصق مخطط الكيانات @startuml الخاص بك...",
        "placeholderXlsx": "يستخدم استيراد Excel تحميل الملفات فقط. كل ورقة عمل تكون إما جدولًا واحدًا (صف العنوان = الأعمدة)، أو شبكة قاموس بيانات (صفوف جدول/عمود/نوع)، أو ورقة Relationships (From Table / To Table / Foreign Key Column).",
        "sampleCsv": "نموذج CSV",
        "sampleHelp": "قم برفع ملف CSV واحد أو أكثر يحتوي على بيانات عينة تمثيلية. يقوم النظام بتحليل أسماء الأعمدة والقيم لاستنتاج الكيانات وأنواع البيانات والمفاتيح الأساسية/الأجنبية والعلاقات بين الجداول.",
        "sampleXlsx": "نموذج XLSX",
        "subtitle": "تنسيقات منظمة، صور ومستندات، أو الاستنتاج من بيانات CSV عينة",
        "tabMedia": "الصور والمستندات",
        "tabSample": "من بيانات عينة",
        "tabStructured": "تنسيقات منظمة",
        "title": "استيراد نموذج بيانات",
        "uploadFile": "رفع ملف",
        "warningPrefix": "تحذير:",
        "xlsxHelp": "تصبح كل ورقة عمل مرئية جدولًا واحدًا أو أكثر: تستخدم الأوراق الجدولية الصف 1 كأسماء أعمدة؛ أوراق قاموس البيانات (اسم الجدول + اسم العمود + نوع البيانات، مفتاح أساسي / جدول مرجعي / كاردينالية اختياريًا) توسع كل صف إلى عمود منطقي. استخدم ورقة Relationships (From Table، To Table، Foreign Key Column، Cardinality اختياريًا) للحواف الصريحة، أو ضع الجدول المرجعي في صفوف المفتاح الأجنبي بالقاموس. يتم تخطي أسماء الأوراق ذات الطابع التوجيهي (README، Template، ...) والأسماء التي تبدأ بـ _. لا تزال المفاتيح الأجنبية المتبقية تُستنتج من أسماء الأعمدة (مثل store_sk ← store) عند وجود الأهداف في المصنف."
      },
      "industryTagDialog": {
        "subtitle": "شارة الكتالوج والمرشحات لـ {{name}}",
        "title": "علامات القطاع",
        "updateFailed": "تعذر تحديث علامات القطاع",
        "updated": "تم تحديث علامات القطاع"
      },
      "list": {
        "actionClone": "استنساخ",
        "actionDelete": "حذف",
        "actionEdit": "تعديل",
        "actionIndustryTags": "علامات القطاع",
        "actionPublish": "نشر",
        "allCreators": "جميع المنشئين",
        "allIndustries": "جميع القطاعات",
        "clearSearch": "مسح البحث",
        "cloneFailed": "تعذر استنساخ نموذج البيانات",
        "clonedAs": "تم الاستنساخ باسم \"{{name}}\"",
        "createDataModel": "إنشاء نموذج بيانات",
        "creator": "المنشئ",
        "deleteDialogMessage": "سيؤدي هذا إلى إزالة نموذج البيانات من الكتالوج. قد تحتاج مراجع مؤشرات الأداء المرتبطة إلى التحديث.",
        "deleteDialogTitle": "حذف نموذج البيانات",
        "deleteFailed": "تعذر حذف نموذج البيانات",
        "deleted": "تم حذف نموذج البيانات",
        "emptyDescription": "أنشئ أو استورد نموذج بيانات للبدء.",
        "emptyTitle": "لا توجد نماذج بيانات بعد",
        "entities": "كيانات",
        "exportFailed": "تعذر تصدير نموذج البيانات",
        "filters": "المرشحات",
        "import": "استيراد",
        "industry": "القطاع",
        "kpis": "مؤشرات الأداء",
        "loadFailed": "فشل تحميل نماذج البيانات",
        "loading": "جارٍ تحميل نماذج البيانات…",
        "loadingMore": "جارٍ تحميل المزيد من نماذج البيانات…",
        "loadingPrev": "جارٍ تحميل نماذج البيانات السابقة…",
        "noMatchDescription": "جرب بحثًا آخر أو مرشح قطاع آخر، أو أنشئ نموذجًا جديدًا.",
        "noMatchTitle": "لا توجد نماذج بيانات مطابقة",
        "publishFailed": "تعذر النشر",
        "published": "تم نشر نموذج البيانات",
        "refresh": "تحديث",
        "refreshError": "تعذر تحديث الكتالوج",
        "refreshList": "تحديث القائمة",
        "relationships": "علاقات",
        "searchPlaceholder": "البحث عن نماذج البيانات…",
        "statEntities": "الكيانات",
        "statLinkedKpis": "مؤشرات الأداء المرتبطة",
        "statModels": "النماذج",
        "statPublished": "منشور",
        "unableToLoad": "تعذر تحميل الكتالوج"
      },
      "erFlow": {
        "entityType": {
          "dimension": "بُعد",
          "fact": "جدول وقائع",
          "bridge": "جسر",
          "aggregate": "تجميع"
        },
        "columnsCount": "{{count}} عمود",
        "loadingEllipsis": "جارٍ التحميل…",
        "showMore": "عرض المزيد",
        "showLess": "عرض أقل",
        "resetViewTitle": "إعادة تعيين العرض والتمييزات",
        "resetView": "إعادة تعيين العرض",
        "hintReadOnly": "معاينة للقراءة فقط · مرر للتحريك · استخدم أزرار التكبير",
        "hintModify": "تعديل: اسحب من النقطة اليمنى للعمود (جانب المفتاح الأجنبي) إلى النقطة اليسرى لعمود في جدول آخر · ",
        "hintClickTable": "انقر على جدول لعرض التفاصيل · ",
        "hintPanZoom": "مرر للتحريك · استخدم أزرار التكبير · اسحب لتحريك الجداول"
      }
    },
    "optional": "اختياري",
    "type": "النوع",
    "kpiAllListView": "كل مؤشرات الأداء",
    "kpiLibrary": {
      "all": "الكل",
      "allCollections": "كل المجموعات",
      "allDataTypes": "كل أنواع البيانات",
      "allIndustries": "كل الصناعات",
      "andMoreErrors": "...و{{count}} أخرى",
      "askAboutKpis": "اسأل عن مؤشرات الأداء",
      "backToFamilies": "العودة إلى العائلات",
      "browseMode": "وضع التصفح",
      "cardActions": "إجراءات البطاقة",
      "chatGreeting": "اسأل عن أسماء مؤشرات الأداء وتعريفاتها وعائلاتها وأنواع بياناتها أو روابطها بنماذج البيانات.",
      "chatSubtitleCollection": "التعريفات والعائلات في هذه المجموعة.",
      "chatSubtitleFamily": "التعريفات في هذه العائلة.",
      "clearFiltersAndSearch": "مسح عوامل التصفية والبحث",
      "closeAria": "إغلاق",
      "collection": "المجموعة",
      "collectionCardMenu": "قائمة بطاقة المجموعة",
      "collectionsView": "عرض المجموعات",
      "couldNotLoadCatalog": "تعذر تحميل الكتالوج",
      "createCollection": "إنشاء مجموعة",
      "createFamily": "إنشاء عائلة",
      "createKpi": "إنشاء مؤشر أداء",
      "dataType": "نوع البيانات",
      "delete": "حذف",
      "dismiss": "إغلاق",
      "editDetails": "تعديل التفاصيل",
      "editLinkedDataModel": "تعديل نموذج البيانات المرتبط",
      "enterpriseOntology": "أنطولوجيا المؤسسة",
      "family": "العائلة",
      "familiesCount": "{{count}} عائلة",
      "filters": "عوامل التصفية",
      "importCompleteLabel": "اكتمل الاستيراد:",
      "importCreatedSkipped": "تم إنشاء {{created}}، وتخطي {{skipped}}",
      "importCsv": "استيراد CSV",
      "industry": "الصناعة",
      "industryTags": "وسوم الصناعة",
      "internalIdNotePrefix": "المعرّف الداخلي",
      "internalIdNoteSuffix": "يبقى كما هو — لن تتأثر عمليات استيراد CSV والروابط.",
      "kpiType": "نوع مؤشر الأداء",
      "kpisCount": "{{count}} مؤشر أداء",
      "legacySuffix": "{{domain}} (قديم)",
      "linkDataModel": "ربط نموذج البيانات",
      "linkFamilyToModel": "ربط عائلة مؤشرات الأداء هذه بنموذج بيانات مرجعي",
      "linkedDataModel": "نموذج البيانات المرتبط",
      "linkedDataModelTooltip": "نموذج البيانات المرتبط: {{name}}",
      "linkedModelFallback": "النموذج المرتبط",
      "loadingLibrary": "جارٍ تحميل مكتبة مؤشرات الأداء...",
      "noCollectionsDesc": "أنشئ مجموعة أو استورد ملف CSV للبدء.",
      "noCollectionsMatchTitle": "لا توجد مجموعات مطابقة لبحثك",
      "noCollectionsTitle": "لا توجد مجموعات مؤشرات أداء بعد",
      "noDataFound": "لم يتم العثور على بيانات",
      "noFamiliesDesc": "أنشئ عائلة أو استورد ملف CSV للبدء.",
      "noFamiliesMatchTitle": "لا توجد عائلات مطابقة لبحثك",
      "noFamiliesTitle": "لا توجد عائلات مؤشرات أداء في هذه المجموعة",
      "noKpisMatch": "لا توجد مؤشرات أداء مطابقة لعوامل التصفية. حاول تعديل البحث أو عوامل التصفية، أو استورد تعريفات.",
      "noMatchDesc": "جرّب مصطلح بحث مختلف أو امسح عوامل التصفية.",
      "none": "بلا",
      "precisionYes": "الدقة (نعم)",
      "rename": "إعادة تسمية",
      "rowActions": "إجراءات الصف",
      "save": "حفظ",
      "saving": "جارٍ الحفظ…",
      "searchPlaceholder": "ابحث في المجموعات أو العائلات أو اسم مؤشر الأداء أو التعريف أو الوصف...",
      "selectCollection": "اختر مجموعة...",
      "selectFamily": "اختر عائلة...",
      "selectIndustry": "اختر صناعة…",
      "selectType": "اختر نوعاً...",
      "totalCollections": "إجمالي المجموعات",
      "viewDetails": "عرض التفاصيل",
      "viewKpiDetails": "عرض تفاصيل مؤشر الأداء",
      "columns": {
        "actions": "الإجراءات",
        "costPositive": "التكلفة +",
        "dataType": "نوع البيانات",
        "definition": "التعريف",
        "description": "الوصف",
        "family": "العائلة",
        "kpiName": "اسم مؤشر الأداء",
        "kpiType": "نوع مؤشر الأداء",
        "precision": "الدقة"
      },
      "createCollectionDialog": {
        "descriptionAlnumError": "يجب أن يحتوي الوصف على نص صالح ولا يمكن أن يتكون فقط من رموز خاصة أو إيموجي",
        "descriptionPlaceholder": "وصف موجز لمجموعة مؤشرات الأداء هذه",
        "displayNameAlnumError": "يجب أن يتضمن الاسم المعروض حرفاً أو رقماً واحداً على الأقل",
        "displayNameCharsError": "يمكن أن يحتوي الاسم المعروض على أحرف وأرقام ومسافات وشرطات وشرطات سفلية فقط",
        "displayNamePlaceholder": "مثال: مؤشرات أداء التجزئة",
        "displayNameRequired": "الاسم المعروض *",
        "nameAlnumError": "يجب أن يتضمن الاسم حرفاً أو رقماً واحداً على الأقل",
        "nameCharsError": "يمكن أن يحتوي الاسم على أحرف وأرقام وشرطات سفلية فقط",
        "namePlaceholder": "مثال: retail_kpis",
        "nameRequired": "الاسم *",
        "title": "إنشاء مجموعة جديدة"
      },
      "createFamilyDialog": {
        "collectionRequired": "مجموعة مؤشرات الأداء *",
        "displayNamePlaceholder": "مؤشرات أداء على مستوى العميل",
        "displayNameRequired": "الاسم المعروض *",
        "namePlaceholder": "مثال: COSMOS_CUSTOMER_LEVEL_KPIS",
        "nameRequired": "الاسم *",
        "title": "إنشاء عائلة مؤشرات أداء جديدة"
      },
      "createKpiDialog": {
        "collectionRequired": "المجموعة *",
        "costPositiveCheckbox": "التكلفة + (نعم/لا)",
        "create": "إنشاء مؤشر أداء",
        "dataTypePlaceholder": "نص (string)",
        "definitionPlaceholder": "التعريف الفني أو ملاحظات الحساب",
        "descriptionPlaceholder": "ملخص موجز",
        "familyRequired": "العائلة *",
        "kpiNamePlaceholder": "مثال: CUSTOMER_ATC_RATE",
        "kpiNameRequired": "اسم مؤشر الأداء *",
        "precisionCheckbox": "الدقة (نعم/لا)",
        "title": "إنشاء مؤشر أداء جديد"
      },
      "collectionIndustryDialog": {
        "subtitle": "ينطبق على \"{{name}}\" وكيفية ظهورها في كتالوج مؤشرات الأداء.",
        "title": "وسوم صناعة المجموعة"
      },
      "deleteCollectionDialog": {
        "message": "يؤدي هذا إلى إزالة المجموعة وجميع عائلات وتعريفات مؤشرات الأداء بداخلها. سيتم مسح هدف مجموعة مؤشرات الأداء تلقائياً في أي مشروع ترحيل كان يشير إلى هذه المجموعة.",
        "title": "حذف مجموعة مؤشرات الأداء"
      },
      "deleteFamilyDialog": {
        "message": "هل أنت متأكد من رغبتك في حذف \"{{name}}\"؟ سيؤدي هذا أيضاً إلى حذف جميع مؤشرات الأداء في هذه العائلة ولا يمكن التراجع عنه.",
        "title": "حذف العائلة"
      },
      "deleteKpiDialog": {
        "message": "هل أنت متأكد من رغبتك في حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
        "title": "حذف مؤشر الأداء"
      },
      "detailPopup": {
        "closeAria": "إغلاق",
        "costPositive": "التكلفة +",
        "dataType": "نوع البيانات",
        "definition": "التعريف",
        "description": "الوصف",
        "linkedModel": "النموذج المرتبط",
        "no": "لا",
        "precision": "الدقة",
        "tags": "الوسوم",
        "yes": "نعم"
      },
      "domainDialog": {
        "missingIndustry": "الصناعة مفقودة",
        "updateFailed": "تعذر تحديث وسوم الصناعة"
      },
      "editFamilyDialog": {
        "descriptionPlaceholder": "صف ما تغطيه عائلة مؤشرات الأداء هذه…",
        "title": "تعديل عائلة مؤشرات الأداء",
        "titleLabel": "العنوان",
        "titlePlaceholder": "مثال: مؤشرات أداء الإيرادات",
        "updateFailed": "تعذر تحديث العائلة"
      },
      "errors": {
        "createCollectionFailed": "فشل إنشاء المجموعة",
        "createFamilyFailed": "فشل إنشاء العائلة",
        "createKpiFailed": "فشل إنشاء مؤشر الأداء",
        "csvImportFailed": "فشل استيراد CSV",
        "deleteCollectionFailed": "تعذر حذف مجموعة مؤشرات الأداء",
        "deleteFamilyFailed": "فشل حذف العائلة",
        "deleteKpiFailed": "فشل حذف مؤشر الأداء",
        "exportFailed": "تعذر تصدير مؤشرات الأداء",
        "loadFailed": "تعذر تحميل مكتبة مؤشرات الأداء."
      },
      "familyIndustryDialog": {
        "subtitle": "ينطبق على \"{{name}}\".",
        "title": "وسوم صناعة عائلة مؤشرات الأداء"
      },
      "importDialog": {
        "appliedToFamiliesNote": "يُطبَّق على عائلات مؤشرات الأداء التي أنشأتها أو لمستها عملية الاستيراد هذه.",
        "chooseCsvFile": "اختر ملف CSV",
        "close": "إغلاق",
        "dataTypeHelp": "— مثال: نص، عدد عشري؛ يتم استنتاج القيم المحذوفة من الاسم والتعريف.",
        "definitionHelp": "— التعريف الفني؛",
        "descriptionHelp": "— ملخص موجز.",
        "domainHelp": "— نطاق اختياري على مستوى الصف (يُستخدم نطاق الاستيراد افتراضياً).",
        "familyCreatedNote": "سيتم وضع العائلات التي يتم إنشاؤها أثناء الاستيراد في هذه المجموعة. تُستخدم \"Default\" افتراضياً إذا كان الحقل فارغاً.",
        "familyDisplayHelp": "— تظهر في الواجهة عند إنشاء العائلات أو تحديثها.",
        "familyKpiHelp": "— معرّفات ثابتة لمجموعة العائلة ورمز مؤشر الأداء.",
        "industryOptional": "الصناعة (اختياري)",
        "kpiCollection": "مجموعة مؤشرات الأداء",
        "kpiTypeDefault": "(الافتراضي: أساسي).",
        "linkDataModelOptional": "ربط نموذج البيانات (اختياري)",
        "or": "أو",
        "or2": "(أو",
        "overridesDomainNote": "يتجاوز عمود النطاق في صفوف CSV الفردية.",
        "precisionCostHelp": ") — نعم/لا؛ في حال حذفها، يكون الافتراضي لكليهما نعم.",
        "requiredColumns": "الأعمدة المطلوبة:",
        "title": "استيراد مؤشرات الأداء من CSV"
      },
      "linkDialog": {
        "noneHint": "اختر \"بلا\" لفصل هذه العائلة عن أي نموذج علاقات كيانية. يستخدم استوديو الوكلاء والمخططات هذا الرابط لمواءمة مؤشرات الأداء مع الكيانات.",
        "referenceDataModel": "نموذج البيانات المرجعي",
        "subtitle": "اختر نموذج البيانات المرجعي لـ \"{{name}}\".",
        "title": "ربط عائلة مؤشرات الأداء بنموذج البيانات",
        "updateFailed": "تعذر تحديث رابط نموذج البيانات"
      },
      "renameCollectionDialog": {
        "displayName": "الاسم المعروض",
        "placeholder": "مثال: مؤشرات أداء التجزئة",
        "renameFailed": "تعذرت إعادة تسمية المجموعة",
        "title": "إعادة تسمية المجموعة"
      },
      "toasts": {
        "collectionDeleted": "تم حذف مجموعة مؤشرات الأداء",
        "collectionRenamed": "تمت إعادة تسمية المجموعة",
        "dataModelLinkRemoved": "تمت إزالة رابط نموذج البيانات",
        "dataModelLinked": "تم ربط نموذج البيانات",
        "familyUpdated": "تم تحديث العائلة",
        "industryTagsUpdated": "تم تحديث وسوم الصناعة"
      },
      "createCollectionButton": "إنشاء مجموعة",
      "importCsvButton": "استيراد CSV"
    },
    "dataStudio": {
      "list": {
        "newPipeline": "خط أنابيب جديد",
        "typeLabel": "النوع",
        "statusLabel": "الحالة",
        "allTypes": "كل الأنواع",
        "allStatus": "كل الحالات",
        "columnPipeline": "خط الأنابيب",
        "columnType": "النوع",
        "columnStatus": "الحالة",
        "columnRoute": "المصدر ← الهدف",
        "columnSchedule": "الجدولة",
        "columnUpdated": "تاريخ التحديث",
        "columnActions": "الإجراءات",
        "actionOpen": "فتح",
        "actionDelete": "حذف",
        "deleteDialogTitle": "حذف خط الأنابيب",
        "deleteDialogMessage": "سيُزال خط الأنابيب من Data Studio. لا يمكن التراجع عن هذا الإجراء.",
        "deleted": "تم حذف خط الأنابيب \"{{name}}\"",
        "deleteFailed": "تعذّر حذف خط الأنابيب",
        "migrationLinkTitle": "من الترحيل: {{id}}",
        "migrationLinkText": "الترحيل",
        "statsPipelines": "خطوط الأنابيب",
        "emptyNoPipelines": "لا يوجد شيء بعد في Data Studio. عادةً ما تُرقّى خطوط الأنابيب من مشاريع ترحيل مكتملة أو تُنشأ عبر زر الإنشاء أعلاه.",
        "emptyNoMatches": "لا توجد إدخالات مطابقة للفلاتر. حاول تعديل معايير البحث أو الفلترة.",
        "filtersTitle": "الفلاتر",
        "searchPlaceholder": "البحث في الكتالوج...",
        "loadErrorTitle": "تعذّر تحميل كتالوج Data Studio",
        "retry": "إعادة المحاولة"
      },
      "status": {
        "pending": "قيد الانتظار",
        "terminating": "جارٍ الإنهاء"
      },
      "createDialog": {
        "title": "إنشاء خط أنابيب",
        "subtitleChoose": "اختر نوع خط الأنابيب للبدء",
        "subtitleMode": "خط أنابيب {{mode}}",
        "steps": {
          "type": {
            "label": "نوع خط الأنابيب",
            "description": "اختر وضع خط الأنابيب"
          },
          "sourceTarget": {
            "label": "المصدر والهدف",
            "description": "اختر نقاط النهاية"
          },
          "configuration": {
            "label": "الإعدادات",
            "description": "الجدولة والخيارات"
          },
          "review": {
            "label": "المراجعة",
            "description": "تأكيد وإنشاء"
          }
        },
        "modes": {
          "migrate": {
            "label": "ترحيل",
            "description": "ترحيل مدعوم بالذكاء الاصطناعي — يفتح Migrations Studio"
          },
          "orchestrator": {
            "label": "سير عمل التنسيق",
            "description": "مصمم DAG مرئي — النشر إلى Databricks أو Vertex AI أو Airflow"
          },
          "map": {
            "label": "ربط",
            "description": "ربط على مستوى الحقول بين مخططات المصدر والهدف"
          },
          "transform": {
            "label": "تحويل",
            "description": "تطبيق تحويلات SQL أو Python أثناء النقل"
          },
          "custom": {
            "label": "مخصص",
            "description": "خط أنابيب قابل للتكوين بالكامل مع محرر أكواد"
          }
        },
        "createdTitle": "تم إنشاء خط الأنابيب",
        "createdDesc": "تم حفظ {{name}} ({{mode}}) كمسودة.",
        "pipelineNameLabel": "اسم خط الأنابيب",
        "pipelineNamePlaceholder": "مثال: {{source}} ← {{target}} {{mode}}",
        "sourceSystemLabel": "نظام المصدر",
        "sourceSystemPlaceholder": "مثال: Postgres prod, Snowflake DWH",
        "targetDestinationLabel": "وجهة الهدف",
        "targetDestinationPlaceholder": "مثال: BigQuery curated, S3 lake",
        "modeSuffix": "وضع {{mode}}",
        "change": "تغيير",
        "scheduleLabel": "الجدولة",
        "scheduleSelectPlaceholder": "اختر الجدولة",
        "batchSizeLabel": "حجم الدفعة",
        "retryOnFailureLabel": "إعادة المحاولة عند الفشل",
        "retryEnabled": "مفعّل (3 محاولات)",
        "retryDisabled": "معطّل",
        "transformationSqlLabel": "SQL التحويل",
        "customPipelineCodeLabel": "كود خط أنابيب مخصص",
        "transformSqlPlaceholder": "SELECT\n  customer_id,\n  SUM(amount) as total_spend,\n  COUNT(*) as txn_count\nFROM source_table\nGROUP BY customer_id",
        "customCodePlaceholder": "# منطق خط أنابيب مخصص\nimport pandas as pd\n\ndef transform(df):\n    return df",
        "summaryTitle": "ملخص خط الأنابيب",
        "summaryName": "الاسم:",
        "summaryType": "النوع:",
        "summarySchedule": "الجدولة:",
        "summaryBatchSize": "حجم الدفعة:",
        "summaryRetry": "إعادة المحاولة:",
        "retryAttempts": "3 محاولات",
        "back": "رجوع",
        "done": "تم",
        "continue": "متابعة",
        "creating": "جارٍ الإنشاء…",
        "createPipeline": "إنشاء خط أنابيب"
      },
      "detail": {
        "configured": "تم التكوين",
        "error": "خطأ",
        "start": "بداية",
        "end": "نهاية",
        "sourceNodeType": "المصدر",
        "targetNodeType": "الهدف",
        "extractNodeLabel": "استخراج وتحقق",
        "parserNodeType": "محلّل",
        "notFoundTitle": "خط الأنابيب غير موجود",
        "backToPipelines": "الرجوع إلى خطوط الأنابيب",
        "typeLabel": "النوع",
        "batchSizeLabel": "حجم الدفعة",
        "retryOnFailureLabel": "إعادة المحاولة عند الفشل",
        "updatedLabel": "تاريخ التحديث",
        "yes": "نعم",
        "no": "لا",
        "transformationSqlLabel": "SQL التحويل",
        "customCodeLabel": "كود مخصص"
      }
    }
  },
  "home": {
    "tabs": {
      "overview": "نظرة عامة",
      "agents": "الوكلاء",
      "workflows": "سير العمل",
      "evals": "التقييمات",
      "sessions": "الجلسات",
      "cost": "التكلفة",
      "platform": "المنصة"
    },
    "dateRangeAriaLabel": "النطاق الزمني للوحة المعلومات",
    "sectionInfoAriaLabel": "معلومات القسم",
    "viewLabel": "عرض {{label}}",
    "loading": "جارٍ تحميل لوحة المعلومات...",
    "loadFailed": "فشل تحميل البيانات",
    "retry": "إعادة المحاولة",
    "noDataAvailable": "لا توجد بيانات متاحة",
    "noData": "لا توجد بيانات",
    "quickActions": {
      "createAgent": "إنشاء وكيل",
      "newWorkflow": "سير عمل جديد",
      "runEval": "تشغيل تقييم",
      "aiAgentBuilder": "أداة بناء وكلاء الذكاء الاصطناعي",
      "aiWorkflowsBuilder": "أداة بناء مسارات عمل الذكاء الاصطناعي",
      "agentStore": "متجر الوكلاء",
      "tools": "الأدوات"
    },
    "activity": {
      "title": "النشاط الأخير",
      "export": "تصدير",
      "filterAll": "الكل",
      "filterUpdate": "تحديث",
      "filterCreate": "إنشاء",
      "filterDelete": "حذف",
      "noActivityFound": "لم يُعثر على أي نشاط",
      "actionCreate": "إنشاء",
      "actionUpdate": "تحديث",
      "actionDelete": "حذف",
      "actionRead": "قراءة",
      "resourceIdTitle": "معرّف المورد",
      "viewAll": "عرض الكل"
    },
    "overview": {
      "kpi": {
        "totalAgents": "إجمالي الوكلاء",
        "totalAgentsHintDefault": "تم الإنشاء خلال الفترة المحددة",
        "totalAgentsHintAllTenants": "تم الإنشاء خلال الفترة المحددة · جميع المستأجرين · باستثناء المؤرشف",
        "totalAgentsHintStudio": "تم الإنشاء خلال الفترة المحددة · بنفس نطاق استوديو الوكلاء",
        "totalWorkflows": "إجمالي مسارات العمل",
        "activeUsers": "المستخدمون النشطون",
        "activeDeployments": "عمليات النشر النشطة",
        "activeDeploymentsHint": "عمليات النشر النشطة التي تم إنشاؤها خلال الفترة المحددة",
        "sessions": "الجلسات",
        "evalRuns": "عمليات تشغيل التقييم",
        "toolCalls": "استدعاءات الأدوات",
        "archivedDelta": "مؤرشف",
        "totalProjects": "إجمالي المشاريع",
        "activeProjects": "المشاريع النشطة",
        "modelsAvailable": "النماذج المتاحة",
        "toolsAvailable": "الأدوات المتاحة",
        "activeConnections": "الاتصالات النشطة",
        "pendingApprovals": "الموافقات المعلّقة",
        "actionNeeded": "يتطلب إجراء"
      },
      "funnel": {
        "active": "نشط",
        "deployments": "عمليات النشر"
      },
      "series": {
        "agentsCreated": "الوكلاء الذين تم إنشاؤهم",
        "projects": "المشاريع",
        "sessions": "الجلسات",
        "workflows": "مسارات العمل",
        "evals": "التقييمات",
        "medianRuntime": "الوسيط الزمني للتشغيل (مللي ثانية)",
        "retryRate": "نسبة إعادة المحاولة %",
        "slaBreaches": "خروقات اتفاقية مستوى الخدمة"
      },
      "platformTrendTitle": "اتجاه المنصة",
      "platformTrendSubtitle": "نمو ونشاط كيانات المنصة عبر الزمن",
      "loadingPlatformTrend": "جارٍ تحميل اتجاه المنصة...",
      "loadingActivity": "جارٍ تحميل النشاط...",
      "quickActionsTitle": "إجراءات سريعة",
      "adoptionHealthTitle": "التبني والسلامة",
      "adoptionFunnelTitle": "قمع التبني",
      "adoptionFunnelSubtitle": "مسار المشروع من الإعداد إلى الاستخدام الفعلي",
      "adoptionFunnelInfo": "يوضح كيفية تقدم المشاريع من الإنشاء إلى النشر الفعلي واستخدام الجلسات. يمثل كل شريط عدد المشاريع التي وصلت إلى تلك المرحلة.",
      "topRiskSignalTitle": "أهم إشارة مخاطرة",
      "topRiskSignalSubtitle": "أكثر المخاطر وتنبيهات السلامة أهمية في المنصة",
      "topRiskSignalInfo": "يبرز أهم مخاطرة حالية في المنصة، استنادًا إلى معدلات فشل مسارات العمل واتجاهات نشاط الجلسات. يوضح الرسم البياني عدد خروقات اتفاقية مستوى الخدمة.",
      "riskSeverityWarn": "تحذير",
      "noActiveRiskSignal": "لا توجد إشارة مخاطرة نشطة",
      "metricFallback": "المقياس",
      "workflowHealthTitle": "سلامة مسار العمل",
      "workflowHealthSubtitle": "مقاييس الأداء والموثوقية للتنفيذات",
      "workflowHealthInfo": "يتتبّع سلامة تنفيذات مسارات العمل. يوضح الوسيط الزمني للتشغيل سرعة المعالجة، وتشير نسبة إعادة المحاولة إلى مشاكل الموثوقية، بينما تشير خروقات اتفاقية مستوى الخدمة إلى التنفيذات الفاشلة أو المنتهية المهلة.",
      "actionableHighlightsTitle": "أبرز النقاط القابلة للتنفيذ",
      "actionableHighlightsSubtitle": "أهم الكيانات مرتبة حسب النشاط والتوصيات",
      "actionableHighlightsInfo": "أهم المشاريع مرتبة حسب نشاط الجلسات وتغطية التقييم.\n\nالحالة الصحية:\n• جيد: > 0 جلسات، > 0 تقييمات\n• تحذير: > 0 جلسات، 0 تقييمات\n• سيء: 0 جلسات\n\nيعرض كل صف عدد الجلسات وعمليات تشغيل التقييم وإجراءً موصى به لتحسين تبني المنصة أو جودتها.",
      "noHighlightsYet": "لا توجد أبرز الأحداث بعد",
      "table": {
        "entity": "الكيان",
        "type": "النوع",
        "sessions": "الجلسات",
        "evalRuns": "عمليات تشغيل التقييم",
        "failurePercent": "نسبة الفشل %",
        "health": "السلامة",
        "recommendedAction": "الإجراء الموصى به"
      }
    },
    "na": "غير متاح",
    "agents": {
      "kpi": {
        "draft": "مسودة",
        "published": "منشور",
        "registered": "مسجَّل",
        "deployed": "منشور تشغيليًا",
        "storeListings": "قوائم المتجر"
      },
      "sections": {
        "byEnvironment": "الوكلاء حسب البيئة",
        "byStatus": "حالة الوكلاء",
        "registryStatus": "حالة السجل",
        "deploymentPipeline": "خط أنابيب النشر",
        "byProjectsTitle": "الوكلاء حسب المشاريع",
        "byProjectsSubtitle": "توزيع الوكلاء عبر المشاريع"
      },
      "barName": "الوكلاء"
    },
    "workflows": {
      "kpi": {
        "executions": "التنفيذات",
        "successRate": "معدل النجاح",
        "activeSchedules": "الجداول النشطة"
      },
      "sections": {
        "executionStatus": "حالة التنفيذ",
        "triggerSource": "مصدر التشغيل",
        "executionVolumeTitle": "حجم التنفيذ",
        "executionVolumeSubtitle": "إجمالي تنفيذات مسارات العمل خلال الفترة المحددة",
        "successRateTrendTitle": "اتجاه معدل النجاح",
        "successRateTrendSubtitle": "نسبة التنفيذات الناجحة عبر الزمن",
        "scheduleOverview": "نظرة عامة على الجداول",
        "recentExecutions": "التنفيذات الأخيرة"
      },
      "noRecentExecutions": "لا توجد تنفيذات حديثة",
      "series": {
        "executions": "التنفيذات",
        "successPercent": "نسبة النجاح %"
      },
      "statusActive": "نشط",
      "statusPaused": "متوقف مؤقتًا",
      "everySeconds": "كل {{seconds}} ثانية",
      "table": {
        "workflow": "سير العمل",
        "type": "النوع",
        "schedule": "الجدول",
        "status": "الحالة",
        "nextRun": "التشغيل التالي",
        "trigger": "المشغّل",
        "duration": "المدة",
        "started": "بدأ في"
      }
    },
    "evals": {
      "kpi": {
        "totalEvalSessions": "إجمالي جلسات التقييم",
        "totalEvalSessionsHint": "الجلسات التي تم إنشاؤها خلال الفترة المحددة (وفق مرشح التاريخ).",
        "avgEvalQualityScore": "متوسط درجة جودة التقييم",
        "avgEvalQualityScoreHint": "متوسط درجة مقاييس الملخص عبر جلسات التقييم خلال الفترة المحددة.",
        "passRate": "معدل النجاح",
        "passRateHint": "نسبة مقاييس الملخص التي تبلغ 70% أو أكثر خلال الفترة المحددة."
      },
      "zones": {
        "poor": "ضعيف",
        "fair": "متوسط",
        "good": "جيد"
      },
      "sections": {
        "averageScoreTitle": "متوسط درجة جودة التقييم",
        "sessionsByStatus": "الجلسات حسب الحالة",
        "sessionsTrendTitle": "اتجاه جلسات التقييم",
        "sessionsTrendSubtitle": "حجم جلسات التقييم عبر الزمن",
        "frameworkDistribution": "توزيع أُطر العمل",
        "topEvaluatedAgents": "أكثر الوكلاء تقييمًا"
      },
      "series": {
        "evalSessions": "جلسات التقييم"
      },
      "table": {
        "agent": "الوكيل",
        "evalSessions": "جلسات التقييم",
        "latestScore": "أحدث درجة",
        "framework": "إطار العمل"
      }
    },
    "sessions": {
      "kpi": {
        "activeSessionsInPeriod": "الجلسات النشطة (خلال الفترة)",
        "activeSessionsHint": "الجلسات التي تضمنت رسالة أو جولة واحدة على الأقل خلال الفترة الزمنية المحددة.",
        "avgTurnsPerSession": "متوسط الجولات / الجلسة",
        "avgTurnsHint": "متوسط عدد جولات المحادثة لكل جلسة بين الجلسات النشطة خلال الفترة الزمنية المحددة.",
        "messages": "الرسائل",
        "avgLatency": "متوسط زمن الاستجابة",
        "avgCostPerCall": "متوسط التكلفة / استدعاء",
        "avgCostPerCallHint": "يطابق تبويب التكلفة (سجلات LLM + أحداث الاستخدام)."
      },
      "sections": {
        "byEnvironment": "الجلسات حسب البيئة",
        "byEnvironmentSubtitle": "توزيع الجلسات النشطة عبر بيئات مختلفة.",
        "visibilityDistribution": "توزيع مستوى الظهور",
        "visibilityDistributionSubtitle": "تفصيل الجلسات حسب مستوى الظهور.",
        "sessionTrendTitle": "اتجاه الجلسات",
        "sessionTrendSubtitle": "عدد الجلسات اليومي خلال الفترة الزمنية المحددة.",
        "messagesTrendTitle": "اتجاه الرسائل",
        "messagesTrendSubtitle": "حجم الرسائل اليومي عبر جميع الجلسات.",
        "tokenUsageTitle": "استخدام الرموز",
        "tokenUsageSubtitle": "نفس الإجماليات اليومية في تبويب التكلفة (سجلات LLM + أحداث الاستخدام).",
        "latencyTrendTitle": "اتجاه زمن الاستجابة",
        "latencyTrendSubtitle": "متوسط زمن الاستجابة والمئينات عبر الزمن.",
        "topAgentsBySessions": "أفضل الوكلاء حسب الجلسات"
      },
      "series": {
        "tokens": "الرموز",
        "avgLatency": "متوسط زمن الاستجابة",
        "p90Latency": "زمن الاستجابة P90",
        "p95Latency": "زمن الاستجابة P95",
        "p99Latency": "زمن الاستجابة P99"
      },
      "table": {
        "agent": "الوكيل",
        "sessions": "الجلسات",
        "messages": "الرسائل",
        "avgLatency": "متوسط زمن الاستجابة",
        "avgTokens": "متوسط الرموز"
      }
    },
    "cost": {
      "kpi": {
        "totalTokens": "إجمالي الرموز",
        "inputTokens": "رموز الإدخال",
        "outputTokens": "رموز الإخراج",
        "cachedTokens": "الرموز المخزَّنة مؤقتًا",
        "estCost": "التكلفة التقديرية",
        "llmCalls": "استدعاءات LLM",
        "avgTokensPerCall": "متوسط الرموز/استدعاء",
        "dailyAvgCost": "متوسط التكلفة اليومية",
        "peakUsageDate": "تاريخ ذروة الاستخدام",
        "peakTokens": "ذروة الرموز",
        "dailyAvgTokens": "متوسط الرموز اليومي",
        "avgCostPerCall": "متوسط التكلفة/استدعاء"
      },
      "sections": {
        "tokenUsageTrendTitle": "اتجاه استخدام الرموز",
        "tokenUsageTrendSubtitle": "حجم الرموز المُعالجة عبر الزمن",
        "costTrendTitle": "اتجاه التكلفة",
        "costTrendSubtitle": "التكلفة التشغيلية التقديرية عبر الزمن",
        "tokensByServiceTitle": "الرموز حسب الخدمة",
        "tokensByServiceSubtitle": "إجمالي استخدام الرموز عبر خدمات النظام المختلفة",
        "costByServiceTitle": "التكلفة التقديرية حسب الخدمة",
        "costByServiceSubtitle": "تفصيل الأثر المالي حسب خدمة النظام",
        "tokensByConsumerTitle": "الرموز حسب المستهلك",
        "tokensByConsumerSubtitle": "استهلاك الرموز موزّعًا حسب مستهلكي واجهة البرمجة",
        "costByConsumerTitle": "التكلفة التقديرية حسب المستهلك",
        "costByConsumerSubtitle": "تفصيل التكلفة عبر مستهلكي واجهة البرمجة المختلفين",
        "tokenDistByModelTitle": "توزيع الرموز حسب النموذج",
        "tokenDistByModelSubtitle": "الاستخدام النسبي للرموز عبر نماذج الذكاء الاصطناعي المختلفة",
        "costByModelTitle": "تقدير التكلفة حسب النموذج",
        "costByModelSubtitle": "النفقات التقديرية المنسوبة لكل نموذج ذكاء اصطناعي",
        "tokensByProjectTitle": "استهلاك الرموز حسب المشروع",
        "tokensByProjectSubtitle": "إجمالي الرموز المستخدمة لكل مشروع مسجَّل",
        "costByProjectTitle": "التكلفة التقديرية حسب المشروع",
        "costByProjectSubtitle": "التفصيل المالي لاستخدام الذكاء الاصطناعي حسب المشروع",
        "tokensByAgentTitle": "استهلاك الرموز حسب الوكيل",
        "tokensByAgentSubtitle": "استخدام الرموز المتتبَّع لكل وكيل ذكاء اصطناعي",
        "costByAgentTitle": "التكلفة التقديرية حسب الوكيل",
        "costByAgentSubtitle": "الأثر المالي لوكلاء ذكاء اصطناعي محددين",
        "tokensByWorkflowTitle": "استهلاك الرموز حسب مسار العمل",
        "tokensByWorkflowSubtitle": "حجم الرموز الذي عالجته مسارات العمل الآلية",
        "costByWorkflowTitle": "التكلفة التقديرية حسب مسار العمل",
        "costByWorkflowSubtitle": "التكلفة المنسوبة لتنفيذ مسارات عمل الذكاء الاصطناعي",
        "tokensByEnvironmentTitle": "استهلاك الرموز حسب البيئة",
        "tokensByEnvironmentSubtitle": "مقاييس الاستخدام موزّعة حسب بيئات النشر",
        "costByEnvironmentTitle": "التكلفة التقديرية حسب البيئة",
        "costByEnvironmentSubtitle": "التفصيل المالي حسب بيئة النشر",
        "tokensByUsersTitle": "استهلاك الرموز حسب المستخدمين",
        "tokensByUsersSubtitle": "حجم الرموز الذي استخدمه المستخدمون النهائيون",
        "costByUsersTitle": "التكلفة التقديرية حسب المستخدمين",
        "costByUsersSubtitle": "النفقات التشغيلية المنسوبة لمستخدمين محددين",
        "topCostDriversTitle": "أهم محركات التكلفة",
        "topCostDriversSubtitle": "الوكلاء الأكثر استهلاكًا المساهمون في تكاليف المنصة"
      },
      "noDataRange": {
        "projectToken": "لا توجد بيانات رموز حسب المشروع في هذه الفترة.",
        "projectCost": "لا توجد بيانات تكلفة حسب المشروع في هذه الفترة.",
        "agentToken": "لا توجد بيانات رموز حسب الوكيل في هذه الفترة.",
        "agentCost": "لا توجد بيانات تكلفة حسب الوكيل في هذه الفترة.",
        "workflowToken": "لا توجد بيانات رموز حسب مسار العمل في هذه الفترة.",
        "workflowCost": "لا توجد بيانات تكلفة حسب مسار العمل في هذه الفترة.",
        "environmentToken": "لا توجد بيانات رموز حسب البيئة في هذه الفترة.",
        "environmentCost": "لا توجد بيانات تكلفة حسب البيئة في هذه الفترة.",
        "userToken": "لا توجد بيانات رموز حسب المستخدم في هذه الفترة.",
        "userCost": "لا توجد بيانات تكلفة حسب المستخدم في هذه الفترة."
      },
      "barName": {
        "tokens": "الرموز",
        "usd": "دولار أمريكي",
        "models": "النماذج"
      },
      "table": {
        "agent": "الوكيل",
        "totalTokens": "إجمالي الرموز",
        "inputTokens": "رموز الإدخال",
        "outputTokens": "رموز الإخراج",
        "estCost": "التكلفة التقديرية"
      }
    },
    "platform": {
      "kpi": {
        "totalTenants": "إجمالي المستأجرين",
        "totalUsers": "إجمالي المستخدمين",
        "rejectedUsers": "المستخدمون المرفوضون"
      },
      "sections": {
        "userGrowthTitle": "نمو المستخدمين",
        "usersByRoleTitle": "المستخدمون حسب الدور",
        "approvalDecisionsTitle": "قرارات الموافقة",
        "userStatusDistributionTitle": "توزيع حالة المستخدمين",
        "auditActivityTitle": "نشاط التدقيق",
        "tenantOverviewTitle": "نظرة عامة على المستأجرين"
      },
      "series": {
        "newUsers": "مستخدمون جدد",
        "approved": "تمت الموافقة",
        "rejected": "مرفوض"
      },
      "table": {
        "tenant": "المستأجر",
        "users": "المستخدمون",
        "projects": "المشاريع",
        "agents": "الوكلاء",
        "created": "تاريخ الإنشاء"
      }
    }
  },
  "blueprints": {
    "common": {
      "all": "الكل",
      "cancel": "إلغاء",
      "deepThinkingDesc": "تحليل شامل",
      "deepThinkingLabel": "تفكير عميق",
      "delete": "حذف",
      "deleteBlueprintMessage": "إزالة \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteBlueprintTitle": "حذف المخطط؟",
      "dismiss": "تجاهل",
      "expressModeDesc": "توليد سريع ومباشر",
      "expressModeLabel": "الوضع السريع",
      "loading": "جارٍ تحميل المخططات...",
      "modeDeep": "عميق",
      "modeFast": "سريع",
      "noProjectsFound": "لم يتم العثور على مشاريع. يرجى إنشاء مشروع وتحديده للمتابعة.",
      "noSystemBlueprints": "لا توجد مخططات نظام.",
      "proceed": "متابعة",
      "removeAttachedFile": "إزالة الملف المرفق",
      "scopeLibrary": "مخصص",
      "scopeSystem": "النظام",
      "searchAriaLabel": "البحث في المخططات",
      "searchPlaceholder": "البحث في المخططات…",
      "searchSelectProjectPlaceholder": "البحث عن مشروع وتحديده...",
      "selectProjectLabel": "يلزم وجود مشروع للبدء:",
      "selectProjectTitle": "تحديد مشروع",
      "selectThinkingModeTitle": "تحديد وضع التفكير",
      "sourceAriaLabel": "مصدر المخطط",
      "stopRecording": "إيقاف التسجيل",
      "systemBadge": "النظام",
      "systemBadgeTitle": "بداية المنصة — للقراءة فقط",
      "targetAgent": "وكيل",
      "targetWorkflow": "سير عمل",
      "thinkingModeHeader": "وضع التفكير",
      "uploadFile": "رفع ملف",
      "voiceInput": "الإدخال الصوتي"
    },
    "list": {
      "activeBlueprintsTitle": "المخططات النشطة",
      "addToSpotlight": "إضافة إلى الأبرز",
      "archive": "أرشفة",
      "archiveBlueprintMessage": "أرشفة \"{{name}}\"؟ سيتم إخفاؤه من القوائم النشطة.",
      "archiveBlueprintTitle": "أرشفة المخطط؟",
      "archivedBlueprintsTitle": "المخططات المؤرشفة",
      "backTitle": "رجوع",
      "cardActionsAriaLabel": "إجراءات البطاقة",
      "catalogScopeTitle": "نطاق كتالوج المخططات",
      "closeAriaLabel": "إغلاق",
      "delete": "حذف",
      "done": "تم",
      "edit": "تعديل",
      "errorCount": "{{count}} خطأ",
      "export": "تصدير",
      "filters": {
        "status": "الحالة",
        "draft": "مسودة",
        "pendingReview": "قيد المراجعة",
        "pending": "معلّق",
        "approved": "معتمد",
        "archived": "مؤرشف",
        "industry": "التخصص",
        "creator": "المُنشئ"
      },
      "filtersTitle": "عوامل التصفية",
      "fork": "تفريع",
      "goBackAriaLabel": "رجوع",
      "importAriaLabel": "استيراد مخطط",
      "importCompleteHeading": "اكتمل الاستيراد",
      "importErrorSubtitle": "تعذّر استيراد بعض العناصر. راجع التفاصيل أدناه.",
      "importFinishedWithErrorsHeading": "اكتمل الاستيراد مع وجود أخطاء",
      "importSuccessSubtitle": "تم استيراد مخططك كمسودة وهو جاهز للمراجعة.",
      "importTitle": "استيراد مخطط من ملف YAML",
      "loadingMore": "جارٍ تحميل المزيد من المخططات...",
      "newBlueprint": "مخطط جديد",
      "noBlueprintsMatchFilters": "لا توجد مخططات مطابقة لعوامل التصفية.",
      "noBlueprintsYet": "لا توجد مخططات بعد.",
      "pageSubtitle": "مواصفات العمليات لسير العمل الحواري وأداة بناء الوكلاء",
      "pageTitle": "المخططات",
      "refreshAriaLabel": "تحديث القائمة",
      "refreshTitle": "تحديث",
      "removeFromSpotlight": "إزالة من الأبرز",
      "spotlightBadgeTitle": "الأبرز {{rank}} — يُعرض أولًا في صفحة DIP الرئيسية (البدء السريع)",
      "spotlightFullTitle": "قسم الأبرز ممتلئ (الحد الأقصى {{max}}). أزل عنصرًا أولًا.",
      "statCreated": "تم الإنشاء",
      "statFailed": "فشل",
      "statSkipped": "تم التخطي",
      "systemCreatorFallback": "النظام",
      "toasts": {
        "addedToSpotlight": "أُضيف المخطط إلى الأبرز في DIP",
        "archiveFailed": "فشلت الأرشفة",
        "blueprintArchived": "تمت أرشفة المخطط",
        "blueprintDeleted": "تم حذف المخطط",
        "blueprintExported": "تم تصدير المخطط",
        "blueprintForked": "تم تفريع المخطط",
        "blueprintImported": "تم استيراد المخطط",
        "blueprintUnarchived": "تم إلغاء أرشفة المخطط",
        "couldNotAddToSpotlight": "تعذّرت الإضافة إلى الأبرز",
        "couldNotRemoveFromSpotlight": "تعذّرت الإزالة من الأبرز",
        "deleteFailed": "فشل الحذف",
        "exportFailed": "فشل التصدير",
        "forkFailed": "فشل التفريع",
        "importCompletedWithErrors": "اكتمل الاستيراد مع وجود أخطاء",
        "importFailed": "فشل الاستيراد",
        "importedWithWarnings": "تم استيراد المخطط مع {{count}} تحذير",
        "removedFromSpotlight": "تمت الإزالة من الأبرز في DIP",
        "unarchiveFailed": "فشل إلغاء الأرشفة"
      },
      "typeAgent": "وكيل",
      "typeTabsAriaLabel": "نوع المخطط",
      "typeWorkflow": "سير عمل",
      "unarchive": "إلغاء الأرشفة",
      "unarchiveBlueprintMessage": "استعادة \"{{name}}\" إلى حالة المسودة؟",
      "unarchiveBlueprintTitle": "إلغاء أرشفة المخطط؟",
      "warningCount": "{{count}} تحذير"
    }
  },
  "ideate": {
    "aiPrefix": "الذكاء الاصطناعي",
    "backToPlatformAriaLabel": "العودة إلى منصة الذكاء القراري",
    "blueprintDeletedToast": "تم حذف المخطط",
    "blueprintFallback": "مخطط",
    "blueprintLaunchHeader": "إطلاق المخطط",
    "buildWithBlueprint": "البناء باستخدام مخطط",
    "chooseProjectPlaceholder": "اختر مشروعًا…",
    "complianceAriaLabel": "متطلبات الامتثال",
    "complianceLabel": "الامتثال",
    "couldNotOpenSharedSession": "تعذّر فتح الجلسة المشتركة",
    "deleteFailedToast": "فشل الحذف",
    "deleteSessionMessage": "هل أنت متأكد أنك تريد حذف هذه الجلسة؟ لا يمكن التراجع عن هذا الإجراء.",
    "deleteSessionTitle": "حذف الجلسة",
    "deployAriaLabel": "نشر {{name}} باستخدام {{brand}}",
    "deployWithDip": "النشر باستخدام منصة الذكاء القراري",
    "deployWithDipAriaLabel": "نشر {{name}} باستخدام منصة الذكاء القراري",
    "deployWithTitle": "النشر باستخدام {{brand}}",
    "guidedLaunchDesc": "بحث ويب شامل وتوضيح والتحقق عبر النموذج اللغوي",
    "guidedLaunchLabel": "إطلاق موجّه",
    "importHeader": "استيراد",
    "importN8nDesc": "إحضار ملف n8n JSON موجود إلى AI Workflows",
    "importN8nLabel": "استيراد سير عمل n8n",
    "lookingForBlueprints": "جارٍ البحث عن مخططات في هذا التخصص…",
    "moreIndustries": "المزيد",
    "noBlueprintsAvailable": "لا توجد مخططات متاحة. أضف مخططات للمحاولة.",
    "noBlueprintsForFilter": "لا توجد مخططات متاحة لهذا الفلتر.",
    "noBlueprintsForIndustry": "لا توجد مخططات لهذا التخصص.",
    "placeholderAgent": "صف وكيلًا تريد إنشاءه...",
    "placeholderWorkflow": "صف حالة استخدام تريد أتمتتها...",
    "placeholderWorkflowShort": "صف سير عمل تريد أتمتته...",
    "preBuiltBlueprints": "مخططات جاهزة",
    "quickLaunchDesc": "تخطي البحث؛ استخدام إرشادات ومؤشرات أداء المخطط كما هي",
    "quickLaunchLabel": "إطلاق سريع",
    "requireOptTitle": "طلب {{label}}",
    "spotlightBadgeTitleShort": "يُعرض أولًا في صفحة DIP الرئيسية (البدء السريع)",
    "spotlightRank": "الأبرز {{rank}}",
    "tagline": "اكتشف. أعد التصور. حسّن. انطلق فعليًا",
    "untitledSession": "جلسة بلا عنوان",
    "uploadDocumentOrImage": "رفع مستند أو صورة",
    "compliance": {
      "soc2": "SOC 2 / SOX",
      "gdpr": "GDPR / إقامة البيانات",
      "hipaa": "HIPAA",
      "pii": "يتطلب إخفاء البيانات الشخصية (PII)"
    }
  },
  "pipelineDesigner": {
    "list": {
      "searchPlaceholder": "بحث في التصاميم...",
      "emptyMessage": "لا توجد سير عمل منسّق بعد",
      "newWorkflow": "سير عمل منسّق جديد",
      "columnName": "الاسم",
      "columnDescription": "الوصف",
      "columnStatus": "الحالة",
      "columnUpdatedAt": "تاريخ التحديث",
      "columnCreatedAt": "تاريخ الإنشاء",
      "columnActions": "الإجراءات",
      "actionEdit": "تعديل",
      "actionDelete": "حذف",
      "createFailed": "فشل إنشاء التصميم",
      "deleteFailed": "فشل حذف التصميم",
      "deletedToast": "تم حذف التصميم \"{{name}}\"",
      "filterStatusLabel": "الحالة",
      "deleteDialogTitle": "حذف التصميم",
      "deleteDialogMessage": "هل أنت متأكد أنك تريد حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteDialogConfirm": "حذف التصميم",
      "cancel": "إلغاء"
    },
    "status": {
      "draft": "مسودة",
      "published": "منشور",
      "pending": "قيد الانتظار",
      "running": "قيد التشغيل",
      "success": "نجاح",
      "failed": "فشل",
      "cancelled": "ملغى",
      "terminating": "جارٍ الإنهاء",
      "timed_out": "انتهت المهلة",
      "unknown": "غير معروف"
    },
    "canvas": {
      "loading": "جارٍ تحميل التصميم...",
      "tabCanvas": "اللوحة",
      "tabRuns": "التشغيلات",
      "tabSettings": "الإعدادات",
      "publishButton": "نشر وتشغيل",
      "publishDisabledTitle": "اختر اتصال منسّق من علامة تبويب الإعدادات للنشر.",
      "settingsTitle": "إعدادات التصميم",
      "orchestratorRuntimeTitle": "بيئة تشغيل المنسّق",
      "orchestratorRuntimeDesc": "يتطلب النشر اتصال منسّق خاص بالمستأجر يطابق النوع المستهدف. يتم استرداد بيانات الاعتماد من الموصل، ولا يتم تخزينها في الرسم البياني.",
      "targetOrchestratorLabel": "المنسّق المستهدف",
      "saveFailed": "فشل حفظ التصميم",
      "validationFailed": "فشل التحقق من صحة التصميم",
      "publishFailed": "فشل النشر"
    },
    "createDialog": {
      "title": "سير عمل منسّق جديد",
      "closeAria": "إغلاق الحوار",
      "nameLabel": "اسم التصميم",
      "namePlaceholder": "مثال: nightly-feature-batch",
      "descriptionLabel": "الوصف (اختياري)",
      "descriptionPlaceholder": "ملخص قصير للفهرس",
      "orchestratorLabel": "المنسّق المستهدف",
      "orchestratorHint": "يستخدم النشر والتشغيل حاليًا ناشر Enterprise Ontology لـ Databricks Workflows. Vertex AI وAirflow قيد التخطيط.",
      "cancel": "إلغاء",
      "create": "إنشاء",
      "creating": "جارٍ الإنشاء…"
    },
    "publishDialog": {
      "title": "نشر وتشغيل",
      "selectConnectionWarning": "اختر <1>اتصال منسّق</1> من علامة تبويب الإعدادات قبل النشر. تقوم طبقة التنفيذ باسترداد بيانات الاعتماد من هذا الموصل.",
      "translateJobText": "سيؤدي هذا إلى تحويل <1>{{designName}}</1> إلى مهمة <2>{{orchestratorType}}</2>، وإنشائها، وتشغيلها فورًا.",
      "notebookParamsLabel": "معلمات الدفتر (JSON اختياري)",
      "cancel": "إلغاء",
      "publish": "نشر وتشغيل",
      "publishing": "جارٍ النشر...",
      "orchestratorFallback": "المنسّق"
    },
    "nodeConfig": {
      "nodeTitle": "عقدة {{type}}",
      "noConfigurableProps": "لا تحتوي هذه العقدة على خصائص قابلة للتكوين.",
      "taskConfigTitle": "تكوين المهمة",
      "labelLabel": "التسمية",
      "labelPlaceholder": "اسم المهمة",
      "notebookPathLabel": "مسار الدفتر",
      "notebookPathPlaceholder": "/notebooks/my_notebook.py",
      "notebookPathHint": "المسار نسبةً إلى جذر مستودع Git.",
      "timeoutLabel": "المهلة (بالثواني)",
      "maxRetriesLabel": "الحد الأقصى لمحاولات الإعادة",
      "retryOnTimeoutLabel": "إعادة المحاولة عند انتهاء المهلة"
    },
    "canvasEditor": {
      "addTask": "إضافة مهمة",
      "saveNow": "حفظ الآن",
      "allChangesSaved": "تم حفظ جميع التغييرات",
      "saving": "جارٍ الحفظ…",
      "saveFailedUseSaveNow": "فشل الحفظ — استخدم \"حفظ الآن\"",
      "unsavedWillAutoSave": "غير محفوظ — سيتم الحفظ تلقائيًا",
      "delete": "حذف",
      "newTaskLabel": "مهمة جديدة"
    },
    "gitSource": {
      "title": "مصدر Git",
      "repoUrlLabel": "رابط المستودع",
      "repoUrlPlaceholder": "https://github.com/org/repo",
      "providerLabel": "المزوّد",
      "branchLabel": "الفرع",
      "branchPlaceholder": "main",
      "branchError": "أدخل اسم فرع صالحًا (أحرف وأرقام و/ و- و_ و. فقط)."
    },
    "runs": {
      "noRuns": "لا توجد تشغيلات بعد. انشر التصميم لإنشاء تشغيل.",
      "colStatus": "الحالة",
      "colRunId": "معرّف التشغيل",
      "colStarted": "بدأ",
      "colDuration": "المدة",
      "colExternal": "خارجي",
      "colActions": "الإجراءات",
      "runningLabel": "قيد التشغيل...",
      "view": "عرض",
      "cancel": "إلغاء"
    },
    "runDetail": {
      "loading": "جارٍ تحميل تفاصيل التشغيل...",
      "title": "تفاصيل التشغيل",
      "runId": "معرّف التشغيل",
      "externalRunId": "معرّف التشغيل الخارجي",
      "started": "بدأ",
      "completed": "اكتمل",
      "viewInOrchestrator": "عرض في المنسّق",
      "cancelling": "جارٍ الإلغاء...",
      "cancelRun": "إلغاء التشغيل",
      "taskStates": "حالات المهام"
    },
    "orchestratorConnection": {
      "label": "اتصال المنسّق",
      "loadingConnections": "جارٍ تحميل الاتصالات…",
      "optionalSelectToEnable": "اختياري — اختر لتفعيل النشر والتشغيل",
      "noConnections": "لا توجد اتصالات لهذا النوع من المنسّقين.",
      "addOneLink": "أضف واحدًا ضمن الاتصالات ← المنسّقات"
    },
    "nodes": {
      "start": "بداية",
      "end": "نهاية",
      "untitledTask": "مهمة بلا عنوان"
    }
  },
  "agentStudio": {
    "loading": "جارٍ تحميل استوديو الوكلاء...",
    "permissionDeniedMessage": "غير مصرح لك بعرض هذه الصفحة. يُرجى التواصل مع المسؤول.",
    "untitledAgent": "وكيل بلا عنوان",
    "fallbackAgentName": "وكيل",
    "ok": "موافق",
    "closeDialogAriaLabel": "إغلاق مربع الحوار",
    "list": {
      "columnAgentName": "اسم الوكيل",
      "columnProject": "المشروع",
      "columnVersion": "الإصدار",
      "columnStatus": "الحالة",
      "columnCreator": "المنشئ",
      "columnCreatedAt": "تاريخ الإنشاء",
      "columnUpdatedAt": "تاريخ التحديث",
      "columnActions": "الإجراءات",
      "registeredToRegistryTitle": "مسجّل في السجل",
      "emptyFavorites": "لا توجد وكلاء مفضّلة بعد — ضع نجمة على الوكلاء في القائمة لحفظها",
      "emptyArchived": "لا توجد وكلاء مؤرشفة",
      "emptyDefault": "لم يتم العثور على وكلاء",
      "filterFavoritesTitle": "تصفية حسب المفضّلة",
      "allAgents": "جميع الوكلاء",
      "favorites": "المفضّلة",
      "catalogTitle": "كتالوج الوكلاء",
      "activeAgentsTitle": "الوكلاء النشطون",
      "archivedAgentsTitle": "الوكلاء المؤرشفون",
      "guidedTourTitle": "جولة إرشادية في استوديو الوكلاء",
      "autoTune": "ضبط تلقائي",
      "createAgent": "إنشاء وكيل",
      "exportSelected": "تصدير المحدد",
      "archiveSelected": "أرشفة المحدد",
      "exportFileName": "Agent_Studio",
      "exportFileNameArchived": "Agent_Studio_Archived"
    },
    "filters": {
      "status": "الحالة",
      "registryStatus": "حالة السجل",
      "draft": "مسودة",
      "published": "منشور",
      "registered": "مسجّل",
      "unregistered": "غير مسجّل",
      "project": "المشروع",
      "creator": "المنشئ"
    },
    "actions": {
      "restoreToDraft": "استعادة كمسودة",
      "view": "عرض",
      "chat": "محادثة",
      "traces": "التتبعات",
      "logs": "السجلات",
      "exportYaml": "تصدير (YAML)",
      "exportJson": "تصدير (JSON)",
      "evaluate": "تقييم",
      "viewEvaluationRuns": "عرض عمليات التقييم",
      "registerToRegistry": "التسجيل في السجل",
      "registrationPending": "التسجيل قيد الانتظار",
      "unregisterFromRegistry": "إلغاء التسجيل من السجل",
      "clone": "استنساخ",
      "archive": "أرشفة"
    },
    "backLabels": {
      "traces": "التتبعات",
      "blueprint": "المخطط"
    },
    "publishDialog": {
      "title": "نشر الوكيل",
      "confirmHeading": "هل أنت متأكد أنك تريد النشر؟",
      "confirmDescription": "النشر يجعل هذا الوكيل متاحًا للاستخدام. يمكن التراجع عن ذلك بأرشفة الوكيل.",
      "agentLabel": "الوكيل:",
      "frameworkLabel": "الإطار:",
      "nodesLabel": "العُقد:",
      "publishButton": "نشر الوكيل"
    },
    "archiveDialog": {
      "title": "أرشفة الوكيل",
      "publishedHeading": "هذا الوكيل منشور",
      "publishedDescription": "للأرشفة، أوقف أولاً أي قائمة في متجر الوكلاء، وأرشف النشر في المراقبة، وألغِ التسجيل من سجل الوكلاء إن كان ما زال مسجّلًا. سينتقل الوكيل إلى قائمة المؤرشف عند إتمام ذلك.",
      "confirmMessage": "هل أنت متأكد أنك تريد أرشفة \"{{name}}\"؟",
      "checkingDependencies": "جارٍ التحقق من التبعيات…",
      "archiveButton": "أرشفة الوكيل",
      "draftConfirmMessage": "أرشفة \"{{name}}\"؟ سيظهر تحت المؤرشف؛ يمكنك استعادته كمسودة أو حذفه نهائيًا."
    },
    "deleteDialog": {
      "title": "حذف الوكيل",
      "confirmMessage": "حذف \"{{name}}\" نهائيًا؟ سيُزال الوكيل من النظام ولا يمكن التراجع."
    },
    "bulkArchive": {
      "title_one": "أرشفة وكيل",
      "title_other": "أرشفة وكلاء",
      "confirmMessage": "أرشفة {{count}} وكيل(وكلاء)؟ ستظهر تحت المؤرشف؛ يمكنك استعادتها كمسودات أو حذفها نهائيًا.",
      "confirmButton": "أرشفة",
      "failureMessage": "فشل أرشفة الوكلاء",
      "blockedMessage": "\"{{name}}\" لديه تبعيات يجب إزالتها قبل الأرشفة."
    },
    "blockedDialogs": {
      "cannotArchiveTitle": "لا يمكن أرشفة الوكيل بعد",
      "cannotUnregisterTitle": "لا يمكن الإزالة من السجل بعد",
      "unregisterDependenciesMessage": "أزل قوائم متجر الوكلاء وأرشف النشر قبل إزالة هذا الوكيل من سجل الوكلاء.",
      "dependenciesMustBeCleared": "يجب إزالة التبعيات أولاً."
    },
    "registerDialog": {
      "title": "التسجيل في السجل",
      "submitHeading": "إرسال لموافقة المسؤول",
      "submitDescription": "يُرسل طلب تسجيل إلى مسؤولي المستأجر. لن يظهر الوكيل في سجل الوكلاء حتى يوافق المسؤول ضمن الإعدادات العامة → موافقات الطلبات.",
      "confirmMessage": "إرسال طلب تسجيل لـ \"{{name}}\"؟",
      "metadata": "البيانات الوصفية",
      "submitting": "جارٍ الإرسال...",
      "submitRequest": "إرسال الطلب"
    },
    "deletePrerequisites": {
      "stillRegistered": "هذا الوكيل ما زال مسجّلًا في سجل الوكلاء.",
      "activeStoreListing": "يوجد قائمة نشطة في متجر الوكلاء لهذا الوكيل.",
      "nonArchivedDeployments": "توجد نشرات وكيل غير مؤرشفة بعد.",
      "clearBeforeArchive": "{{details}} أزل هذه قبل أن تتمكن من الأرشفة."
    },
    "blockerMessages": {
      "registry": "ألغِ تسجيل هذا الوكيل من سجل الوكلاء قبل الأرشفة.",
      "agent_store": "أوقف القائمة النشطة في متجر الوكلاء قبل أرشفة هذا الوكيل.",
      "agent_deployments": "أرشف جميع نشرات هذا الوكيل في المراقبة قبل الأرشفة.",
      "agent_store_unregister": "أوقف القائمة النشطة قبل إزالة هذا الوكيل من سجل الوكلاء.",
      "agent_deployments_unregister": "أرشف جميع النشر في المراقبة قبل إزالة هذا الوكيل من سجل الوكلاء."
    },
    "blockerNav": {
      "registry": "فتح سجل الوكلاء",
      "workflow_registry": "فتح سجل سير العمل",
      "agent_store": "فتح متجر الوكلاء (إدارة)",
      "agent_deployments": "فتح المراقبة — النشر",
      "workflow_store": "فتح متجر سير العمل (إدارة)",
      "workflow_deployments": "فتح المراقبة — النشر",
      "running_executions": "فتح التشغيلات"
    }
  },
  "projects": {
    "status": {
      "active": "نشط",
      "draft": "مسودة",
      "archived": "مؤرشف",
      "error": "خطأ",
      "pending": "قيد الانتظار"
    },
    "list": {
      "permissionDeniedMessage": "ليس لديك إذن لعرض المشاريع. يرجى التواصل مع المسؤول.",
      "loading": "جارٍ تحميل المشاريع...",
      "columnName": "اسم المشروع",
      "columnMembers": "الأعضاء",
      "columnStatus": "الحالة",
      "columnActions": "الإجراءات",
      "filterCreatorLabel": "المنشئ",
      "actionOpen": "فتح",
      "actionConfigure": "تهيئة",
      "actionEdit": "تعديل",
      "actionDelete": "حذف",
      "bulkDeleteSelected": "حذف المحدد",
      "emptyMessage": "لم يتم العثور على مشاريع",
      "createProject": "إنشاء مشروع",
      "setupWizard": "معالج الإعداد",
      "setupWizardTooltip": "معالج الإعداد - استيراد ملفات YAML لإنشاء مشروع",
      "deleteDialogTitle": "حذف المشروع",
      "deleteDialogMessage": "هل أنت متأكد أنك تريد حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
      "fetchingDependenciesMessage": "جارٍ جلب تبعيات المشروع…",
      "forceDeleteDialogTitle": "تأكيد الحذف القسري",
      "forceDeleteDialogMessage": "سيؤدي الحذف القسري إلى إزالة \"{{name}}\" بشكل دائم مع جميع الوكلاء وعمليات النشر وعناصر Agent Store وعمليات المحاكاة والمطالبات (Prompts) والمهارات والأدوات وبيانات المشروع الأخرى. لا يمكن التراجع عن هذا الإجراء.",
      "forceDeleteConfirmLabel": "حذف المشروع قسريًا",
      "bulkDeleteDialogTitle": "حذف المشاريع المحددة",
      "bulkDeleteConfirmMessage_zero": "لم يتم تحديد أي مشاريع للحذف. لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteConfirmMessage_one": "هل أنت متأكد أنك تريد حذف مشروع واحد؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteConfirmMessage_two": "هل أنت متأكد أنك تريد حذف مشروعين؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteConfirmMessage_few": "هل أنت متأكد أنك تريد حذف {{count}} مشاريع؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteConfirmMessage_many": "هل أنت متأكد أنك تريد حذف {{count}} مشروعًا؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteConfirmMessage_other": "هل أنت متأكد أنك تريد حذف {{count}} مشروع؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteConfirmLabel_zero": "حذف المشاريع المحددة",
      "bulkDeleteConfirmLabel_one": "حذف مشروع واحد",
      "bulkDeleteConfirmLabel_two": "حذف مشروعين",
      "bulkDeleteConfirmLabel_few": "حذف {{count}} مشاريع",
      "bulkDeleteConfirmLabel_many": "حذف {{count}} مشروعًا",
      "bulkDeleteConfirmLabel_other": "حذف {{count}} مشروع",
      "forceDeleteSuccessToast": "تم حذف المشروع \"{{name}}\" قسريًا",
      "forceDeleteErrorToast": "فشل الحذف القسري. أزل التبعيات المتبقية أو حاول مرة أخرى.",
      "noProjectsSelectedWarning": "لم يتم تحديد أي مشاريع",
      "bulkDeletePartialWarning": "تم حذف {{deleted}} مشروع، وفشل {{skipped}}: {{errors}}",
      "bulkDeleteSuccessToast": "تم حذف {{deleted}} مشروع بنجاح",
      "bulkDeleteErrorToast": "فشل حذف المشاريع",
      "andOthers": "و {{count}} أخرى"
    },
    "createDialog": {
      "title": "إنشاء مشروع جديد",
      "closeAriaLabel": "إغلاق مربع الحوار",
      "loadingQuota": "جارٍ تحميل الحصة...",
      "quotaLabel": "المشاريع",
      "nameLabel": "اسم المشروع *",
      "namePlaceholder": "أدخل اسم المشروع",
      "descriptionLabel": "الوصف",
      "descriptionPlaceholder": "وصف موجز للمشروع",
      "descriptionEmojiError": "لا يمكن أن يحتوي الوصف على رموز تعبيرية. استخدم نصًا عاديًا فقط.",
      "quotaExceededTitle": "تم تجاوز حصة المشاريع",
      "creating": "جارٍ الإنشاء..."
    },
    "editDialog": {
      "title": "تعديل المشروع",
      "closeAriaLabel": "إغلاق مربع الحوار",
      "nameLabel": "اسم المشروع *",
      "descriptionLabel": "الوصف",
      "saving": "جارٍ الحفظ...",
      "saveChanges": "حفظ التغييرات"
    },
    "actions": {
      "view": "عرض",
      "edit": "تعديل",
      "chat": "محادثة",
      "traces": "التتبعات",
      "logs": "السجلات",
      "evaluate": "تقييم",
      "viewEvaluationRuns": "عرض عمليات تشغيل التقييم",
      "cloneInAgentStudio": "استنساخ في استوديو الوكلاء",
      "openInAgentStudio": "فتح في استوديو الوكلاء",
      "manageArchiveInStudio": "إدارة الأرشيف في Studio",
      "open": "فتح",
      "runs": "عمليات التشغيل",
      "editCanvas": "تعديل اللوحة",
      "viewInStudio": "عرض في Studio",
      "testChat": "اختبار / محادثة",
      "deployInRegistry": "نشر في Registry",
      "guardrails": "الضوابط الوقائية",
      "chatDetail": "محادثة / تفاصيل",
      "runtimeSettings": "إعدادات وقت التشغيل",
      "openInMonitoring": "فتح في Monitoring"
    },
    "detail": {
      "notFound": "المشروع غير موجود",
      "backToProjectsButton": "العودة إلى المشاريع",
      "backToProjectsAriaLabel": "العودة إلى المشاريع",
      "viewOnlyBadge": "للعرض فقط",
      "tabsAriaLabel": "علامات تبويب تفاصيل المشروع",
      "tabs": {
        "overview": "نظرة عامة",
        "agents": "الوكلاء",
        "workflows": "مسارات العمل",
        "registry": "السجل",
        "evals": "التقييمات",
        "deployments": "عمليات النشر"
      }
    },
    "overview": {
      "hubSubtitle": "مركز المشروع",
      "noTabsAvailable": "لا توجد علامات تبويب تفاصيل متاحة لدورك.",
      "openInBrand": "فتح {{label}} في {{brand}}",
      "cards": {
        "agents": "الوكلاء",
        "workflows": "مسارات العمل",
        "registry": "المسجَّلة",
        "evals": "وكلاء التقييم",
        "deployments": "عمليات النشر النشطة"
      }
    },
    "members": {
      "title": "الأعضاء",
      "refreshTooltip": "تحديث قائمة الأعضاء",
      "addMemberButton": "إضافة عضو",
      "selectedCount": "تم تحديد {{count}}",
      "changeRoleButton": "تغيير الدور",
      "remove": "إزالة",
      "clearButton": "مسح",
      "selectAllButton": "تحديد الكل",
      "noMembersYet": "لا يوجد أعضاء بعد",
      "selectAll": "تحديد الكل",
      "deselectAll": "إلغاء تحديد الكل",
      "unknown": "غير معروف",
      "creatorBadge": "المنشئ",
      "role": {
        "member": "عضو",
        "admin": "مسؤول",
        "viewer": "مُشاهد",
        "creator": "المنشئ"
      },
      "memberSince": "عضو منذ {{date}}",
      "changeRoleTitle": "تغيير الدور",
      "memberFallbackName": "عضو",
      "select": "تحديد",
      "deselect": "إلغاء التحديد",
      "removeMembersTitle": "إزالة الأعضاء",
      "removeMemberTitle": "إزالة العضو",
      "removeMembersMessage": "هل أنت متأكد أنك تريد إزالة {{count}} عضو من هذا المشروع؟ لا يمكن التراجع عن هذا الإجراء.",
      "removeMemberMessage": "هل أنت متأكد أنك تريد إزالة \"{{name}}\" من هذا المشروع؟ لا يمكن التراجع عن هذا الإجراء.",
      "changeRoleForCount_zero": "تغيير الدور لعدد {{count}} من الأعضاء",
      "changeRoleForCount_one": "تغيير دور عضو واحد",
      "changeRoleForCount_two": "تغيير دور عضوين",
      "changeRoleForCount_few": "تغيير الدور لعدد {{count}} أعضاء",
      "changeRoleForCount_many": "تغيير الدور لعدد {{count}} عضوًا",
      "changeRoleForCount_other": "تغيير الدور لعدد {{count}} عضو",
      "selectNewRoleLabel": "اختر الدور الجديد",
      "updating": "جارٍ التحديث...",
      "updateRole": "تحديث الدور",
      "loadErrorFallback": "تعذر تحميل الأعضاء. يرجى تحديث الصفحة.",
      "selectAtLeastOneUserError": "يرجى اختيار مستخدم واحد على الأقل",
      "addedSuccessToast_zero": "لم تتم إضافة أي أعضاء",
      "addedSuccessToast_one": "تمت إضافة عضو واحد بنجاح",
      "addedSuccessToast_two": "تمت إضافة عضوين بنجاح",
      "addedSuccessToast_few": "تمت إضافة {{count}} أعضاء بنجاح",
      "addedSuccessToast_many": "تمت إضافة {{count}} عضوًا بنجاح",
      "addedSuccessToast_other": "تمت إضافة {{count}} عضو بنجاح",
      "removedSuccessToast": "تمت إزالة العضو بنجاح",
      "roleUpdatedSuccessToast": "تم تحديث دور العضو بنجاح",
      "bulkRoleUpdatedWithErrorsToast": "تم تحديث {{updated}} عضو. حدثت {{errorCount}} أخطاء.",
      "bulkRoleUpdatedSuccessToast": "تم تحديث دور {{updated}} عضو بنجاح",
      "bulkRemovedWithErrorsToast": "تمت إزالة {{removed}} عضو. حدثت {{errorCount}} أخطاء.",
      "bulkRemovedSuccessToast": "تمت إزالة {{removed}} عضو بنجاح"
    },
    "configure": {
      "tabsAriaLabel": "علامات تبويب إعداد المشروع",
      "tabs": {
        "members": "الأعضاء",
        "orchestrators": "المنسّقون",
        "prompts": "المطالبات",
        "models": "النماذج",
        "tools": "الأدوات",
        "skills": "المهارات",
        "knowledge": "المعرفة",
        "graph": "الرسم البياني",
        "vector": "المتجهات",
        "storage": "التخزين"
      }
    },
    "setupWizard": {
      "title": "معالج إعداد المشروع",
      "projectFieldLabel": "المشروع",
      "projectFieldPlaceholder": "اختر مشروعًا...",
      "projectFieldRequiredLabel": "المشروع *",
      "projectNameFieldName": "اسم المشروع",
      "projectNameFieldRequiredLabel": "اسم المشروع *",
      "projectNamePlaceholder": "مشروعي الرائع",
      "orDivider": "أو",
      "createNewProject": "إنشاء مشروع جديد",
      "descriptionFieldLabel": "الوصف",
      "descriptionPlaceholder": "وصف موجز...",
      "filesImportedIntoSelectedProject": "سيتم استيراد الملفات إلى المشروع المحدد",
      "dropzoneAriaLabel": "تحميل ملفات YAML. اسحب الملفات وأفلتها هنا، أو انقر أو اضغط Enter أو Space للتصفح.",
      "dropzoneText": "أفلت الملفات هنا أو انقر للتصفح",
      "dropzoneHint": ".yaml، .yml — الوكلاء، النماذج، الأدوات، المطالبات، المهارات، المعرفة، الموصلات، IAM",
      "validFilesCount": "{{count}} ملف صالح",
      "filesWithErrorsCount": "{{count}} بها أخطاء",
      "noAgentYamlWarning": "لم يتم اكتشاف YAML للوكيل. ضع في اعتبارك إضافة تكوين وكيل.",
      "reviewStepTitle": "مراجعة ترتيب الاستيراد",
      "reviewStepDescription": "سيتم استيراد الملفات بالترتيب التالي بناءً على التبعيات:",
      "filesWithErrorsSkipped": "سيتم تخطي {{count}} ملف بها أخطاء",
      "importingStepTitle": "جارٍ الاستيراد...",
      "importingProgress": "جارٍ استيراد {{current}} من {{total}}: {{fileName}}",
      "importActions": {
        "created": "تم الإنشاء",
        "matched": "تمت المطابقة",
        "failed": "فشل"
      },
      "completeStepTitleSuccess": "اكتمل الإعداد!",
      "completeStepTitleWithErrors": "اكتمل الإعداد مع وجود أخطاء",
      "completeStepDescription": "تم إعداد مشروعك بالكيانات التالية:",
      "summaryBadges": {
        "created": "+{{count}} تم الإنشاء",
        "matched": "{{count}} تمت المطابقة",
        "failed": "{{count}} فشل"
      },
      "errorsHeading": "الأخطاء:",
      "steps": {
        "selectProject": "تحديد المشروع",
        "addFiles": "إضافة ملفات",
        "review": "مراجعة",
        "import": "استيراد"
      },
      "creatingLabel": "جارٍ الإنشاء...",
      "createAndContinue": "إنشاء ومتابعة",
      "continueLabel": "متابعة",
      "reviewImport": "مراجعة الاستيراد",
      "startImport": "بدء الاستيراد",
      "importingLabel": "جارٍ الاستيراد...",
      "goToProject": "الانتقال إلى المشروع",
      "entityTypes": {
        "agent": "وكيل",
        "model": "نموذج",
        "tool": "أداة",
        "prompt": "موجه",
        "skill": "مهارة",
        "knowledge": "معرفة",
        "connector": "موصل",
        "iam": "إدارة الهوية والوصول",
        "bundle": "حزمة",
        "unknown": "غير معروف"
      },
      "toasts": {
        "dropYamlFiles": "يرجى إفلات ملفات YAML",
        "enterProjectName": "يرجى إدخال اسم المشروع",
        "projectCreated": "تم إنشاء المشروع \"{{name}}\"",
        "selectProject": "يرجى تحديد مشروع",
        "projectSelected": "تم تحديد المشروع \"{{name}}\"",
        "addAtLeastOneFile": "يرجى إضافة ملف YAML واحد على الأقل",
        "noValidYamlFiles": "لم يتم العثور على ملفات YAML صالحة",
        "projectNotCreated": "لم يتم إنشاء المشروع",
        "noValidFilesToImport": "لا توجد ملفات صالحة للاستيراد",
        "importReportedFailure": "أفاد استيراد {{name}} بفشل العملية",
        "allImportedSuccessfully": "تم استيراد جميع الكيانات بنجاح!",
        "importPermissionError": "فشل الاستيراد بسبب عدم كفاية الأذونات. يرجى الاتصال بالمسؤول لديك.",
        "importCompletedWithErrors": "اكتمل الاستيراد مع {{count}} خطأ"
      },
      "unknownProject": "غير معروف"
    },
    "agentsTab": {
      "agentStatusTitle": "حالة الوكيل",
      "activeAgentsTitle": "الوكلاء النشطون",
      "archivedAgentsTitle": "الوكلاء المؤرشفون",
      "openInAgentStudio": "فتح في استوديو الوكلاء",
      "noArchivedAgents": "لا يوجد وكلاء مؤرشفون في هذا المشروع.",
      "noAgents": "لا يوجد وكلاء في هذا المشروع.",
      "goToAgentStudio": "الانتقال إلى استوديو الوكلاء",
      "archiveDialogTitle": "أرشفة {{count}} وكيل",
      "archiveDialogMessage": "هل تريد أرشفة {{count}} وكيل؟ ستظهر ضمن المؤرشف؛ يمكنك استعادتها كمسودات أو حذفها نهائيًا من هناك.",
      "archiveButtonLabel": "أرشفة",
      "archivedWithSkippedToast": "تمت أرشفة {{deleted}} وكيل، وتم تخطي {{skipped}} بسبب تبعيات نشطة.",
      "archivedToast": "تمت أرشفة {{count}} وكيل",
      "exportSelected": "تصدير المحدد",
      "archiveSelected": "أرشفة المحدد",
      "columns": {
        "name": "الاسم",
        "status": "الحالة",
        "framework": "إطار العمل",
        "creator": "المنشئ",
        "createdAt": "تاريخ الإنشاء",
        "updatedAt": "تاريخ التحديث",
        "actions": "الإجراءات"
      },
      "searchPlaceholder": "البحث عن الوكلاء…"
    },
    "workflowsTab": {
      "statusPublished": "منشور",
      "columns": {
        "workflow": "سير العمل",
        "status": "الحالة",
        "schedule": "الجدولة",
        "controls": "عناصر التحكم",
        "creator": "المنشئ",
        "runs": "عمليات التشغيل",
        "createdAt": "تاريخ الإنشاء",
        "tags": "الوسوم",
        "actions": "الإجراءات"
      },
      "registeredToRegistryAtVersion": "مسجل في السجل بالإصدار v{{version}}",
      "registeredToRegistry": "مسجل في السجل",
      "scheduleActive": "الجدولة نشطة",
      "schedulePaused": "الجدولة متوقفة مؤقتًا",
      "notScheduled": "غير مجدول",
      "draftCadenceTooltip": "تم حفظ التكرار في المسودة — انشر لبدء الجدولة ({{cadence}}).",
      "neverRun": "لم يتم التشغيل مطلقًا",
      "lastRunTitle": "آخر تشغيل",
      "searchPlaceholder": "البحث عن سير العمل…",
      "clearSearch": "مسح البحث",
      "totalWorkflows": "إجمالي سير العمل {{count}}",
      "catalogTitle": "الكتالوج",
      "activeWorkflowsTitle": "سير العمل النشط",
      "archivedWorkflowsTitle": "سير العمل المؤرشف",
      "gridViewTitle": "عرض الشبكة",
      "listViewTitle": "عرض القائمة",
      "openInAgentWorkflows": "فتح في سير عمل الوكلاء",
      "noSearchResults": "لا يوجد سير عمل يطابق بحثك.",
      "noArchivedWorkflows": "لا يوجد سير عمل مؤرشف في هذا المشروع.",
      "noWorkflows": "لا يوجد سير عمل في هذا المشروع.",
      "goToAgentWorkflows": "الانتقال إلى سير عمل الوكلاء",
      "lastRunStatusTooltip": "حالة آخر تشغيل: {{status}}",
      "lastRunTooltip": "آخر تشغيل: {{time}}",
      "updatedTooltip": "تم التحديث: {{time}}",
      "noDescriptionProvided": "لم يتم تقديم وصف",
      "runsCount": "{{count}} عملية تشغيل",
      "lastRunLabel": "آخر تشغيل {{time}}",
      "pageOfTotal": "صفحة {{page}} من {{totalPages}}",
      "versionTitle": "الإصدار"
    },
    "skillsTab": {
      "loadError": "فشل تحميل المهارات",
      "requestedAccessToast": "تم طلب الوصول إلى {{count}} مهارة (بانتظار الموافقة)",
      "addedToast": "تمت إضافة {{count}} مهارة إلى المشروع",
      "alreadyInProjectToast": "{{count}} مهارة موجودة بالفعل في المشروع",
      "addFailedToast": "فشلت إضافة {{count}} مهارة",
      "removedToast": "تمت إزالة المهارة من المشروع",
      "bulkRemovedToast": "تمت إزالة {{count}} مهارة بنجاح من المشروع",
      "bulkRemoveFailedToast": "فشلت إزالة {{count}} مهارة",
      "removeFromProject": "إزالة من المشروع",
      "pending": "قيد الانتظار",
      "platform": "منصة",
      "allModels": "جميع النماذج",
      "columns": {
        "name": "اسم المهارة",
        "category": "الفئة",
        "type": "النوع",
        "model": "النموذج",
        "version": "الإصدار",
        "added": "تمت الإضافة",
        "lastUpdated": "آخر تحديث",
        "actions": "الإجراءات"
      },
      "errorBoundaryMessage": "تعذر تحميل المهارات. يرجى تحديث الصفحة.",
      "emptyMessage": "لا توجد مهارات مهيأة لهذا المشروع",
      "addSkill": "إضافة مهارة",
      "addSkillsToProjectTitle": "إضافة مهارات إلى المشروع",
      "showApprovedSkills": "إظهار المهارات المعتمدة",
      "removeDialogTitle": "إزالة المهارة",
      "removeDialogMessage": "إزالة \"{{name}}\" من هذا المشروع؟",
      "remove": "إزالة",
      "bulkRemoveDialogTitle": "إزالة المهارات",
      "bulkRemoveDialogMessage": "هل أنت متأكد أنك تريد إزالة {{count}} مهارة محددة من هذا المشروع؟"
    },
    "toolsTab": {
      "requestedAccessToast": "تم طلب الوصول إلى {{count}} أداة (بانتظار الموافقة)",
      "alreadyInProjectToast": "{{count}} أداة موجودة بالفعل في المشروع",
      "addFailedToast": "فشلت إضافة {{count}} أداة",
      "removedToast": "تمت إزالة الأداة من المشروع",
      "bulkRemovedToast": "تمت إزالة {{count}} أداة بنجاح من المشروع",
      "bulkRemoveFailedToast": "فشلت إزالة {{count}} أداة: {{errors}}",
      "removeFromProject": "إزالة من المشروع",
      "exportSelected": "تصدير المحدد",
      "pending": "قيد الانتظار",
      "columns": {
        "name": "اسم الأداة",
        "type": "النوع",
        "endpoint": "نقطة النهاية",
        "created": "تاريخ الإنشاء",
        "lastUpdated": "آخر تحديث",
        "actions": "الإجراءات"
      },
      "errorBoundaryMessage": "تعذر تحميل الأدوات. يرجى تحديث الصفحة.",
      "emptyMessage": "لا توجد أدوات مهيأة لهذا المشروع",
      "addTool": "إضافة أداة",
      "addToolsToProjectTitle": "إضافة أدوات إلى المشروع",
      "showApprovedTools": "إظهار الأدوات المعتمدة",
      "removeDialogTitle": "إزالة الأداة",
      "removeDialogMessage": "إزالة \"{{name}}\" من هذا المشروع؟",
      "remove": "إزالة",
      "bulkRemoveDialogTitle": "إزالة الأدوات",
      "bulkRemoveDialogMessage": "هل أنت متأكد أنك تريد إزالة {{count}} أداة محددة من هذا المشروع؟"
    },
    "modelsTab": {
      "requestedAccessToast": "تم طلب الوصول إلى {{count}} نموذج (بانتظار الموافقة)",
      "alreadyInProjectToast": "{{count}} نموذج موجود بالفعل في المشروع",
      "addFailedToast": "تعذرت إضافة {{count}} نموذج",
      "removedToast": "تمت إزالة النموذج بنجاح",
      "bulkRemovedToast": "تمت إزالة {{count}} نموذج بنجاح من المشروع",
      "bulkRemoveFailedToast": "فشلت إزالة {{count}} نموذج: {{errors}}",
      "removeFromProject": "إزالة من المشروع",
      "pending": "قيد الانتظار",
      "columns": {
        "name": "اسم النموذج",
        "provider": "المزوّد",
        "modelId": "معرّف النموذج",
        "created": "تاريخ الإنشاء",
        "lastUpdated": "آخر تحديث",
        "actions": "الإجراءات"
      },
      "errorBoundaryMessage": "تعذر تحميل النماذج. يرجى تحديث الصفحة.",
      "emptyMessage": "لا توجد نماذج مهيأة لهذا المشروع",
      "addModel": "إضافة نموذج",
      "addModelsToProjectTitle": "إضافة نماذج إلى المشروع",
      "showApprovedModels": "إظهار النماذج المعتمدة",
      "removeDialogTitle": "إزالة النموذج",
      "removeDialogMessage": "إزالة \"{{name}}\" من هذا المشروع؟",
      "remove": "إزالة",
      "bulkRemoveDialogTitle": "إزالة النماذج",
      "bulkRemoveDialogMessage": "هل أنت متأكد أنك تريد إزالة {{count}} نموذج محدد من هذا المشروع؟"
    },
    "orchestratorsTab": {
      "selectAtLeastOne": "يرجى تحديد منسق واحد على الأقل",
      "requestedAccessToast": "تم طلب الوصول إلى {{count}} منسق (بانتظار الموافقة)",
      "removedToast": "تمت إزالة \"{{name}}\" من المشروع",
      "bulkRemovedToast": "تمت إزالة {{count}} منسق بنجاح من المشروع",
      "bulkRemoveFailedToast": "فشلت إزالة {{count}} منسق: {{errors}}",
      "removeFromProject": "إزالة من المشروع",
      "testConnection": "اختبار الاتصال",
      "testConnectionSuccess": "نجح اختبار الاتصال لـ \"{{name}}\"",
      "testConnectionFailure": "فشل اختبار الاتصال لـ \"{{name}}\": {{message}}",
      "columns": {
        "name": "الاسم",
        "type": "النوع",
        "host": "المضيف",
        "status": "الحالة",
        "addedBy": "أضافه",
        "addedAt": "تاريخ الإضافة",
        "actions": "الإجراءات"
      },
      "errorBoundaryMessage": "تعذر تحميل المنسقين. يرجى تحديث الصفحة.",
      "emptyMessage": "لا يوجد منسقون مهيؤون لهذا المشروع",
      "addOrchestrator": "إضافة منسق",
      "addOrchestratorsToProjectTitle": "إضافة منسقين إلى المشروع",
      "removeDialogTitle": "إزالة المنسق",
      "removeDialogMessage": "إزالة \"{{name}}\" من هذا المشروع؟",
      "remove": "إزالة",
      "bulkRemoveDialogTitle": "إزالة المنسقين",
      "bulkRemoveDialogMessage": "هل أنت متأكد أنك تريد إزالة {{count}} منسق محدد من هذا المشروع؟"
    },
    "knowledgeTab": {
      "unknown": "غير معروف",
      "vectorDatabase": "قاعدة بيانات متجهية",
      "vectorDbBadge": "قاعدة بيانات متجهية",
      "schemaTitle": "المخطط: {{schema}}",
      "searchPlaceholder": "البحث في الجداول...",
      "clearSearch": "مسح البحث",
      "columns": {
        "name": "الاسم",
        "database": "قاعدة البيانات",
        "rows": "الصفوف",
        "status": "الحالة",
        "creator": "المُنشئ",
        "actions": "الإجراءات"
      },
      "status": {
        "error": "خطأ",
        "active": "نشط",
        "syncing": "جارٍ المزامنة",
        "pending": "قيد الانتظار"
      },
      "actions": {
        "previewData": "معاينة البيانات",
        "removeFromProject": "إزالة من المشروع",
        "remove": "إزالة"
      },
      "toasts": {
        "requestedAccess": "تم طلب الوصول إلى {{count}} من {{tableLabel}}{{plural}} (بانتظار الموافقة)",
        "alreadyInProject": "{{count}} من {{tableLabel}}{{plural}} موجودة بالفعل في المشروع",
        "requestAccessFailed": "فشل طلب الوصول إلى {{count}} من {{tableLabel}}{{plural}}",
        "removed": "تمت إزالة جدول المعرفة من المشروع",
        "bulkRemoved": "تمت إزالة {{count}} من جداول {{typeLabel}}{{plural}} من المشروع بنجاح",
        "bulkRemoveFailed": "فشلت إزالة {{count}} من جداول {{typeLabel}}{{plural}}: {{errors}}"
      },
      "removeDialogMessage": "هل تريد إزالة \"{{name}}\" من هذا المشروع؟",
      "bulkRemoveDialogMessage": "هل أنت متأكد أنك تريد إزالة {{count}} من الجداول المحددة من هذا المشروع؟",
      "viewToggle": {
        "database": "عرض قاعدة البيانات",
        "collection": "عرض المجموعة"
      },
      "variant": {
        "knowledge": {
          "tableLabel": "جدول معرفة",
          "typeLabel": "المعرفة",
          "addButton": "إضافة معرفة",
          "emptyMessage": "لا توجد جداول معرفة مهيأة لهذا المشروع",
          "addModalTitle": "إضافة معرفة إلى المشروع",
          "membershipToggleLabel": "إظهار الجداول المعتمدة",
          "removeDialogTitle": "إزالة جدول المعرفة",
          "removeDialogTitlePlural": "إزالة جداول المعرفة",
          "errorBoundaryMessage": "تعذر تحميل جداول المعرفة. يرجى تحديث الصفحة."
        },
        "graph": {
          "tableLabel": "جدول رسم بياني",
          "typeLabel": "الرسم البياني",
          "addButton": "إضافة رسم بياني",
          "emptyMessage": "لا توجد جداول رسم بياني مهيأة لهذا المشروع",
          "addModalTitle": "إضافة جداول رسم بياني إلى المشروع",
          "membershipToggleLabel": "إظهار جداول الرسم البياني المعتمدة",
          "removeDialogTitle": "إزالة جدول الرسم البياني",
          "removeDialogTitlePlural": "إزالة جداول الرسم البياني",
          "errorBoundaryMessage": "تعذر تحميل جداول الرسم البياني. يرجى تحديث الصفحة."
        },
        "vector": {
          "tableLabel": "جدول متجهي",
          "typeLabel": "المتجه",
          "addButton": "إضافة متجه",
          "emptyMessage": "لا توجد جداول متجهية مهيأة لهذا المشروع",
          "addModalTitle": "إضافة جداول متجهية إلى المشروع",
          "membershipToggleLabel": "إظهار الجداول المتجهية المعتمدة",
          "removeDialogTitle": "إزالة الجدول المتجهي",
          "removeDialogTitlePlural": "إزالة الجداول المتجهية",
          "errorBoundaryMessage": "تعذر تحميل الجداول المتجهية. يرجى تحديث الصفحة."
        }
      }
    },
    "storageTab": {
      "unknown": "غير معروف",
      "addButton": "إضافة تخزين",
      "addModalTitle": "إضافة تخزين إلى المشروع",
      "emptyMessage": "لا توجد مجلدات تخزين مهيأة لهذا المشروع",
      "errorBoundaryMessage": "تعذر تحميل مجلدات التخزين. يرجى تحديث الصفحة.",
      "membershipToggleLabel": "إظهار التخزين المعتمد",
      "removeDialogTitle": "إزالة مجلد التخزين",
      "removeDialogTitlePlural": "إزالة مجلدات التخزين",
      "removeDialogMessage": "هل تريد إزالة \"{{name}}\" من هذا المشروع؟",
      "bulkRemoveDialogMessage": "هل أنت متأكد أنك تريد إزالة {{count}} من مجلدات التخزين المحددة من هذا المشروع؟",
      "columns": {
        "folder": "المجلد",
        "connector": "الموصل",
        "files": "الملفات",
        "size": "الحجم",
        "status": "الحالة",
        "creator": "المُنشئ",
        "actions": "الإجراءات"
      },
      "status": {
        "active": "نشط",
        "error": "خطأ",
        "pending": "قيد الانتظار"
      },
      "actions": {
        "previewFiles": "معاينة الملفات",
        "sync": "مزامنة",
        "syncing": "جارٍ المزامنة...",
        "removeFromProject": "إزالة من المشروع",
        "remove": "إزالة"
      },
      "toasts": {
        "requestedAccess": "تم طلب الوصول إلى {{count}} من مجلدات التخزين{{plural}} (بانتظار الموافقة)",
        "alreadyInProject": "{{count}} من مجلدات التخزين{{plural}} موجودة بالفعل في المشروع",
        "addFailed": "فشلت إضافة {{count}} من مجلدات التخزين{{plural}}",
        "synced": "تمت مزامنة بيانات \"{{name}}\" الوصفية.",
        "removed": "تمت إزالة مجلد التخزين من المشروع",
        "bulkRemoved": "تمت إزالة {{count}} من مجلدات التخزين{{plural}} من المشروع بنجاح",
        "bulkRemoveFailed": "فشلت إزالة {{count}} من مجلدات التخزين{{plural}}"
      }
    },
    "registryTab": {
      "columnAgent": "الوكيل",
      "columnFramework": "الإطار",
      "columnStatus": "الحالة",
      "columnEnv": "البيئة",
      "columnOrchestrator": "المنسق",
      "columnRegisteredBy": "سُجّل بواسطة",
      "columnRegisteredAt": "تاريخ التسجيل",
      "columnActions": "الإجراءات",
      "columnWorkflow": "سير العمل",
      "actionOpenCanvas": "فتح اللوحة",
      "actionRuns": "التشغيلات",
      "registryViewsAriaLabel": "طرق عرض السجل",
      "agentRegistryTitle": "سجل الوكلاء",
      "agentsLabel": "الوكلاء",
      "workflowRegistryTitle": "سجل سير العمل",
      "workflowsLabel": "سير العمل",
      "registryStatusTitle": "حالة السجل",
      "activeItemsTitle": "عناصر السجل النشطة",
      "archivedItemsTitle": "عناصر السجل المؤرشفة",
      "openInRegistryTitle": "فتح في السجل",
      "emptyActiveAgents": "لا يوجد وكلاء مسجلون في هذا المشروع.",
      "emptyArchivedAgents": "لا يوجد وكلاء مسجلون مؤرشفون في هذا المشروع.",
      "emptyActiveWorkflows": "لا يوجد سير عمل مسجل في هذا المشروع.",
      "emptyArchivedWorkflows": "لا يوجد سير عمل مسجل مؤرشف في هذا المشروع.",
      "goToRegistry": "الانتقال إلى سجل الوكلاء",
      "searchRegistryPlaceholder": "بحث في السجل…",
      "searchWorkflowsPlaceholder": "بحث في سير العمل…"
    },
    "promptsTab": {
      "columnName": "اسم المطالبة",
      "columnCategory": "الفئة",
      "columnDescription": "الوصف",
      "columnCreated": "تاريخ الإنشاء",
      "columnLastUpdated": "آخر تحديث",
      "columnActions": "الإجراءات",
      "noDescription": "لا يوجد وصف",
      "viewVersionsTitle": "عرض إصدارات المطالبة",
      "errorBoundaryMessage": "تعذر تحميل المطالبات. يرجى تحديث الصفحة.",
      "emptyMessage": "لا توجد مطالبات في هذا المشروع. تتم إدارة المطالبات عبر صفحة المطالبات.",
      "dialogCloseAriaLabel": "إغلاق الحوار",
      "categoryLabel": "الفئة:",
      "versionsHeading": "الإصدارات ({{count}})",
      "loadingVersions": "جارٍ تحميل الإصدارات...",
      "noVersionsFound": "لم يتم العثور على إصدارات",
      "versionLabel": "الإصدار {{version}}",
      "latestBadge": "الأحدث",
      "selectVersionPrompt": "حدد إصدارًا لعرض المحتوى"
    },
    "deploymentsTab": {
      "columnAgent": "الوكيل",
      "columnEnv": "البيئة",
      "columnStatus": "الحالة",
      "columnDeployedBy": "تم النشر بواسطة",
      "columnDeployedAt": "تاريخ النشر",
      "columnActions": "الإجراءات",
      "columnWorkflow": "سير العمل",
      "actionOpen": "فتح",
      "actionChat": "محادثة",
      "actionRuntimeSettings": "إعدادات وقت التشغيل",
      "actionOpenInMonitoring": "فتح في المراقبة",
      "actionManageArchive": "إدارة الأرشيف في المراقبة",
      "actionGuardrails": "الضوابط",
      "deploymentViewsAriaLabel": "طرق عرض النشر",
      "agentDeploymentsTitle": "عمليات نشر الوكلاء",
      "agentsLabel": "الوكلاء",
      "workflowDeploymentsTitle": "عمليات نشر سير العمل",
      "workflowsLabel": "سير العمل",
      "deploymentStatusTitle": "حالة النشر",
      "activeDeploymentsTitle": "عمليات النشر النشطة",
      "archivedDeploymentsTitle": "عمليات النشر المؤرشفة",
      "openInMonitoringTitle": "فتح في المراقبة",
      "emptyActiveAgents": "لا توجد عمليات نشر نشطة للوكلاء لهذا المشروع.",
      "emptyArchivedAgents": "لا توجد عمليات نشر مؤرشفة للوكلاء لهذا المشروع.",
      "emptyActiveWorkflows": "لا توجد عمليات نشر نشطة لسير العمل لهذا المشروع.",
      "emptyArchivedWorkflows": "لا توجد عمليات نشر مؤرشفة لسير العمل لهذا المشروع.",
      "goToMonitoring": "الانتقال إلى المراقبة",
      "searchDeploymentsPlaceholder": "بحث في عمليات النشر…",
      "searchWorkflowDeploymentsPlaceholder": "بحث في عمليات نشر سير العمل…"
    },
    "evalsTab": {
      "columnAgent": "الوكيل",
      "columnLatestSession": "أحدث جلسة",
      "columnActions": "الإجراءات",
      "actionOpenEvals": "فتح التقييمات",
      "actionManageInEvals": "إدارة في التقييمات",
      "portfolioSubtitle": "محفظة التقييم لهذا المشروع",
      "openInEvalsTitle": "فتح في التقييمات",
      "emptyMessage": "لا توجد بيانات تقييم لهذا المشروع.",
      "goToEvals": "الانتقال إلى التقييمات والمحاكاة",
      "searchAgentsPlaceholder": "بحث عن الوكلاء…"
    }
  },
  "prompts": {
    "exportFileName": "الأوامر التوجيهية",
    "searchPlaceholder": "البحث في المطالبات...",
    "columns": {
      "name": "اسم الأمر التوجيهي",
      "description": "الوصف",
      "category": "الفئة",
      "model": "النموذج",
      "project": "المشروع",
      "visibility": "الظهور",
      "createdBy": "أنشأه",
      "updatedAt": "آخر تحديث",
      "actions": "الإجراءات"
    },
    "filters": {
      "title": "عوامل التصفية",
      "visibility": "الظهور",
      "category": "الفئة",
      "project": "المشروع",
      "creator": "المُنشئ",
      "all": "الكل",
      "favorites": "المفضلة"
    },
    "visibility": {
      "project": "المشروع",
      "public": "المنصة"
    },
    "list": {
      "uncategorized": "غير مصنف",
      "allModels": "جميع النماذج",
      "platformBadge": "المنصة",
      "platformBadgeTooltip": "أمر توجيهي نظامي مضمّن في الكود — للقراءة فقط",
      "versionCount": "{{count}} إصدار",
      "versionCount_other": "{{count}} إصدارات",
      "unknownProject": "غير معروف",
      "emptyState": {
        "permissionDenied": "ليس لديك إذن لعرض الأوامر التوجيهية. تواصل مع مسؤول النظام للحصول على الوصول.",
        "noResultsSearch": "لم يتم العثور على أوامر توجيهية مطابقة لبحثك.",
        "default": "لم يتم العثور على أوامر توجيهية. أنشئ أول أمر توجيهي للبدء."
      }
    },
    "actions": {
      "view": "عرض",
      "chat": "محادثة",
      "exportYaml": "تصدير بصيغة YAML",
      "optimize": "تحسين",
      "cloneForModel": "استنساخ لنموذج",
      "edit": "تعديل",
      "delete": "حذف",
      "exportSelected": "تصدير المحدد",
      "deleteSelected": "حذف المحدد",
      "createPrompt": "إنشاء أمر توجيهي",
      "newPrompt": "أمر توجيهي جديد",
      "creating": "جارٍ الإنشاء..."
    },
    "quota": {
      "loading": "جارٍ تحميل الحصة...",
      "label": "الأوامر التوجيهية"
    },
    "toast": {
      "projectFilterReset": "المشروع المحدد سابقًا لم يعد موجودًا. تمت إعادة تعيين عامل التصفية.",
      "draftInserted": "تم إدراج مسودة الأمر التوجيهي. عدّلها إذا لزم الأمر ثم أنشئها — يمكنك تشغيل التحسين من محرر الأمر التوجيهي بعد الحفظ.",
      "clonedForModel": "تم استنساخ الأمر التوجيهي للنموذج \"{{model}}\"",
      "bulkDeletePartial": "تم حذف {{deleted}} أمر توجيهي، وفشل {{skipped}}: {{errors}}",
      "bulkDeleteSuccess": "تم حذف {{count}} أمر توجيهي بنجاح",
      "platformDeleteBlocked": "لا يمكن حذف الأوامر التوجيهية الخاصة بالمنصة"
    },
    "form": {
      "modelAgnostic": "غير مرتبط بنموذج (جميع النماذج)",
      "selectProjectFirst": "الرجاء اختيار مشروع أولاً.",
      "selectProjectModel": "الرجاء اختيار نموذج LLM مخصص لهذا المشروع.",
      "selectModel": "الرجاء اختيار نموذج LLM.",
      "minBusinessContext": "أدخل 10 أحرف على الأقل من السياق التجاري.",
      "selectProjectAndModelFirst": "الرجاء اختيار المشروع والنموذج أولاً",
      "selectModelFirst": "الرجاء اختيار نموذج أولاً",
      "minCharsRequired": "الحد الأدنى 10 أحرف مطلوب",
      "selectProjectFirstPlaceholder": "اختر مشروعًا أولاً",
      "loadingModels": "جارٍ تحميل النماذج…",
      "noLlmForProject": "لا يوجد نموذج LLM مخصص لهذا المشروع",
      "noLlmAvailable": "لا يوجد نموذج LLM متاح",
      "nameAlreadyExists": "يوجد بالفعل أمر توجيهي بهذا الاسم",
      "promptNameLabel": "اسم الأمر التوجيهي *",
      "promptNamePlaceholder": "مثال: مساعد دعم العملاء",
      "categoryLabel": "الفئة",
      "categoryPlaceholder": "مثال: الدعم، المبيعات",
      "targetModelLabel": "النموذج المستهدف",
      "targetModelRequiredLabel": "النموذج المستهدف *",
      "selectModelPlaceholder": "اختر نموذجًا...",
      "descriptionLabel": "الوصف",
      "descriptionPlaceholder": "وصف موجز لما يقوم به هذا الأمر التوجيهي",
      "charCount": "{{count}}/{{max}} حرفًا",
      "modelLabel": "النموذج",
      "selectAiModelPlaceholder": "اختر نموذج الذكاء الاصطناعي",
      "generating": "جارٍ التوليد…",
      "generate": "توليد",
      "businessContextPlaceholder": "الجمهور، النبرة، المهام، القيود — سيقوم النموذج بصياغة الأمر التوجيهي من هذا النص. الحد الأدنى 10 أحرف للتوليد.",
      "aiGenerateHint": "بعد التوليد ستنتقل إلى الوضع اليدوي لمراجعة الأمر التوجيهي وتعديله، ثم إنشائه.",
      "contentPlaceholderPrefix": "أنت مساعد مفيد يقوم بـ...\n\nاكتب أمرك التوجيهي النظامي هنا. استخدم ",
      "contentPlaceholderSuffix": " للإشارة إلى متغيرات الحالة التي سيتم حلها وقت التشغيل.",
      "variableNamePlaceholder": "variable_name",
      "addVariable": "إضافة متغير",
      "nameLabel": "الاسم *",
      "fixValidationErrors": "الرجاء إصلاح أخطاء التحقق قبل الحفظ",
      "saving": "جارٍ الحفظ...",
      "saveChanges": "حفظ التغييرات",
      "quotaExceeded": "تم تجاوز حصة الأوامر التوجيهية",
      "fillRequiredFields": "الرجاء تعبئة جميع الحقول المطلوبة",
      "cloning": "جارٍ الاستنساخ..."
    },
    "modal": {
      "detailsHeader": "التفاصيل",
      "describePromptHeader": "صف ما تريد أن يقوم به الأمر التوجيهي",
      "promptDetailsHeader": "تفاصيل الأمر التوجيهي",
      "createTitle": "إنشاء أمر توجيهي جديد",
      "creationModeAriaLabel": "وضع إنشاء الأمر التوجيهي",
      "modeManual": "يدوي",
      "modeAi": "ذكاء اصطناعي",
      "editorSectionsAriaLabel": "أقسام محرر الأمر التوجيهي",
      "tabPrompt": "الأمر التوجيهي",
      "tabState": "الحالة",
      "editorHintPrefix": "استخدم",
      "editorHintSuffix": "لمتغيرات الحالة",
      "aiGeneratedNote": "تم إنشاؤه بالذكاء الاصطناعي — عدّله حسب الحاجة. استخدم التحسين لمزيد من الضبط.",
      "loadingEditor": "جارٍ تحميل محرر الأمر التوجيهي...",
      "stateVariablesHintPrefix": "عرّف متغيرات الحالة لاستخدامها مع",
      "stateVariablesHintSuffix": "في أمرك التوجيهي. يجب إدراج كل متغير مُشار إليه في الأمر التوجيهي هنا.",
      "noStateVariables": "لم يتم تعريف أي متغيرات حالة بعد.",
      "stateVariableNameAriaLabel": "اسم متغير الحالة {{name}}",
      "removeStateVariableAriaLabel": "إزالة متغير الحالة {{name}}",
      "newVariableFallback": "جديد",
      "editTitle": "تعديل بيانات الأمر التوجيهي الوصفية",
      "deleteTitle": "حذف الأمر التوجيهي",
      "deleteMessage": "هل تريد بالتأكيد حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteTitle": "حذف الأوامر التوجيهية المحددة",
      "bulkDeleteMessage": "هل تريد بالتأكيد حذف {{count}} أمر توجيهي؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteMessage_other": "هل تريد بالتأكيد حذف {{count}} أوامر توجيهية؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteConfirm": "حذف {{count}} أمر توجيهي",
      "bulkDeleteConfirm_other": "حذف {{count}} أوامر توجيهية",
      "cloneTitle": "استنساخ لنموذج",
      "cloneMessage": "استنساخ \"{{name}}\" بجميع إصداراته لنموذج مختلف.",
      "cloneSubmit": "استنساخ الأمر التوجيهي"
    },
    "optimizeModal": {
      "header": {
        "title": "تحسين الموجّه",
        "subtitlePlaceholder": "اختر موجّهًا"
      },
      "stepper": {
        "configure": "التهيئة",
        "running": "قيد التشغيل",
        "result": "النتيجة"
      },
      "framework": {
        "sectionTitle": "اختر إطار العمل",
        "bestFor": "الأنسب لـ: {{value}}",
        "catalog": {
          "dspy": {
            "label": "DSPy",
            "tier": "المستوى 1",
            "desc": "تحسين تصريحي (MIPROv2 أو COPRO أو bootstrap few-shot). الأفضل مع أمثلة موسومة.",
            "tooltip": "يُترجم برنامجًا تصريحيًا إلى موجّهات محسّنة. اختر نوع المُجمِّع أدناه (الافتراضي MIPROv2).",
            "bestFor": "التصنيف، الأسئلة والأجوبة، مهام الاستخراج"
          },
          "cot": {
            "label": "سلسلة التفكير",
            "tier": "المستوى 2",
            "desc": "تحسين الاستدلال: خطوة بخطوة، جودة المسار، تفكيك الخطوات.",
            "tooltip": "يجرّب عدة استراتيجيات لسلسلة التفكير (مثل \"فكّر خطوة بخطوة\")، ويحسّن جودة مسار الاستدلال وتفكيك الخطوات. استخدم نوع الموجّه \"سلسلة التفكير\" للحصول على كل الاستراتيجيات.",
            "bestFor": "الاستدلال، الرياضيات، المهام متعددة الخطوات"
          },
          "opro": {
            "label": "OPRO",
            "tier": "المستوى 2",
            "desc": "النموذج كمُحسِّن. يغذي سجل (الموجّه، النتيجة) ويطلب التحسين.",
            "tooltip": "يستخدم النموذج نفسه كمُحسِّن — يقترح تكراريًا موجّهات أفضل بتحليل مسارات النتائج. بسيط النشر، بدون حساب تدرجات.",
            "bestFor": "تكرار سريع على أي مهمة"
          },
          "reflexion": {
            "label": "Reflexion",
            "tier": "المستوى 2",
            "desc": "تعلم تعزيزي لفظي ذاتي التأمل. ينشئ حلقة نقد ثم إعادة كتابة.",
            "tooltip": "يولّد نقدًا ذاتيًا بعد كل محاولة، ثم يعيد كتابة الموجّه لإصلاح الإخفاقات المحددة. يجمع بين التأمل والذاكرة الحلقية للتحسين المستمر.",
            "bestFor": "الاستدلال المعقد، المهام متعددة الخطوات"
          },
          "gepa": {
            "label": "GEPA",
            "tier": "المستوى 3",
            "desc": "محرك Genetic-Pareto الأصلي مع اختيار باريتو لكل مثال ودمج المرشحين.",
            "tooltip": "يشغّل محرك GEPA المرجعي. يحتفظ بجبهة باريتو لكل مثال تحقق بدلًا من نتيجة إجمالية واحدة، بحيث تبقى الموجّهات التي تساعد فقط على جزء من الحالات قابلة للدمج.",
            "bestFor": "رسوم الوكلاء متعددة العقد، التشغيلات الراكدة"
          },
          "gepa_legacy": {
            "label": "GEPA (قديم)",
            "tier": "المستوى 3",
            "desc": "نهج تطوري تأملي داخلي مع تشخيص إخفاقات مدعوم بالنموذج.",
            "tooltip": "تقريب GEPA المدمج السابق. يُحتفظ به كبديل احتياطي عند عدم توفر الحزمة الأصلية، وللمقارنة A/B.",
            "bestFor": "التثبيتات دون اتصال بدون حزمة gepa"
          },
          "optimize_anything": {
            "label": "optimize_anything",
            "tier": "المستوى 3",
            "desc": "مُشغّل GEPA الأصلي للأدوات غير الموجّهات (رسم الوكيل، تهيئة العقدة).",
            "tooltip": "يحسّن JSON الرسم أو معايير تهيئة العقدة عبر نفس محرك Genetic-Pareto. المرشحون غير الصالحون يحصلون على نتيجة 0 مع خطأ التحقق كتغذية راجعة. الاستمرارية مشروطة بخطوة تطبيق صريحة.",
            "bestFor": "البحث في الطوبولوجيا والتهيئة بما يتجاوز الموجّهات"
          },
          "evoprompt": {
            "label": "EvoPrompt",
            "tier": "المستوى 3",
            "desc": "تطور قائم على مجموعة سكانية مع مؤثرات تزاوج وطفرة.",
            "tooltip": "يحافظ على مجموعة من الموجّهات المرشحة ويطبق مؤثرات تزاوج/طفرة مستوحاة من الخوارزميات الجينية. ممتاز لاستكشاف صياغات موجّهات متنوعة.",
            "bestFor": "استكشاف موجّهات متنوعة"
          },
          "ape": {
            "label": "APE",
            "tier": "المستوى 3",
            "desc": "مهندس موجّهات تلقائي. توليد ← تقييم ← إعادة أخذ عينات.",
            "tooltip": "يولّد العديد من التعليمات المرشحة من عروض الإدخال/الإخراج، يقيّمها، ثم يعيد أخذ العينات حول الأفضل. سريع وفعّال لاكتشاف التعليمات.",
            "bestFor": "اكتشاف التعليمات من الأمثلة"
          },
          "textgrad": {
            "label": "TextGrad",
            "tier": "المستوى 4",
            "desc": "الانتشار العكسي النصي. يحسب تدرجات نصية لإصلاحات مستهدفة.",
            "tooltip": "ينشر \"تدرجات\" نصية — تغذية راجعة بلغة طبيعية — للخلف عبر الموجّه لتحديد الأجزاء التي تحتاج تعديلًا بدقة. تنقيح دقيق وجراحي.",
            "bestFor": "تحرير دقيق للموجّهات الطويلة"
          },
          "rl_tuning": {
            "label": "RL-PPO",
            "tier": "المستوى 5",
            "desc": "تحسين سياسة بأسلوب PPO مع دوال مكافأة مخصصة.",
            "tooltip": "يعامل اختيار الموجّه كسياسة ويحسّنها عبر Proximal Policy Optimization. عرّف دالة المكافأة الخاصة بك للتحكم الكامل بهدف التحسين.",
            "bestFor": "أهداف مكافأة مخصصة"
          },
          "rag_aware": {
            "label": "RAG-Aware",
            "tier": "المستوى 6",
            "desc": "تحسين مشترك للموجّه وخط أنابيب الاسترجاع.",
            "tooltip": "يحسّن الموجّه وتهيئة الاسترجاع معًا. يضبط تنسيق الاستعلام وموضع السياق وصياغة التعليمات لسير العمل كثيف RAG.",
            "bestFor": "التوليد المعزَّز بالاسترجاع"
          },
          "multi_obj": {
            "label": "متعدد الأهداف",
            "tier": "شامل",
            "desc": "تحسين جبهة باريتو عبر الدقة والزمن والتكلفة.",
            "tooltip": "يستكشف جبهة باريتو عبر أهداف متنافسة متعددة (الدقة، زمن الاستجابة، تكلفة الرموز). يعيد مجموعة من الموجّهات المتوازنة بدلًا من فائز واحد.",
            "bestFor": "الموازنة بين الدقة والتكلفة"
          },
          "ensemble": {
            "label": "المجموعة (Ensemble)",
            "tier": "شامل",
            "desc": "تشغيل عدة مُحسِّنات بالتوازي، ثم دمج النتائج (بطولة، دمج، أو تصويت).",
            "tooltip": "يشغّل إطارين متكاملين أو أكثر في آن واحد (مثل Reflexion + OPRO + TextGrad)، ثم يدمج أفضل مرشحيهم. تكلفة أعلى من إطار واحد؛ الأفضل عند الرغبة في تحسين موجّه قوي ومتعدد الأوجه.",
            "bestFor": "أقصى تغطية ومتانة"
          }
        }
      },
      "promptVersion": {
        "sectionTitle": "الموجّه والإصدار",
        "projectLabel": "المشروع",
        "promptLabel": "الموجّه",
        "promptPlaceholder": "اختر موجّهًا...",
        "promptSearchPlaceholder": "ابحث بالاسم...",
        "promptRequiredError": "اختيار موجّه مطلوب.",
        "versionLabel": "الإصدار",
        "versionPlaceholder": "اختر إصدارًا...",
        "versionRequiredError": "اختيار إصدار الموجّه مطلوب.",
        "versionCurrentSuffix": " (الحالي)",
        "compilerTypeLabel": "نوع المُجمِّع",
        "compilerTypeTitle": "أي مُلقِّن DSPy يعمل (MIPROv2 هو مُحسِّن المضاعفة الافتراضي).",
        "compilerOptions": {
          "miprov2": "MIPROv2",
          "copro": "COPRO",
          "bootstrapFewShot": "Bootstrap few-shot"
        },
        "promptTypeLabel": "نوع الموجّه",
        "promptTypeTitle": "استراتيجيات مُحسِّن سلسلة التفكير.",
        "promptTypeOptions": {
          "standard": "قياسي",
          "cot": "سلسلة التفكير",
          "fewShot": "أمثلة قليلة",
          "structuredOutput": "إخراج منظّم (JSON/XML)"
        },
        "allProjectsLabel": "كل المشاريع"
      },
      "model": {
        "sectionTitle": "تهيئة النموذج",
        "responseModelLabel": "نموذج الاستجابة",
        "responseModelPlaceholder": "اختر نموذج LLM...",
        "responseModelRequiredError": "نموذج الاستجابة مطلوب (أو فعّل تعدد النماذج بهدفين أو أكثر).",
        "judgeModelLabel": "نموذج الحكم",
        "judgeModelPlaceholder": "اختر نموذج حكم",
        "gepaMutationModelLabel": "نموذج طفرة GEPA",
        "gepaMutationModelTitle": "النموذج المستخدم للتأمل والطفرة في GEPA (معرّف نموذج LiteLLM أو UUID نموذج المنصة).",
        "gepaMutationModelPlaceholder": "اختر نموذج الطفرة",
        "gepaMutationModelHint": "التأمل وتوليد الطفرات؛ لا يزال التقييم يستخدم نماذج الحكم/الاستجابة أعلاه.",
        "multiModelLabel": "التحسين عبر عدة نماذج",
        "multiModelHint": "تقييم الموجّه على نموذجين أو أكثر وتجميع النتائج (موجّه غير مرتبط بنموذج محدد)",
        "targetModelsLabel": "النماذج المستهدفة (اختر 2 أو أكثر)",
        "selectAtLeast2Hint": "اختر نموذجين على الأقل.",
        "modelsSelectedCount": "تم اختيار {{count}} نموذج.",
        "aggregationStrategyLabel": "استراتيجية التجميع",
        "aggregationOptions": {
          "mean": "المتوسط — متوسط عبر جميع النماذج",
          "min": "الأدنى — أسوأ حالة (لا يُترك أي نموذج)",
          "pareto": "باريتو — توازن بين الأدنى والمتوسط"
        },
        "aggregationHint": "الأدنى = التحسين للنموذج الأضعف؛ المتوسط = المعدل؛ باريتو = التوازن.",
        "noModelsHint": "لا توجد نماذج LLM مرتبطة بهذا المشروع. أضف نماذج ضمن المشروع ← النماذج، وإلا فقد يعتمد التحسين على القيم الافتراضية للخلفية.",
        "selectPromptHint": "اختر موجّهًا لتحميل نماذج الاستجابة والحكم من مشروع ذلك الموجّه."
      },
      "ensemble": {
        "sectionTitle": "تهيئة المجموعة",
        "subFrameworksLabel": "الأطر الفرعية (اختر 2 أو أكثر)",
        "subFrameworksHint": "يعمل كل مُحسِّن مختار بالتوازي؛ تُدمج النتائج باستخدام الاستراتيجية أدناه.",
        "fusionLabel": "استراتيجية الدمج",
        "fusionOptions": {
          "tournament": "بطولة — تقييم المرشحين على كامل البيانات، اختيار الأفضل",
          "merge": "دمج — يُركّب النموذج أفضل المرشحين في موجّه واحد",
          "voting": "تصويت — تقييم المرشحين على مجموعة اختبار، دمج مرجّح"
        },
        "minTwoToast": "اختر إطارين فرعيين على الأقل للمجموعة"
      },
      "metrics": {
        "sectionTitle": "مقياس التقييم",
        "autoDiscoverLabel": "اكتشاف المقاييس تلقائيًا من البيانات والموجّه (يوصي بالإخلاص والملاءمة وغيرها عند وجود سياق)",
        "selectPromptHint": "اختر موجّهًا لتحميل كتالوج المقاييس الخاص بمشروعه.",
        "weightsTitle": "أوزان المقاييس (اختياري — نتيجة مركبة)",
        "weightsHint": "اتركه فارغًا للوزن المتساوي. تُطبَّع الأوزان لمجموع يساوي 1.",
        "weightPlaceholder": "متساوٍ",
        "noMetricsWarning": "لم تُختر مقاييس — سيُستخدم افتراضيًا صحة الإجابة.",
        "embeddingLabel": "نموذج التضمين (مطلوب للمقاييس المختارة)",
        "embeddingPlaceholder": "اختر نموذج تضمين…",
        "embeddingNoModelsHint": "لا توجد نماذج تضمين نشطة في هذا المشروع. سجّل نموذجًا ضمن المشروع ← النماذج.",
        "sqlLabel": "قاعدة بيانات التنفيذ (مطلوبة لمقاييس Text2SQL EX/VES)",
        "sqlPlaceholder": "اختر موصل قاعدة بيانات…",
        "sqlNoConnectorsHint": "لا توجد موصلات قواعد بيانات مسجّلة. أضف واحدًا ضمن المعرفة ← الموصلات.",
        "schemaLabel": "تعريف المخطط (JSON، مطلوب لمطابقة المخطط)",
        "schemaPlaceholder": "{\"tables\": [{\"name\": \"orders\", \"columns\": [\"id\", \"amount\"]}]}"
      },
      "dataset": {
        "sectionTitle": "مجموعة بيانات القياس",
        "optionalGepaSuffix": "(اختياري لـ GEPA)",
        "selectPromptHint": "اختر موجّهًا لعرض مجموعات بيانات القياس المرتبطة بمعرفة ذلك المشروع.",
        "datasetPlaceholder": "اختر جدولًا مسجّلًا...",
        "datasetSearchPlaceholder": "ابحث عن مجموعات البيانات بالاسم أو الجدول...",
        "datasetRowsSuffix": "({{count}} صف)",
        "datasetRequiredError": "اختيار مجموعة بيانات القياس مطلوب.",
        "noDatasetsHint": "لا توجد جداول معرفة مرتبطة بهذا المشروع. اربط الجداول ضمن المشروع ← المعرفة.",
        "inputColumnLabel": "عمود الإدخال",
        "columnPlaceholder": "اختر عمودًا...",
        "expectedOutputColumnLabel": "عمود الإخراج المتوقع",
        "expectedOutputRequiredError": "عمود الإخراج المتوقع مطلوب لـ DSPy.",
        "contextColumnsLabel": "أعمدة السياق (اختياري)",
        "selectDatasetFirst": "اختر مجموعة بيانات أولًا",
        "contextColumnsHint": "تُدمج عدة أعمدة لتكوين سياق التقييم (RAGAS / DeepEval).",
        "samplingStrategyLabel": "استراتيجية أخذ العينات",
        "samplingOptions": {
          "random": "عشوائي",
          "stratified": "طبقي (حسب الإخراج المتوقع)",
          "difficultyWeighted": "مرجّح بالصعوبة (التركيز على الحالات الصعبة)",
          "progressive": "تدريجي (توسيع المجموعة الفرعية مع تقدم التحسين)"
        },
        "samplingHint": "يمكن للطبقي والمرجّح بالصعوبة تحسين الإشارة بعدد أقل من الصفوف."
      },
      "dspyContext": {
        "title": "تكامل سياق DSPy",
        "modeLabel": "وضع تمرير السياق",
        "modeOptions": {
          "auto": "تلقائي — حقن السياق كإدخال DSPy عند اكتشافه",
          "injectField": "حقن حقل — دائمًا إضافة السياق كإدخال DSPy",
          "ragModule": "وحدة RAG — استرجاع من مجموعة السياق قبل التنبؤ"
        },
        "modeHints": {
          "auto": "يحقن السياق من البيانات تلقائيًا في توقيع DSPy، حتى لو لم يُشر إليه قالب الموجّه.",
          "injectField": "يفرض حقن السياق كحقل إدخال DSPy. يتعلم DSPy استخدام السياق أثناء التجميع.",
          "ragModule": "يبني وحدة DSPy مركبة من الاسترجاع + التنبؤ. يمكن لـ MIPROv2 تحسين الاسترجاع والتنبؤ معًا."
        },
        "demoStrategyLabel": "استراتيجية اختيار الأمثلة التوضيحية",
        "demoOptions": {
          "default": "افتراضي — دع مُجمِّع DSPy يختار",
          "diverseContext": "سياق متنوع — تعظيم تنوع السياق بين الأمثلة",
          "maxCoverage": "أقصى تغطية — تغطية أوسع نطاق من مواضيع السياق"
        },
        "demoHint": "يختار السياق المتنوع والتغطية القصوى أمثلة بتنوع سياق أغنى لجودة أفضل في التعلم بأمثلة قليلة.",
        "topKLabel": "أعلى K للاسترجاع",
        "topKHint": "عدد مقاطع السياق المسترجعة لكل استعلام من مجموعة البيانات المرجعية.",
        "truncateLabel": "اقتطاع السياقات الطويلة",
        "truncateHint": "تحديد مقاطع السياق لتناسب ميزانية الرموز",
        "maxTokensLabel": "الحد الأقصى لرموز السياق",
        "maxTokensHint": "اقتطاع تقريبي على مستوى الكلمات لكل مقطع."
      },
      "advanced": {
        "sectionTitle": "خيارات متقدمة",
        "warmStartLabel": "بداية دافئة بالتعلم الفوقي",
        "warmStartHint": "البدء من تشغيلات سابقة مشابهة",
        "adversarialLabel": "اختبار المتانة العدائية",
        "adversarialHint": "الاختبار على مدخلات مضطربة؛ الدمج مع النتيجة النظيفة",
        "adversarialWeightLabel": "وزن العدائي (0–1)",
        "adversarialWeightHint": "robust_score = (1 − α)×نظيف + α×عدائي؛ α أعلى يعطي وزنًا أكبر للعدائي.",
        "requireApprovalLabel": "طلب الموافقة قبل الحفظ",
        "requireApprovalHint": "مراجعة الموجّه المحسّن قبل أن يصبح إصدارًا جديدًا",
        "driftGuardLabel": "حارس الانحراف الدلالي",
        "driftGuardHint": "رفض المرشحين الذين ينحرفون كثيرًا عن القصد الأصلي",
        "maxDriftLabel": "الحد الأقصى للانحراف (0–1)",
        "maxDriftHint": "يُرفض المرشحون بانحراف أكبر من هذه القيمة. أقل = أكثر صرامة (مثل 0.3).",
        "driftMethodLabel": "طريقة الانحراف",
        "driftMethodOptions": {
          "jaccard": "جاكارد (قائم على الرموز)",
          "vector": "متجه (تشابه جيب التمام للتضمين)"
        },
        "driftMethodHint": "يستخدم انحراف المتجه نموذج التضمين أدناه؛ جاكارد معجمي فقط.",
        "embeddingModelLabel": "نموذج التضمين",
        "embeddingLoading": "جارٍ تحميل النماذج…",
        "embeddingNoModelsHint": "لا توجد نماذج تضمين نشطة في هذا المشروع. استخدم انحراف جاكارد أو سجّل نماذج ضمن النماذج الأساسية.",
        "embeddingPlaceholder": "اختر نموذج تضمين",
        "embeddingRequiredHint": "مطلوب عندما تكون طريقة الانحراف متجهًا (يُخزَّن كـ drift_embedding_model_id).",
        "guardrailsLabel": "حواجز أمان المحتوى",
        "guardrailsHint": "رفض المرشحين الذين يفشلون في فحوصات السمية أو المعلومات الشخصية أو حقن الموجّه أو أمان العلامة التجارية",
        "guardrailBackendLabel": "خلفية الحواجز",
        "guardrailBackendOptions": {
          "builtin": "مدمج (قائم على الأنماط)",
          "azureContentSafety": "Azure Content Safety",
          "awsBedrock": "AWS Bedrock Guardrails",
          "custom": "مخصص (نقطة نهاية HTTP)"
        },
        "guardrailBackendHint": "المدمج يشغّل فحوصات المعلومات الشخصية والسمية والاختراق وأمان العلامة التجارية الاختياري دون واجهات برمجة خارجية.",
        "checksLabel": "الفحوصات المطلوب تشغيلها",
        "checksHint": "يُرفض المرشحون الذين يفشلون في أي فحص مختار قبل التقييم.",
        "checkLabels": {
          "piiCheck": "معلومات شخصية",
          "toxicity": "سمية",
          "promptInjection": "حقن الموجّه",
          "jailbreak": "اختراق",
          "brandSafety": "أمان العلامة التجارية",
          "lengthCheck": "فحص الطول"
        }
      },
      "parameters": {
        "sectionTitle": "المعاملات",
        "maxIterationsLabel": "الحد الأقصى للتكرارات",
        "maxIterationsEnsembleLabel": "الحد الأقصى للتكرارات (لكل إطار فرعي)",
        "maxIterationsHint": "أعلى = تنقيح أكثر، وقت تشغيل أطول",
        "maxIterationsEnsembleHint": "يعمل كل مُحسِّن متوازٍ حتى هذا العدد من التكرارات (تستخدم المجموعة sub_max_iterations).",
        "timeBudgetLabel": "ميزانية الوقت (ثوانٍ)",
        "timeBudgetHint": "حد أقصى صارم لزمن التشغيل الفعلي (60–14400 ثانية). يتوقف التشغيل عند بلوغ الميزانية.",
        "maxCostLabel": "الحد الأقصى للتكلفة (دولار، اختياري)",
        "maxCostPlaceholder": "بلا حد",
        "maxCostHint": "سقف إنفاق تقديري؛ تُلغى الجلسة عند تجاوزه. اتركه فارغًا لعدم وجود حد.",
        "targetScoreLabel": "النتيجة المستهدفة (اختياري)",
        "targetScorePlaceholder": "بلا",
        "targetScoreHint": "التوقف مبكرًا عندما تصل النتيجة المركبة لهذه القيمة (0–1). اتركه فارغًا للتشغيل حتى التكرارات أو الحدود الأخرى.",
        "candidateCountHint": "عدد الموجّهات المرشحة المولّدة أو المقيّمة لكل تكرار لهذا المُحسِّن.",
        "evalMaxRowsLabel": "الحد الأقصى لصفوف بيانات التقييم",
        "evalMaxRowsHint": "الصفوف المجلوبة من القياس لكل تقييم (يستخدم الأساس السقف الكامل؛ قد تستخدم الحلقات الداخلية أقل).",
        "rowsPerIterationLabel": "الصفوف لكل تقييم مرشح (اختياري)",
        "rowsPerIterationPlaceholder": "تلقائي",
        "rowsPerIterationHint": "يحدد الصفوف عند تقييم كل موجّه مقترح؛ اتركه فارغًا للتلقائي (نحو نصف الحد الأقصى للصفوف، بحد أدنى 5).",
        "earlyStoppingLabel": "التوقف المبكر",
        "patienceHint": "الصبر (جولات بلا تحسّن)",
        "candidateLabels": {
          "gepa": "الطفرات لكل تكرار",
          "ape": "المرشحون لكل جولة",
          "opro": "المقترحات لكل تكرار",
          "evoprompt": "حجم المجموعة السكانية",
          "rl_tuning": "عمليات التشغيل لكل تكرار"
        }
      },
      "reward": {
        "sectionTitle": "دالة المكافأة (Python)",
        "description": "عرّف دالة المكافأة المخصصة الخاصة بك. تستقبل كل صف تقييم وتعيد إشارة مكافأة ضمن [-1، 1]. ستُعظّم السياسة هذه المكافأة."
      },
      "estimate": {
        "title": "الموارد المقدَّرة",
        "summary": "~{{calls}} استدعاء نموذج · حوالي ${{low}}–${{high}} دولار",
        "monthlyUsed": "المستخدم الشهري: ${{used}} / ${{limit}}",
        "acknowledge": "أُقرّ بالتكلفة المقدَّرة (حتى ${{cost}} دولار) وأرغب في بدء هذا التشغيل"
      },
      "start": {
        "button": "بدء تحسين {{framework}}",
        "confirmButton": "تأكيد وبدء",
        "changeParams": "تغيير المعاملات"
      },
      "toast": {
        "selectPrompt": "يرجى اختيار موجّه",
        "selectVersion": "يرجى اختيار إصدار الموجّه",
        "selectDataset": "يرجى اختيار مجموعة بيانات قياس",
        "selectResponseModel": "يرجى اختيار نموذج استجابة أو تفعيل تعدد النماذج بنموذجين على الأقل",
        "multiModelMin2": "يتطلب تحسين تعدد النماذج نموذجين مستهدفين على الأقل",
        "dspyExpectedOutput": "لـ DSPy، اختر عمود الإخراج المتوقع",
        "vectorDriftEmbedding": "يتطلب انحراف المتجه نموذج تضمين، أو اضبط طريقة الانحراف على جاكارد.",
        "embeddingForMetrics": "اختر نموذج تضمين للمقاييس المختارة.",
        "sqlForMetrics": "اختر قاعدة بيانات تنفيذ لمقاييس Text2SQL المختارة.",
        "schemaForMetrics": "قدّم تعريف مخطط JSON صالحًا لمقياس مطابقة المخطط.",
        "ensembleMin2": "تتطلب المجموعة إطارين فرعيين على الأقل",
        "unsupportedSubframework": "إطار فرعي غير مدعوم: {{list}}",
        "maxCostInvalid": "يجب أن يكون الحد الأقصى للتكلفة (دولار) رقمًا غير سالب",
        "targetScoreInvalid": "يجب أن تكون النتيجة المستهدفة بين 0 و1",
        "llmCapExceeded": "استدعاءات النموذج المقدَّرة ({{calls}}) تتجاوز حد الجلسة ({{cap}}). قلّل التكرارات أو حجم المجموعة.",
        "cancelRequested": "تم طلب إلغاء تشغيل التحسين",
        "cancelFailed": "فشل إلغاء تشغيل التحسين"
      },
      "running": {
        "title": "جارٍ تحسين \"{{name}}\"",
        "engineLabel": "المحرك:",
        "jobLabel": "المهمة:",
        "progressLabel": "التقدم",
        "statusLabel": "الحالة:",
        "statusStarting": "قيد البدء",
        "iterationSuffix": " · التكرار {{current}}/{{max}}",
        "initializing": "جارٍ تهيئة محرك {{engine}}...",
        "loadingDataset": "جارٍ تحميل مجموعة بيانات القياس",
        "completedIterations": "اكتمل {{current}}/{{max}} من التكرارات",
        "errorPrefix": "خطأ: {{message}}",
        "cancelButton": "إلغاء التشغيل"
      },
      "result": {
        "awaitingApproval": "بانتظار الموافقة",
        "complete": "اكتمل التحسين",
        "cancelled": "أُلغي التحسين",
        "failed": "فشل التحسين",
        "approvalHint": "يتطلب الموجّه المحسّن موافقة بشرية قبل حفظه كإصدار جديد. راجعه ووافق عليه في صفحة تفاصيل التشغيل.",
        "baseline": "الأساس",
        "optimized": "محسّن",
        "iterationsSuffix": "التكرارات: {{count}}",
        "evaluationsSuffix": " · التقييمات: {{count}}",
        "reviewApprove": "مراجعة والموافقة",
        "viewRunDetails": "عرض تفاصيل التشغيل",
        "viewOptimizedVersion": "عرض الإصدار المحسّن"
      }
    },
    "runDetail": {
      "pageTitle": "تحسين المطالبة",
      "backToRuns": "العودة إلى عمليات التشغيل",
      "backToOptimizationRuns": "العودة إلى عمليات تشغيل التحسين",
      "notFound": "لم يتم العثور على عملية تشغيل التحسين",
      "loading": "جارٍ تحميل تفاصيل التحسين...",
      "status": {
        "completed": "مكتمل",
        "failed": "فشل",
        "cancelled": "ملغى",
        "running": "قيد التشغيل",
        "queued": "في قائمة الانتظار",
        "pending_approval": "بانتظار الموافقة"
      },
      "approvalBadge": {
        "pending": "بانتظار الموافقة",
        "approved": "تمت الموافقة",
        "rejected": "مرفوض"
      },
      "viewOptimizedPrompt": "عرض المطالبة المحسّنة",
      "errorBanner": {
        "title": "فشل التحسين"
      },
      "createdAt": "أُنشئ في {{date}}",
      "approval": {
        "reviewTitle": "مراجعة المطالبة المحسّنة",
        "reviewSubtitle": "يتطلب هذا التحسين موافقة قبل حفظ المطالبة المحسّنة كإصدار جديد.",
        "reasonPlaceholder": "سبب اختياري للموافقة/الرفض...",
        "reject": "رفض",
        "approve": "الموافقة والحفظ كإصدار جديد",
        "approvedMessage": "تمت الموافقة على المطالبة وحفظها كإصدار جديد.",
        "rejectedMessage": "تم رفض المطالبة. لم يتم إنشاء إصدار جديد.",
        "promptApprovedTitle": "تمت الموافقة على المطالبة",
        "promptRejectedTitle": "تم رفض المطالبة",
        "approvedSubtitle": "تمت الموافقة على هذه المطالبة المحسّنة وحفظها كإصدار جديد.",
        "rejectedSubtitle": "تم رفض هذه المطالبة المحسّنة. لم يتم إنشاء إصدار جديد."
      },
      "diff": {
        "originalPrompt": "المطالبة الأصلية",
        "optimizedPrompt": "المطالبة المحسّنة"
      },
      "tabs": {
        "overview": "نظرة عامة",
        "insights": "الرؤى",
        "rowMetrics": "مقاييس الصفوف",
        "candidates": "المرشحون",
        "trace": "التتبع",
        "abTest": "اختبار A/B",
        "configuration": "التهيئة"
      },
      "metrics": {
        "baselineScore": "النتيجة الأساسية",
        "optimizedScore": "النتيجة المحسّنة",
        "improvement": "التحسّن",
        "holdoutScore": "نتيجة مجموعة الاختبار",
        "holdoutSubValue": "النتيجة الحقيقية على مجموعة الاختبار المحجوزة",
        "iterations": "التكرارات",
        "iterationsSubValue": "من أصل {{max}} كحد أقصى",
        "evaluations": "التقييمات",
        "duration": "المدة",
        "totalTokens": "إجمالي الرموز",
        "tokensSubValue": "{{prompt}} مطالبة / {{completion}} إكمال",
        "estimatedCost": "التكلفة المقدرة",
        "estimatedCostSubValue": "استهلاك نموذج اللغة"
      },
      "orchestrator": {
        "label": "المنسّق",
        "openRun": "فتح تشغيل سير العمل"
      },
      "earlyStopping": {
        "label": "الإيقاف المبكر",
        "completedOf": "اكتمل {{completed}} من أصل {{max}} تكرارًا مُهيأً."
      },
      "perModelScores": {
        "title": "النتائج لكل نموذج (تشغيل غير مرتبط بنموذج محدد)",
        "desc": "النتيجة الإجمالية أعلاه مشتقة من هذه النتائج لكل نموذج. تم تقييم المطالبة على كل نموذج أساسي."
      },
      "coproDescription": "COPRO: يمثل إعداد <strong>الحد الأقصى للتكرارات</strong> عمق التحسين ({{depth}}). يقيّم كل عمق عدة مطالبات مقترحة (العرض {{breadth}})، لذا يسرد مخطط النتيجة {{candidatesTracked}} — وليس نقطة واحدة فقط لكل خطوة عمق.",
      "coproScoredCandidates": "{{count}} مرشحًا تم تقييمه",
      "coproOneRowPerCandidate": "صف واحد لكل مرشح تم تقييمه",
      "miproDescription": "MIPROv2: يمثل <strong>الحد الأقصى للتكرارات</strong> ({{trials}}) عدد تجارب التحسين البايزي. تعرض قائمة المخطط والمرشحين المطالبات التي تم تقييمها على مجموعة التحقق <strong>الكاملة</strong> (يتم استبعاد الفحوصات ذات الدُفعات الصغيرة فقط)، لذا قد يختلف عدد الصفوف ({{rows}}) عن عدد التجارب — خاصة عند تفعيل التقسيم إلى دُفعات صغيرة.",
      "scoreChartTitle": "تقدّم النتيجة",
      "chartTooltip": "التكرار {{iteration}}: {{score}}",
      "chartTooltipBestSuffix": " (الأفضل)",
      "insights": {
        "title": "رؤى المحسّن",
        "foundationModel": "النموذج الأساسي",
        "judgeModel": "نموذج التقييم",
        "evalMetrics": "مقاييس التقييم",
        "mutationModel": "نموذج الطفرة",
        "targetScore": "النتيجة المستهدفة",
        "timeBudget": "الميزانية الزمنية",
        "defaultModel": "افتراضي (الافتراضي على الخادم)"
      },
      "componentsTitle": "المكوّنات المحسّنة",
      "rowEvaluations": {
        "title": "التقييمات على مستوى الصفوف",
        "sourceLabel": "المصدر:",
        "source": {
          "optimization_trace": "أفضل تمريرة معيارية من تتبع المحسّن",
          "final_eval": "تقييم بعد التشغيل للمطالبة المحسّنة على مجموعة البيانات",
          "none": "لم يتم تقييم أي صفوف من مجموعة البيانات لهذا التشغيل",
          "failed": "تعذّر التقاط لقطة الصفوف"
        },
        "metricsConfigured": "المقاييس المهيأة: {{metrics}}.",
        "emptyFailed": "انتهى المحسّن، ولكن فشل حفظ النتائج لكل صف. تحقق من سجلات الخادم.",
        "emptyNoDataset": "لم ينتج هذا التشغيل نتائج على مستوى الصفوف (لا توجد مجموعة بيانات أو صفوف تقييم).",
        "emptyDefault": "لم يتم إرجاع أي صفوف على مستوى الصفوف لهذه الجلسة.",
        "columns": {
          "index": "#",
          "input": "الإدخال / السؤال",
          "generatedAnswer": "الإجابة المولّدة",
          "metrics": "المقاييس",
          "score": "النتيجة",
          "reasoning": "التعليل"
        },
        "expectedOutput": "المخرجات المتوقعة"
      },
      "candidates": {
        "title": "المطالبات المرشحة ({{count}})",
        "iteration": "التكرار {{iteration}}",
        "candidateLabel": "المرشح {{index}}",
        "best": "الأفضل",
        "driftRejected": "مرفوض بسبب الانحراف",
        "guardrails": "الضوابط الوقائية",
        "rejectionReason": "سبب الرفض:"
      },
      "trace": {
        "title": "تتبع التحسين ({{count}} إدخال)",
        "iter": "تكرار {{iteration}}"
      },
      "abTest": {
        "dailyTrafficLabel": "حركة المرور اليومية المتوقعة (اختياري):",
        "dailyTrafficPlaceholder": "مثال: 10000",
        "generateButton": "إنشاء اختبار A/B",
        "generating": "جارٍ الإنشاء…",
        "variantsLabel": "المتغيرات",
        "sampleSizeLabel": "حجم العينة لكل متغير",
        "sampleSizeValue": "{{perVariant}} (الإجمالي {{total}})",
        "improvementCiLabel": "التحسّن (فاصل الثقة)",
        "recommendedDurationLabel": "المدة الموصى بها",
        "durationDays": "~{{days}} يومًا",
        "durationHours": "~{{hours}} ساعة",
        "variantPromptsSummary": "مطالبات المتغيرات",
        "controlLabel": "الضابط (A)",
        "treatmentLabel": "المعالجة (B)"
      },
      "metadataLabels": {
        "meta_model": "النموذج الفوقي",
        "reflection_model": "نموذج الانعكاس",
        "stale_rounds": "الجولات الراكدة",
        "population_size": "حجم المجتمع",
        "gradient_model": "نموذج التدرج",
        "mutation_model": "نموذج الطفرة",
        "gen_model": "نموذج التوليد",
        "policy_model": "نموذج السياسة",
        "optimizer_model": "نموذج المحسّن",
        "compiler": "مترجم DSPy",
        "dspy_version": "إصدار DSPy",
        "dspy_copro": "COPRO (العمق / العرض)",
        "final_avg_reward": "متوسط المكافأة النهائي",
        "baseline_reward": "المكافأة الأساسية",
        "reward_function": "دالة المكافأة",
        "objectives": "الأهداف",
        "pareto_size": "حجم جبهة باريتو",
        "early_stopping_reason": "الإيقاف المبكر",
        "ensemble_frameworks": "الأطر الفرعية للتجميع",
        "fusion_strategy": "استراتيجية الدمج"
      },
      "frameworkTier": {
        "dspy": "تحسين البرنامج التصريحي",
        "opro": "المطالبة الفوقية / نموذج اللغة كمحسّن",
        "reflexion": "التحسين الذاتي التأملي",
        "gepa": "البحث التطوري التأملي",
        "evoprompt": "البحث التطوري + نموذج اللغة",
        "ape": "هندسة المطالبات التلقائية",
        "textgrad": "الانتشار الخلفي النصي",
        "rl_tuning": "تحسين السياسة القائم على التعلم المعزز",
        "rag_aware": "التحسين المشترك المعزز بالاسترجاع",
        "multi_obj": "تحسين باريتو متعدد الأهداف",
        "ensemble": "دمج الأطر المتعددة",
        "cot": "المطالبة المهيكلة بالاستدلال"
      }
    },
    "comparison": {
      "backAriaLabel": "رجوع",
      "title": "مقارنة عمليات تشغيل التحسين",
      "subtitle": "حدد مطالبة، ثم اختر عمليتي تشغيل مكتملتين أو أكثر لمقارنة المسارات والأطر والمخرجات المحسّنة",
      "promptFieldLabel": "المطالبة",
      "promptPlaceholder": "اختر مطالبة...",
      "runsFieldLabel": "عمليات تشغيل التحسين",
      "runsFilterLabel": "عمليات تشغيل التحسين",
      "selectPromptFirst": "اختر مطالبة أولاً",
      "loadingRuns": "جارٍ التحميل…",
      "noCompletedRuns": "لا توجد عمليات تشغيل مكتملة",
      "clearSelection": "مسح التحديد",
      "compareButton": "مقارنة ({{count}} محددة)",
      "selectAtLeastTwo": "حدد عمليتي تشغيل على الأقل للمقارنة.",
      "genericCompareError": "فشلت مقارنة الجلسات",
      "scoreTrajectoriesTitle": "مسارات النتائج",
      "yAxisScore": "النتيجة",
      "xAxisIteration": "التكرار",
      "summaryTitle": "الملخص",
      "exportCsvTitle": "تصدير CSV",
      "columns": {
        "framework": "الإطار",
        "original": "الأصلي",
        "optimized": "المحسّن",
        "improvement": "التحسّن",
        "holdout": "مجموعة الاختبار",
        "duration": "المدة",
        "iterations": "التكرارات",
        "actions": "الإجراءات"
      },
      "view": "عرض",
      "promptComparisonTitle": "مقارنة المطالبات",
      "selectPromptVersion": "اختر إصدار المطالبة...",
      "originalPromptLabel": "الأصلي",
      "optimizedPromptLabel": "المحسّن",
      "originalPromptOption": "المطالبة الأصلية",
      "noPromptContent": "(لا يوجد محتوى مطالبة متاح)",
      "csv": {
        "sessionId": "معرّف الجلسة",
        "framework": "الإطار",
        "originalScore": "النتيجة الأصلية",
        "optimizedScore": "النتيجة المحسّنة",
        "improvementPct": "نسبة التحسّن %",
        "holdoutScore": "نتيجة مجموعة الاختبار",
        "duration": "المدة",
        "iterations": "التكرارات",
        "evaluations": "التقييمات"
      }
    },
    "editPage": {
      "backAriaLabel": "العودة إلى المطالبات",
      "backToPrompts": "العودة إلى المطالبات",
      "platformTooltip": "مطالبة نظام مضمّنة في الكود — للقراءة فقط",
      "platformBadge": "المنصة",
      "versionsCount": "{{count}} إصدار",
      "targetModelTooltip": "النموذج المستهدف",
      "allModels": "جميع النماذج",
      "changeModelTooltip": "تغيير النموذج أو الاستنساخ",
      "changeModelHeader": "تغيير النموذج",
      "modelAgnostic": "غير مرتبط بنموذج (جميع النماذج)",
      "autoSavingAriaLabel": "جارٍ الحفظ التلقائي للوصف",
      "autoSaving": "جارٍ الحفظ التلقائي...",
      "autoSaveTooltip": "يتم حفظ الوصف تلقائيًا فقط. تتطلب تغييرات محتوى المطالبة تنفيذ commit يدويًا.",
      "loadingPrompt": "جارٍ تحميل المطالبة...",
      "notFound": "المطالبة غير موجودة",
      "contentPlaceholder": "أدخل محتوى المطالبة... استخدم {{syntax}} للإشارة إلى متغيرات الحالة.",
      "comingSoon": "قريبًا...",
      "targetModelLabel": "النموذج المستهدف *",
      "selectModelPlaceholder": "اختر نموذجًا...",
      "cloning": "جارٍ الاستنساخ...",
      "tabs": {
        "text": "نص المطالبة",
        "diffs": "اختلافات المطالبة",
        "testing": "اختبار المطالبة",
        "evals": "تقييمات المطالبة",
        "metrics": "المقاييس"
      },
      "testing": {
        "title": "اختبار المطالبة",
        "description": "اختبر مطالباتك بمدخلات ونماذج مختلفة"
      },
      "evals": {
        "title": "تقييمات المطالبة",
        "description": "قيّم أداء المطالبة ومقاييس الجودة"
      },
      "metrics": {
        "title": "مقاييس التحسين",
        "description": "تم إنشاء هذا الإصدار عن طريق تحسين الذكاء الاصطناعي",
        "descriptionWithFramework": "تم إنشاء هذا الإصدار عن طريق تحسين الذكاء الاصطناعي ({{framework}})",
        "baselineScore": "درجة الأساس",
        "optimizedScore": "الدرجة بعد التحسين",
        "improvement": "نسبة التحسن",
        "iterations": "عدد التكرارات",
        "evaluations": "عدد التقييمات",
        "duration": "المدة",
        "viewAllRuns": "عرض جميع عمليات التحسين"
      },
      "toast": {
        "retagged": "تمت إعادة الوسم إلى \"{{modelId}}\"",
        "setModelAgnostic": "تم الضبط ليكون غير مرتبط بنموذج",
        "cloned": "تم استنساخ المطالبة لـ \"{{modelId}}\"",
        "forkedSuccess": "تم تفريع الإصدار بنجاح",
        "noChangesToCommit": "لا توجد تغييرات لتنفيذ commit عليها",
        "enterCommitMessage": "يرجى إدخال رسالة commit",
        "platformReadOnlyFork": "مطالبات المنصة للقراءة فقط ولا يمكن تفريعها",
        "platformReadOnlyModify": "مطالبات المنصة للقراءة فقط ولا يمكن تعديلها"
      }
    },
    "playground": {
      "loadingPlayground": "جارٍ تحميل ساحة التجربة...",
      "unableToLoad": "تعذر تحميل المطالبة. يرجى المحاولة مرة أخرى.",
      "unableToLoadSessions": "تعذر تحميل جلسات المحادثة.",
      "headerTitle": "{{name}} — ساحة التجربة",
      "versionOption": "الإصدار {{version}}",
      "versionOptionCurrent": "الإصدار {{version}} (الحالي)",
      "selectModelOption": "اختر نموذجًا...",
      "loadingSession": "جارٍ تحميل الجلسة...",
      "noModelSelected": "لم يتم تحديد نموذج",
      "typeMessage": "اكتب رسالة...",
      "emptyStateTitleFallback": "ساحة التجربة",
      "emptyStateMessage": "ابدأ باختبار مطالبتك",
      "noResponseGenerated": "(لم يتم إنشاء أي رد)",
      "toast": {
        "noModelsAvailable": "لا توجد نماذج متاحة",
        "promptNotLoaded": "لم يتم تحميل المطالبة",
        "noModelsAvailableAddOne": "لا توجد نماذج متاحة. يرجى إضافة نموذج أولاً.",
        "switchedModel": "تم التبديل إلى {{name}}",
        "stopBeforeSending": "يرجى إيقاف الرد الحالي قبل إرسال رسالة جديدة",
        "uploadAttachmentsFailed": "فشل تحميل المرفقات",
        "messageNotFoundForRetry": "لم يتم العثور على الرسالة لإعادة المحاولة",
        "noUserMessageToRegenerate": "لم يتم العثور على رسالة مستخدم لإعادة إنشائها",
        "cannotRegenerateEmptyContent": "لا يمكن إعادة الإنشاء: رسالة المستخدم لا تحتوي على محتوى",
        "cannotRetryMessageType": "لا يمكن إعادة محاولة هذا النوع من الرسائل",
        "addAttachmentFailed": "فشل إضافة المرفق: {{name}}"
      }
    },
    "runsPage": {
      "title": "تحسين المطالبات",
      "subtitle": "سجل جميع عمليات التحسين عبر مطالباتك",
      "backToPrompts": "العودة إلى المطالبات",
      "compareRuns": "مقارنة العمليات",
      "newOptimization": "تحسين جديد",
      "loadingMessage": "جارٍ تحميل عمليات التحسين...",
      "emptyMessage": "لا توجد عمليات تحسين حتى الآن. انقر على \"تحسين جديد\" للبدء.",
      "status": {
        "queued": "في الانتظار",
        "running": "قيد التشغيل",
        "completed": "مكتمل",
        "failed": "فشل",
        "cancelled": "ملغى"
      },
      "columns": {
        "promptName": "اسم المطالبة",
        "framework": "الإطار",
        "status": "الحالة",
        "metrics": "المقاييس",
        "improvementPct": "نسبة التحسين %",
        "cost": "التكلفة",
        "tokens": "الرموز",
        "createdBy": "أنشأه",
        "createdAt": "تاريخ الإنشاء",
        "updatedAt": "تاريخ التحديث",
        "actions": "الإجراءات"
      },
      "tokensTooltip": "المطالبة: {{prompt}} | الإكمال: {{completion}}",
      "actions": {
        "retry": "إعادة المحاولة",
        "delete": "حذف"
      },
      "retryConfirm": "هل تريد بدء تحسين جديد لـ \"{{label}}\" باستخدام نفس الإطار والخيارات المستخدمة في هذه العملية؟",
      "retryDefaultLabel": "هذه المطالبة",
      "deleteConfirm": "حذف جلسة التحسين الخاصة بـ \"{{label}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteDefaultLabel": "هذه الجلسة",
      "toast": {
        "newRunStarted": "تم بدء عملية تحسين جديدة.",
        "retryFailed": "فشلت إعادة محاولة التحسين.",
        "sessionDeleted": "تم حذف جلسة التحسين.",
        "deleteSessionFailed": "فشل حذف الجلسة.",
        "bulkDeleteWarning": "تم حذف {{deleted}} عملية؛ تعذر حذف {{skipped}}.{{detail}}",
        "bulkDeleteSuccess_other": "تم حذف {{count}} عملية تحسين.",
        "bulkDeleteFailed": "فشل حذف عمليات التحسين المحددة."
      },
      "bulkDelete": {
        "selectedLabel": "حذف المحدد",
        "title": "حذف العمليات المحددة",
        "message_other": "هل أنت متأكد من حذف {{count}} عملية تحسين؟ لا يمكن التراجع عن هذا الإجراء.",
        "confirmLabel_other": "حذف {{count}} عملية"
      }
    },
    "optimizationLogModal": {
      "title": {
        "complete": "اكتمل التحسين",
        "cancelled": "تم إلغاء التحسين",
        "failed": "فشل التحسين",
        "running": "جارٍ التحسين..."
      },
      "subtitleDefault": "المطالبة",
      "closeAriaLabel": "إغلاق",
      "progressLabel": "التقدم",
      "statusLabel": "الحالة:",
      "statusStarting": "جارٍ البدء",
      "iterationSuffix": " · التكرار {{iteration}}/{{max}}",
      "bestSuffix": " · الأفضل: {{value}}",
      "runIdLabel": "معرّف العملية:",
      "jobIdLabel": "معرّف المهمة:",
      "initializingEngine": "جارٍ تهيئة محرك {{framework}}...",
      "loadingDataset": "جارٍ تحميل مجموعة بيانات القياس",
      "completedIterations": "اكتمل {{completed}}/{{max}} من التكرارات",
      "cancelRun": "إلغاء العملية",
      "viewResults": "عرض النتائج"
    },
    "commitMessageModal": {
      "title": "تثبيت الإصدار",
      "closeAriaLabel": "إغلاق",
      "description": "أدخل رسالة تثبيت لوصف التغييرات في هذا الإصدار.",
      "placeholder": "مثال: إصلاح خطأ إملائي في المطالبة، إضافة أمثلة جديدة...",
      "commit": "تثبيت",
      "committing": "جارٍ التثبيت..."
    },
    "diffView": {
      "noVersionsTitle": "لا توجد إصدارات للمقارنة",
      "noVersionsDesc": "أنشئ المزيد من الإصدارات لرؤية الفروقات بينها.",
      "baseLabel": "الأساس:",
      "compareLabel": "المقارنة:",
      "swapTooltip": "تبديل الأساس والمقارنة",
      "fileLabel": "prompt.txt",
      "collapseContextTooltip": "طي السياق",
      "expandContextTooltip": "توسيع السياق",
      "copyDiffTooltip": "نسخ الفروقات",
      "loadingDiff": "جارٍ تحميل الفروقات...",
      "expandHiddenLines": "إظهار {{count}} سطر مخفي",
      "sameVersionTitle": "تم تحديد نفس الإصدار",
      "sameVersionDesc": "اختر إصدارات مختلفة لرؤية الفروقات.",
      "noDifferencesTitle": "لا توجد فروقات",
      "noDifferencesDesc": "هذه الإصدارات متطابقة.",
      "toast": {
        "copied": "تم نسخ الفروقات إلى الحافظة"
      }
    },
    "versionList": {
      "title": "الإصدارات",
      "refreshTooltip": "تحديث الإصدارات",
      "searchPlaceholder": "البحث عن إصدارات...",
      "emptyMessage": "لم يتم العثور على إصدارات"
    },
    "versionItem": {
      "commitTooltip": "تثبيت الإصدار",
      "commitLabel": "تثبيت",
      "forkTooltip": "تفريع الإصدار {{version}}",
      "forkLabel": "تفريع",
      "createdByPrefix": "بواسطة {{name}}",
      "wordCount_other": "{{count}} كلمة"
    },
    "visibilitySelector": {
      "label": "الرؤية",
      "platformDescription": "متاح عبر جميع المشاريع داخل المنصة",
      "projectDescription": "متاح فقط داخل المشروع المحدد",
      "platformHint": "ستكون المطالبة متاحة عبر جميع المشاريع داخل المنصة.",
      "projectHint": "ستكون المطالبة متاحة فقط داخل المشروع المحدد.",
      "projectLabel": "المشروع",
      "selectProjectPlaceholder": "اختر مشروعًا",
      "searchProjectsPlaceholder": "البحث عن مشاريع..."
    }
  },
  "data": {
    "tabs": {
      "knowledge": "المعرفة",
      "graph": "الرسم البياني",
      "vector": "قاعدة بيانات المتجهات",
      "storage": "التخزين"
    }
  },
  "knowledge": {
    "connections": {
      "tabs": {
        "databases": "قواعد البيانات",
        "storage": "حسابات التخزين",
        "orchestrators": "أدوات التنسيق",
        "telephony": "الاتصالات الهاتفية"
      }
    },
    "connectorsTab": {
      "testErrorToast": "فشل اختبار الاتصال",
      "batchTestSuccessToast_one": "نجح اختبار الاتصال لـ {{count}} اتصال مستورد",
      "batchTestSuccessToast_other": "نجح اختبار الاتصال لـ {{count}} اتصالات مستوردة",
      "batchTestFailedToast_one": "فشل اختبار الاتصال لـ {{count}} اتصال مستورد",
      "batchTestFailedToast_other": "فشل اختبار الاتصال لـ {{count}} اتصالات مستوردة",
      "batchTestFinishedToast": "انتهت اختبارات الاتصال: نجح {{success}}، وفشل {{fail}}",
      "loadErrorToast": "فشل تحميل الموصلات",
      "loadingMessage": "جارٍ تحميل الاتصالات...",
      "filterResourceLabel": {
        "database": "محرك قاعدة البيانات",
        "storage": "نوع التخزين",
        "orchestrator": "نوع أداة التنسيق",
        "telephony": "نوع الاتصالات الهاتفية"
      },
      "filterAllTypesPlaceholder": "جميع الأنواع",
      "filterCreatorLabel": "المُنشئ",
      "filterAllCreatorsPlaceholder": "جميع المُنشئين",
      "filterStatusLabel": "الحالة",
      "filterAllStatusesPlaceholder": "جميع الحالات",
      "filterStatusError": "خطأ",
      "deletePermissionDeniedToast": "لا تملك إذن حذف هذا الموصل",
      "deleteErrorToast": "فشل حذف الموصل",
      "bulkDeletePermissionDeniedToast": "لا تملك إذن حذف الموصلات",
      "bulkDeletePartialWarning": "تم حذف {{deleted}} موصل(ات)، وفشل {{skipped}}: {{errors}}",
      "bulkDeleteSuccessToast_one": "تم حذف {{count}} موصل بنجاح",
      "bulkDeleteSuccessToast_other": "تم حذف {{count}} موصلات بنجاح",
      "bulkDeleteErrorToast": "فشل حذف الموصلات",
      "unsetDefaultToast": "{{name}} لم يعد {{category}} الافتراضي",
      "setDefaultToast": "{{name}} هو الآن {{category}} الافتراضي",
      "unsetDefaultErrorToast": "فشل إزالة {{category}} الافتراضي",
      "setDefaultErrorToast": "فشل تعيين {{category}} الافتراضي",
      "status": {
        "active": "نشط",
        "failed": "فشل",
        "notTested": "لم يتم اختباره",
        "unknown": "غير معروف"
      },
      "statusTooltip": "الحالة: {{status}}",
      "authModeTooltip": "المصادقة: {{mode}}",
      "columnName": "الاسم",
      "columnCloud": "السحابة",
      "columnResource": "المورد",
      "columnType": "النوع",
      "columnHost": "المضيف",
      "columnStatus": "الحالة",
      "columnLastTested": "آخر اختبار",
      "columnCreatedBy": "أنشأه",
      "columnUpdatedBy": "حدّثه",
      "columnActions": "الإجراءات",
      "actionView": "عرض",
      "actionTestConnection": "اختبار الاتصال",
      "actionRemoveAsDefault": "إزالة كـ {{category}} افتراضي",
      "actionSetAsDefault": "تعيين كافتراضي",
      "actionExport": "تصدير",
      "actionEdit": "تعديل",
      "actionDelete": "حذف",
      "entityFilterAllLabel": "الكل",
      "entityFilterFavoritesLabel": "المفضلة",
      "bulkExportSelected": "تصدير المحدد",
      "bulkDeleteSelected": "حذف المحدد",
      "emptyMessage": "لم يتم العثور على موصلات. أضف اتصالاً للاتصال بقواعد البيانات أو التخزين أو مصادر بيانات أخرى.",
      "addConnection": "إضافة اتصال",
      "deleteDialogTitle": "حذف الموصل",
      "deleteDialogMessage": "هل أنت متأكد أنك تريد حذف \"{{name}}\"؟ سيؤدي ذلك أيضًا إلى حذف جميع الجداول المسجلة من هذا الموصل.",
      "deleteDialogConfirmLabel": "حذف",
      "bulkDeleteDialogTitle": "حذف الموصلات المحددة",
      "bulkDeleteDialogMessage_one": "هل أنت متأكد أنك تريد حذف {{count}} موصل؟ سيؤدي ذلك أيضًا إلى حذف جميع الجداول المسجلة من هذه الموصلات. لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteDialogMessage_other": "هل أنت متأكد أنك تريد حذف {{count}} موصلات؟ سيؤدي ذلك أيضًا إلى حذف جميع الجداول المسجلة من هذه الموصلات. لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteDialogConfirmLabel_one": "حذف {{count}} موصل",
      "bulkDeleteDialogConfirmLabel_other": "حذف {{count}} موصلات"
    },
    "tab": {
      "unknownConnectorType": "غير معروف",
      "filterEngineLabel": "محرك قاعدة البيانات",
      "filterAllEnginesPlaceholder": "جميع المحركات",
      "filterCreatorLabel": "المُنشئ",
      "filterAllCreatorsPlaceholder": "جميع المُنشئين",
      "deleteErrorToast": "فشل حذف جدول المعرفة",
      "bulkDeletePartialWarning": "تم حذف {{deleted}} جدول(ول)، وفشل {{skipped}}: {{errors}}",
      "bulkDeleteSuccessToast_one": "تم حذف {{count}} جدول بنجاح",
      "bulkDeleteSuccessToast_other": "تم حذف {{count}} جداول بنجاح",
      "bulkDeleteErrorToast": "فشل حذف الجداول",
      "deleteSchemaErrorToast": "فشل حذف المخطط",
      "deleteSchemaPartialWarning": "تم حذف {{deleted}} جدول(ول) عبر {{schemaCount}} مخطط(ات)؛ وفشل {{skipped}}",
      "deleteSchemaSuccessToast_one": "تم حذف المخطط ({{count}} جدول)",
      "deleteSchemaSuccessToast_other": "تم حذف المخطط ({{count}} جداول)",
      "deleteSchemaSuccessToastNamed_one": "تم حذف المخطط \"{{schema}}\" ({{count}} جدول)",
      "deleteSchemaSuccessToastNamed_other": "تم حذف المخطط \"{{schema}}\" ({{count}} جداول)",
      "deleteSchemasSuccessToast_one": "تم حذف {{schemaCount}} مخططات ({{count}} جدول)",
      "deleteSchemasSuccessToast_other": "تم حذف {{schemaCount}} مخططات ({{count}} جداول)",
      "syncRequeuedToast": "أُعيدت جدولة مزامنة البيانات الوصفية (كانت متوقفة) لـ '{{name}}'",
      "syncQueuedToast": "تمت جدولة مزامنة البيانات الوصفية لـ '{{name}}'",
      "syncQueueErrorToast": "فشل جدولة مزامنة البيانات الوصفية لـ '{{name}}'",
      "bulkSyncStartedRequeuedToast_one": "بدأت مزامنة البيانات الوصفية لـ {{count}} جدول (أُعيدت جدولة أي فحص متوقف)",
      "bulkSyncStartedRequeuedToast_other": "بدأت مزامنة البيانات الوصفية لـ {{count}} جداول (أُعيدت جدولة أي فحص متوقف)",
      "bulkSyncStartedToast_one": "بدأت مزامنة البيانات الوصفية لـ {{count}} جدول",
      "bulkSyncStartedToast_other": "بدأت مزامنة البيانات الوصفية لـ {{count}} جداول",
      "bulkSyncStartErrorToast": "فشل بدء مزامنة البيانات الوصفية الجماعية",
      "columnName": "الاسم",
      "defaultBadgeTooltip": "افتراضي",
      "schemaTooltip": "المخطط: {{schema}}",
      "columnDatabase": "قاعدة البيانات",
      "columnType": "النوع",
      "columnRows": "الصفوف",
      "columnIntrospection": "الفحص الداخلي",
      "syncStatus": {
        "queued": "في الانتظار",
        "running": "قيد التشغيل",
        "synced": "تمت المزامنة",
        "failed": "فشل",
        "active": "نشط"
      },
      "viewSyncLogsTooltip": "عرض سجلات المزامنة",
      "columnStatus": "الحالة",
      "columnCreated": "تاريخ الإنشاء",
      "columnUpdated": "تاريخ التحديث",
      "columnCreator": "المُنشئ",
      "unknownCreator": "غير معروف",
      "columnLogs": "السجلات",
      "viewLink": "عرض",
      "columnActions": "الإجراءات",
      "actionViewDetails": "عرض التفاصيل",
      "actionPreviewData": "معاينة البيانات",
      "actionApprovals": "الموافقات",
      "actionEvals": "التقييمات",
      "actionEdit": "تعديل",
      "actionRequeueSync": "إعادة جدولة مزامنة البيانات الوصفية",
      "actionSyncMetadata": "مزامنة البيانات الوصفية",
      "actionExport": "تصدير",
      "actionDelete": "حذف",
      "databaseViewLabel": "عرض قاعدة البيانات",
      "collectionViewLabel": "عرض المجموعة",
      "addGraphTable": "إضافة جدول رسم بياني",
      "addKnowledgeTable": "إضافة جدول معرفة",
      "leafTitleTables": "الجداول",
      "leafTitleGraphTables": "جداول الرسم البياني",
      "defaultSchemaLabel": "(افتراضي)",
      "entityFilterAllLabel": "الكل",
      "entityFilterFavoritesLabel": "المفضلة",
      "noGraphConnectorsEmptyMessage": "لا توجد موصلات قاعدة بيانات رسم بياني حتى الآن.",
      "noDataConnectorsEmptyMessage": "لا توجد موصلات بيانات حتى الآن.",
      "schemasPaneTitle": "المخططات",
      "bulkExportSelected": "تصدير المحدد",
      "bulkSyncMetadata": "مزامنة البيانات الوصفية",
      "bulkDeleteSelected": "حذف المحدد",
      "graphDataExplorerAriaLabel": "مستعرض بيانات الرسم البياني",
      "knowledgeDataExplorerAriaLabel": "مستعرض بيانات المعرفة",
      "deleteDialogTitle": "حذف جدول المعرفة",
      "deleteDialogMessage": "هل أنت متأكد أنك تريد حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteDialogConfirmLabel": "حذف",
      "deleteSchemaDialogTitle": "حذف المخطط",
      "deleteSchemasDialogTitle": "حذف المخططات",
      "deleteSchemaDialogMessage_one": "هل أنت متأكد أنك تريد حذف المخطط \"{{schema}}\" و {{count}} جدول مسجل فيه؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deleteSchemaDialogMessage_other": "هل أنت متأكد أنك تريد حذف المخطط \"{{schema}}\" و {{count}} جداول مسجلة فيه؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deleteSchemasDialogMessage_one": "هل أنت متأكد أنك تريد حذف {{schemaCount}} مخططات و {{count}} جدول مسجل فيها؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deleteSchemasDialogMessage_other": "هل أنت متأكد أنك تريد حذف {{schemaCount}} مخططات و {{count}} جداول مسجلة فيها؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deletingLabel": "جارٍ الحذف…",
      "deleteSchemasDialogConfirmLabel": "حذف {{count}} مخططات",
      "andOthersLabel": "{{names}} و {{count}} أخرى",
      "bulkDeleteDialogTitle": "حذف الجداول المحددة",
      "bulkDeleteDialogMessage_one": "هل أنت متأكد أنك تريد حذف {{count}} جدول؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteDialogMessage_other": "هل أنت متأكد أنك تريد حذف {{count}} جداول؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkDeleteDialogConfirmLabel_one": "حذف {{count}} جدول",
      "bulkDeleteDialogConfirmLabel_other": "حذف {{count}} جداول",
      "emptyStatePermissionDenied": "ليس لديك إذن لعرض {{resource}}. تواصل مع المسؤول للحصول على إذن الوصول.",
      "emptyStateSearching": "لم يتم العثور على {{resource}} مطابقة لبحثك.",
      "emptyStateDefault": "لم يتم العثور على {{resource}}. أنشئ أول {{resourceSingular}} للبدء.",
      "resourceGraphTables": "جداول الرسم البياني",
      "resourceGraphTable": "جدول رسم بياني",
      "resourceKnowledgeTables": "جداول المعرفة",
      "resourceKnowledgeTable": "جدول معرفة"
    },
    "addTableModal": {
      "title": "إضافة جدول معرفة",
      "closeDialogAriaLabel": "إغلاق مربع الحوار",
      "cancelButton": "إلغاء",
      "loadConnectorsError": "فشل تحميل الموصلات",
      "noDatabasesFoundWarning": "لم يتم العثور على قواعد بيانات. قد لا يتمكن الموصل من الوصول إلى أي قاعدة بيانات.",
      "loadTablesTimedOut": "انتهت مهلة تحميل الجداول. جرّب نطاقًا أضيق أو تحقق من اتصالك.",
      "loadTablesForSchemaError": "فشل تحميل الجداول للمخطط",
      "loadingTablesForSchema": "جارٍ تحميل الجداول لـ {{schema}}...",
      "schemaFallbackLabel": "المخطط",
      "inlineSearch": {
        "defaultPlaceholder": "بحث",
        "clearAriaLabel": "مسح البحث"
      },
      "breadcrumb": {
        "backAriaLabel": "رجوع",
        "schemasCount_one": "{{count}} مخطط",
        "schemasCount_other": "{{count}} مخططات"
      },
      "connectorSelection": {
        "emptyTitle": "لا توجد موصلات",
        "emptyMessage": "أنشئ موصلاً أولاً لإضافة جداول معرفة",
        "filterByTypeLabel": "التصفية حسب نوع الموصل",
        "connectorTypeLabel": "نوع الموصل",
        "allConnectorTypesPlaceholder": "جميع أنواع الموصلات ({{count}})",
        "searchPlaceholder": "بحث عن الموصلات",
        "noMatchingConnections": "لا توجد اتصالات مطابقة. عدّل البحث أو اختر نوع موصل آخر."
      },
      "databaseSelection": {
        "loadingCatalog": "جارٍ تحميل الكتالوج…",
        "catalogUnavailableTitle": "الكتالوج غير متاح",
        "catalogUnavailableMessage": "تعذّر تحميل الكتالوج. تحقق من تكوين الموصل وحاول مرة أخرى.",
        "noDatabasesTitle": "لم يتم العثور على قواعد بيانات",
        "noDatabasesMessage": "لا يتمكن الموصل من الوصول إلى أي قاعدة بيانات، أو فشل الفحص الداخلي.",
        "title": "اختيار قاعدة بيانات",
        "countLabel_one": "{{shown}} من {{count}} قاعدة بيانات",
        "countLabel_other": "{{shown}} من {{count}} قواعد بيانات",
        "searchPlaceholder": "بحث عن قواعد البيانات",
        "noMatchMessage": "لا توجد قواعد بيانات مطابقة لبحثك.",
        "schemaCount_one": "{{count}} مخطط",
        "schemaCount_other": "{{count}} مخططات"
      },
      "schemaSelection": {
        "title": "اختيار مخطط",
        "countLabel_one": "{{shown}} من {{count}} مخطط",
        "countLabel_other": "{{shown}} من {{count}} مخططات",
        "selectedCount": "تم تحديد {{count}}",
        "deselectAll": "إلغاء تحديد الكل",
        "selectAll": "تحديد الكل",
        "continueWith_one": "الاستمرار مع {{count}} مخطط",
        "continueWith_other": "الاستمرار مع {{count}} مخططات",
        "searchPlaceholder": "بحث عن المخططات",
        "hint": "حدّد المخططات واضغط على استمرار لتصفحها واحدًا تلو الآخر، أو انقر على بطاقة لفتح مخطط واحد.",
        "noMatchMessage": "لا توجد مخططات مطابقة لبحثك.",
        "selectSchemaAriaLabel": "تحديد المخطط {{schema}}",
        "tableCount_one": "{{count}} جدول",
        "tableCount_other": "{{count}} جداول",
        "clickToLoadTables": "انقر لتحميل الجداول"
      },
      "tableSelection": {
        "loadingTables": "جارٍ تحميل الجداول…",
        "noTablesFoundTitle": "لم يتم العثور على جداول",
        "noTablesInSchema": "لا توجد جداول متاحة في هذا المخطط",
        "noTablesInDatabase": "لا توجد جداول متاحة في هذه قاعدة البيانات",
        "hint": "يتم تحميل الجداول للمخطط المفتوح فقط. انقر على الصفوف أو استخدم مربع الاختيار في الرأس للتحديد.",
        "searchPlaceholder": "بحث عن الجداول",
        "showingCount": "عرض {{shown}} من {{count}}",
        "selectedAcrossSchemas": "تم تحديد {{count}} عبر المخططات",
        "deselectAllAriaLabel": "إلغاء تحديد جميع الجداول",
        "selectAllAriaLabel": "تحديد جميع الجداول",
        "columnTable": "الجدول",
        "columnDatabase": "قاعدة البيانات",
        "columnRows": "الصفوف",
        "columnCols": "الأعمدة",
        "noMatchMessage": "لا توجد جداول مطابقة لبحثك.",
        "selectTableAriaLabel": "تحديد {{label}}",
        "updateAvailableTooltip": "تتوفر عقد/تسميات جديدة",
        "updateAvailableBadge": "يتوفر تحديث",
        "alreadyRegisteredTooltip": "لقد سجّلت هذا الجدول مسبقًا",
        "registeredBadge": "مسجَّل"
      },
      "registrationStep": {
        "loadingTables": "جارٍ تحميل الجداول…",
        "selectedSchemasAriaLabel": "المخططات المحددة",
        "multiGraphRegistrationLabel": "تسجيل متعدد الرسوم البيانية:",
        "multiGraphRegistrationTextPrefix": "كل صف",
        "multiGraphRegistrationTextSuffix": "محدد يُسجَّل كأصل معرفي لذلك الرسم البياني.",
        "graphSchemaRegistrationLabel": "تسجيل مخطط الرسم البياني:",
        "graphSchemaRegistrationText": "سيتم تسجيل جداول الرسم البياني المحددة كإدخال واحد لمخطط الرسم البياني.",
        "relationshipTypesDetected_one": "تم اكتشاف {{count}} نوع علاقة.",
        "relationshipTypesDetected_other": "تم اكتشاف {{count}} أنواع علاقات.",
        "finalizeAndRegisterTitle": "إنهاء وتسجيل",
        "subtitleRegisterPrefix": "تسجيل",
        "subtitleChoosePrefix": "اختر كيفية استخدام هذه المعرفة، ثم سجّل",
        "subtitleGraphSchemaSuffix_one": "جدول رسم بياني كإدخال واحد لمخطط الرسم البياني.",
        "subtitleGraphSchemaSuffix_other": "جداول رسم بياني كإدخال واحد لمخطط الرسم البياني.",
        "subtitleGraphsSuffix_one": "رسم بياني في خطوة واحدة.",
        "subtitleGraphsSuffix_other": "رسومًا بيانية في خطوة واحدة.",
        "subtitleGraphTablesSuffix_one": "جدول رسم بياني في خطوة واحدة.",
        "subtitleGraphTablesSuffix_other": "جداول رسم بياني في خطوة واحدة.",
        "subtitleTablesSuffix_one": "جدول في خطوة واحدة.",
        "subtitleTablesSuffix_other": "جداول في خطوة واحدة.",
        "selectGraphTablesAbove": "حدّد جداول الرسم البياني أعلاه",
        "selectGraphsAbove": "حدّد الرسوم البيانية أعلاه",
        "selectTablesAbove": "حدّد الجداول أعلاه",
        "registerGraphSchema_one": "تسجيل مخطط الرسم البياني ({{count}} جدول رسم بياني)",
        "registerGraphSchema_other": "تسجيل مخطط الرسم البياني ({{count}} جداول رسم بياني)",
        "registerGraphs_one": "تسجيل {{count}} رسم بياني",
        "registerGraphs_other": "تسجيل {{count}} رسومات بيانية",
        "registerGraphTables_one": "تسجيل {{count}} جدول رسم بياني",
        "registerGraphTables_other": "تسجيل {{count}} جداول رسم بياني",
        "registerTables_one": "تسجيل {{count}} جدول",
        "registerTables_other": "تسجيل {{count}} جداول"
      },
      "introspectionError": {
        "thisConnection": "هذا الاتصال",
        "timedOut": "استغرق {{name}} وقتًا طويلاً للاستجابة.",
        "forbidden": "لا تملك صلاحية تصفح {{name}} — اطلب من مسؤول المشروع.",
        "credentialsRejected": "رفض {{name}} بيانات الاعتماد المحفوظة.",
        "missingSecret": "يفتقد {{name}} إلى كلمة مرور أو سر.",
        "databaseNotFound": "قاعدة البيانات أو الكتالوج المحفوظ على {{name}} لم يعد موجودًا.",
        "hostUnreachable": "تعذّر الوصول إلى المضيف المهيَّأ على {{name}}.",
        "serviceBusy": "{{name}} مشغول حاليًا.",
        "notConnecting": "{{name}} لا يتصل.",
        "genericFailure": "تعذّر تحميل الكتالوج من {{name}}.",
        "validateInConnections": "التحقق في الاتصالات",
        "tryAgain": "إعادة المحاولة"
      }
    },
    "editModal": {
      "title": "تعديل جدول المعرفة",
      "closeDialogAriaLabel": "إغلاق مربع الحوار",
      "vectorDbBadge": "قاعدة بيانات متجهية",
      "displayNameLabel": "الاسم المعروض",
      "displayNamePlaceholder": "أدخل الاسم المعروض",
      "nameAlreadyExistsToast": "يوجد جدول معرفة بهذا الاسم مسبقًا",
      "descriptionLabel": "الوصف",
      "descriptionPlaceholder": "أدخل الوصف (اختياري)",
      "knowledgeTypeLabel": "نوع المعرفة",
      "knowledgeTypeData": "بيانات",
      "knowledgeTypeDataHint": "= معرفة عامة.",
      "knowledgeTypeBenchmarks": "معايير قياسية",
      "knowledgeTypeBenchmarksFull": "معايير قياسية (التقييمات والمحاكاة)",
      "knowledgeTypeBenchmarksHint": "= تظهر في التقييمات والمحاكاة.",
      "knowledgeTypePlaceholder": "اختر نوع المعرفة...",
      "benchmarkTypeLabel": "نوع المعيار القياسي",
      "benchmarkTypeHint": "فئة عبء العمل المعروضة في علامة تبويب المعايير القياسية (Text2SQL، RAG، استخدام الأدوات، …).",
      "benchmarkTypePlaceholder": "اختر نوع المعيار القياسي…",
      "benchmarkIconLabel": "أيقونة المعيار القياسي",
      "benchmarkIconHint": "تظهر على بطاقة المعيار القياسي في التقييمات والمحاكاة. تعود إلى أيقونة الموصل عند عدم تعيين صورة.",
      "embeddingModelLabel": "نموذج التضمين",
      "embeddingModelHint": "اختر نموذج التضمين المستخدم لإنشاء المتجهات في هذا الجدول.",
      "embeddingModelPlaceholder": "اختر نموذج التضمين...",
      "searchModelsPlaceholder": "البحث في النماذج...",
      "loadingModelsMessage": "جارٍ تحميل نماذج التضمين...",
      "noModelsRegisteredMessage": "لا توجد نماذج تضمين مسجّلة. يرجى تسجيل نموذج تضمين أولاً.",
      "noModelSelectedWarning": "لم يتم تحديد نموذج تضمين. قد يفشل البحث المتجهي أو يعيد نتائج غير صحيحة.",
      "defaultBadge": "الافتراضي",
      "loadModelsErrorToast": "فشل تحميل نماذج التضمين",
      "updateErrorToast": "فشل تحديث جدول المعرفة",
      "cancelButton": "إلغاء",
      "savingButton": "جارٍ الحفظ...",
      "saveChangesButton": "حفظ التغييرات"
    },
    "modal": {
      "title": "تسجيل جداول لقاعدة المعرفة",
      "closeDialogAriaLabel": "إغلاق مربع الحوار",
      "registeringTooltip_one": "جارٍ تسجيل {{count}} جدول من {{name}}",
      "registeringTooltip_other": "جارٍ تسجيل {{count}} جداول من {{name}}",
      "registeringText_one": "جارٍ تسجيل {{count}} جدول من {{name}}",
      "registeringText_other": "جارٍ تسجيل {{count}} جداول من {{name}}",
      "registerSubmitLabel_one": "تسجيل {{count}} جدول",
      "registerSubmitLabel_other": "تسجيل {{count}} جداول",
      "tablesToRegisterLabel": "الجداول المطلوب تسجيلها",
      "columnsCount_one": "{{count}} عمود",
      "columnsCount_other": "{{count}} أعمدة",
      "rowsCount_one": "{{formattedCount}} صف",
      "rowsCount_other": "{{formattedCount}} صفوف",
      "columnsHeader": "الأعمدة",
      "notNullBadge": "NOT NULL",
      "cancelButton": "إلغاء"
    },
    "viewModal": {
      "title": "تفاصيل جدول المعرفة",
      "closeDialogAriaLabel": "إغلاق مربع الحوار",
      "closeButton": "إغلاق",
      "notAvailable": "غير متاح",
      "yesLabel": "نعم",
      "noLabel": "لا",
      "noneDetectedMessage": "لم يتم اكتشاف أي شيء",
      "statusUnknown": "غير معروف",
      "statusActive": "نشط",
      "statusError": "خطأ",
      "statusSyncing": "جارٍ المزامنة",
      "noErrorsMessage": "لا توجد أخطاء",
      "noColumnInfoMessage": "لا تتوفر معلومات عن الأعمدة",
      "basicInformationHeader": "المعلومات الأساسية",
      "tableInformationHeader": "معلومات الجدول",
      "graphInformationHeader": "معلومات الرسم البياني",
      "embeddingModelHeader": "نموذج التضمين",
      "columnsHeader": "الأعمدة",
      "errorInformationHeader": "معلومات الخطأ",
      "metadataHeader": "البيانات الوصفية",
      "auditInformationHeader": "معلومات التدقيق",
      "fieldId": "المعرف",
      "fieldConnector": "الموصل",
      "fieldStatus": "الحالة",
      "fieldDatabase": "قاعدة البيانات",
      "fieldSchema": "المخطط",
      "fieldTableName": "اسم الجدول",
      "fieldRowCountNodes": "عدد الصفوف (العقد)",
      "fieldTotalNodes": "إجمالي العقد",
      "fieldTotalEdges": "إجمالي الحواف",
      "fieldRelationshipTypes": "أنواع العلاقات",
      "fieldNodeLabels": "تسميات العقد",
      "fieldModel": "النموذج",
      "fieldErrorMessage": "رسالة الخطأ",
      "fieldCreatedAt": "تاريخ الإنشاء",
      "fieldUpdatedAt": "تاريخ التحديث",
      "fieldCreatedBy": "أنشأه",
      "fieldUpdatedBy": "حدّثه",
      "noEmbeddingModelConfiguredTitle": "لم يتم تكوين نموذج تضمين",
      "noEmbeddingModelConfiguredHint": "قد يفشل البحث المتجهي أو يعيد نتائج غير صحيحة. عدّل هذا الجدول لتعيين نموذج تضمين يطابق النموذج المستخدم لإنشاء المتجهات المخزنة.",
      "columnName": "الاسم",
      "columnType": "النوع",
      "columnNullable": "يقبل القيمة الفارغة"
    },
    "registerFields": {
      "embeddingModelLabel": "نموذج التضمين",
      "embeddingModelHint": "النموذج المستخدم للبحث الدلالي في هذه الجداول المتجهية.",
      "loadingModelsMessage": "جارٍ تحميل نماذج التضمين…",
      "noModelsRegisteredMessage": "لا توجد نماذج تضمين مسجّلة. سجّل نموذجًا أولاً.",
      "selectEmbeddingModelOption": "— اختر نموذج التضمين —",
      "defaultBadge": "الافتراضي",
      "managedVectorDbHint": "يدير هذا الموصل الفهارس والتضمينات داخليًا — لا حاجة لتعيين الأعمدة. سيُستخدم نموذج التضمين المحدد وقت الاستعلام لتضمين استعلام البحث.",
      "columnMappingLabel": "تعيين الأعمدة",
      "columnMappingHint": "عيّن أعمدة المعرف والمحتوى والتضمين للبحث المتجهي.",
      "columnLabelId": "المعرف",
      "columnLabelContent": "المحتوى",
      "columnLabelEmbedding": "التضمين",
      "columnFieldLabel": "عمود {{column}}",
      "selectOption": "— اختر —",
      "vectorSuffix": "متجه",
      "knowledgePurposeLabel": "الغرض من المعرفة",
      "knowledgeTypeData": "بيانات",
      "knowledgeTypeDataHint": "لاستخدام RAG العام.",
      "knowledgeTypeBenchmarks": "معايير قياسية",
      "knowledgeTypeBenchmarksHint": "تعرض هذه البيانات في التقييمات والمحاكاة.",
      "knowledgeTypeGroupAriaLabel": "نوع المعرفة",
      "encryptDataLabel": "تشفير بيانات الجدول أثناء التخزين للمُشاهدين",
      "encryptDataHint": "أنت (المُنشئ) فقط ترى القيم الصريحة؛ يرى الآخرون النص المشفر. يستخدم نفس المفتاح المستخدم لأسرار الأدوات.",
      "selectEmbeddingModelTooltip": "اختر نموذج تضمين",
      "mapColumnsTooltip": "عيّن أعمدة المعرف والمحتوى والتضمين",
      "registeringButton": "جارٍ التسجيل…"
    },
    "groupedView": {
      "loadingMessage": "جارٍ تحميل الجداول...",
      "emptyMessage": "لم يتم العثور على جداول معرفة",
      "emptySearchHint": "حاول تعديل استعلام البحث",
      "tableCount_one": "{{count}} جدول",
      "tableCount_other": "{{count}} جداول",
      "rowsCount_one": "{{formattedCount}} صف",
      "rowsCount_other": "{{formattedCount}} صفوف",
      "vectorDbTooltip": "قاعدة بيانات متجهية",
      "vectorDbBadge": "قاعدة بيانات متجهية",
      "createdTooltip": "تاريخ الإنشاء",
      "updatedTooltip": "تاريخ التحديث",
      "statusUnknown": "غير معروف",
      "statusError": "خطأ",
      "statusActive": "نشط",
      "statusSyncing": "جارٍ المزامنة",
      "actionViewDetails": "عرض التفاصيل",
      "actionPreviewData": "معاينة البيانات",
      "actionEdit": "تعديل",
      "actionVectorSearch": "البحث المتجهي",
      "actionSync": "مزامنة",
      "actionManageAccess": "إدارة الوصول",
      "actionDelete": "حذف"
    },
    "addStorageFolderModal": {
      "title": "إضافة مجلد تخزين",
      "closeDialogAriaLabel": "إغلاق الحوار",
      "selectConnectorTitle": "اختر موصل التخزين",
      "noConnectorsFoundMessage": "لم يتم العثور على موصلات تخزين. يرجى إنشاء موصل تخزين أولاً.",
      "searchConnectorsPlaceholder": "البحث عن الموصلات",
      "countOf": "{{shown}} من {{count}}",
      "noConnectorsMatchFilters": "لا توجد موصلات مطابقة لعوامل التصفية الخاصة بك.",
      "connectorTypeLabel": "نوع الموصل",
      "allConnectorTypesPlaceholder": "كل أنواع الموصلات ({{count}})",
      "selectBucketTitle": "اختر الحاوية",
      "noBucketsFoundMessage": "لم يتم العثور على حاويات.",
      "searchBucketsPlaceholder": "البحث عن الحاويات",
      "noBucketsMatchSearch": "لا توجد حاويات مطابقة لبحثك.",
      "selectFoldersTitle": "اختر المجلدات",
      "selectAllButton": "تحديد الكل",
      "deselectAllButton": "إلغاء تحديد الكل",
      "searchFoldersPlaceholder": "البحث عن المجلدات",
      "fileCount_one": "ملف {{count}}",
      "fileCount_other": "{{count}} ملفات",
      "openSubfolderTooltip": "فتح المجلد الفرعي",
      "noFoldersMatchSearch": "لا توجد مجلدات مطابقة لبحثك.",
      "noSubfoldersMessage": "لا توجد مجلدات فرعية هنا. يمكنك تسجيل مسار هذا المجلد إذا كان يحتوي على ملفات.",
      "noFoldersInBucketMessage": "لم يتم العثور على مجلدات في هذه الحاوية.",
      "selectFolderButton": "تحديد المجلد \"{{name}}\"",
      "selectedFoldersCount_one": "تم تحديد {{count}} مجلد",
      "selectedFoldersCount_other": "تم تحديد {{count}} مجلدات",
      "cancelButton": "إلغاء",
      "registeringButton": "جارٍ التسجيل...",
      "registerFoldersButton_one": "تسجيل {{count}} مجلد",
      "registerFoldersButton_other": "تسجيل {{count}} مجلدات",
      "registerSuccessToast_one": "تم تسجيل {{count}} مجلد تخزين بنجاح",
      "registerSuccessToast_other": "تم تسجيل {{count}} مجلدات تخزين بنجاح"
    },
    "splitView": {
      "storageBucketPane": {
        "title": "الحاويات",
        "columnBucket": "الحاوية",
        "columnFolders": "المجلدات",
        "defaultBucketLabel": "(افتراضي)",
        "searchPlaceholder": "البحث عن الحاويات…",
        "emptyMessage": "لا توجد حاويات مسجلة.",
        "emptySearchMessage": "لا توجد حاويات مطابقة لهذا البحث.",
        "loadErrorMessage": "فشل تحميل الحاويات"
      },
      "connectorPane": {
        "columnCreatedAt": "تاريخ الإنشاء",
        "columnDatabase": "النوع",
        "columnName": "الاسم",
        "columnStatus": "الحالة",
        "columnUpdatedAt": "تاريخ التحديث",
        "emptyMessage": "لم يتم العثور على موصلات.",
        "emptySearchMessage": "لا توجد موصلات مطابقة لبحثك.",
        "loadErrorMessage": "فشل تحميل الموصلات.",
        "searchPlaceholder": "ابحث عن الموصلات…",
        "title": "الموصلات"
      },
      "schemaPane": {
        "ariaDeleteMany_one": "حذف {{count}} مخطط محدد",
        "ariaDeleteMany_other": "حذف {{count}} مخططات محددة",
        "ariaDeleteOne": "حذف المخطط المحدد",
        "columnName": "الاسم",
        "columnObjects": "الكائنات",
        "defaultLabel": "افتراضي",
        "deleteTitleEmpty": "حذف المخطط",
        "deleteTitleMany_one": "حذف {{count}} مخطط",
        "deleteTitleMany_other": "حذف {{count}} مخططات",
        "deleteTitleOne": "حذف المخطط",
        "deleteTitleOneNamed": "حذف {{schema}}",
        "emptyMessage": "لم يتم العثور على مخططات",
        "emptySearchMessage": "لا توجد مخططات مطابقة لبحثك",
        "loadErrorMessage": "تعذّر تحميل المخططات",
        "searchPlaceholder": "ابحث في {{title}}…",
        "title": "المخططات"
      }
    },
    "connectorFields": {
      "extraParamField": {
        "authApiKey": "مفتاح API",
        "authBasic": "المصادقة الأساسية",
        "configured": "تم التكوين",
        "engineMssql": "SQL Server",
        "engineMysql": "MySQL",
        "enginePostgres": "PostgreSQL",
        "payloadBase64Json": "Base64 JSON",
        "payloadBinary": "ثنائي",
        "provisioned": "مُخصَّص",
        "schemeBolt": "bolt",
        "schemeBoltS": "bolt+s",
        "schemeNeo4j": "neo4j",
        "schemeNeo4jS": "neo4j+s",
        "serverless": "بدون خادم"
      },
      "extraParams": {
        "advancedLabel": "خيارات متقدمة"
      },
      "scopeSelector": {
        "projectDescription": "متاح فقط ضمن مشروع محدد",
        "projectFieldLabel": "المشروع",
        "projectHint": "سيكون هذا الموصل متاحًا فقط ضمن المشروع المحدد.",
        "projectLabel": "المشروع",
        "projectPlaceholder": "حدد مشروعًا",
        "projectSearchPlaceholder": "ابحث عن المشاريع…",
        "tenantDescription": "متاح لجميع المشاريع في هذا المستأجر",
        "tenantHint": "سيكون هذا الموصل متاحًا لجميع المشاريع في هذا المستأجر.",
        "tenantLabel": "المستأجر",
        "title": "النطاق"
      },
      "shared": {
        "aihubSubscriptionKeySecretNameLabel": "اسم سر مفتاح اشتراك AI Hub",
        "authHelp": {
          "awsDefault": "قدّم بيانات اعتماد AWS لهذا الموصل.",
          "awsKeyBoto": "مفتاح الوصول والمفتاح السري لـ AWS يُستخدمان عبر boto3.",
          "awsKeySql": "مفتاح الوصول والمفتاح السري لـ AWS يُستخدمان للاتصال بقاعدة البيانات.",
          "awsWif": "استخدم اتحاد هوية عبء العمل في AWS بدلاً من مفاتيح الوصول طويلة الأمد.",
          "azureAiSearchKey": "الاتصال بـ Azure AI Search باستخدام مفتاح API الإداري.",
          "azureAihub": "الاتصال باستخدام مفتاح اشتراك AI Hub بدلاً من بيانات اعتماد Azure AD.",
          "azureBlobKey": "الاتصال بتخزين Azure Blob باستخدام مفتاح الحساب.",
          "azureDocIntelligenceKey": "الاتصال بـ Azure Document Intelligence باستخدام مفتاح API.",
          "azureKeyDefault": "الاتصال باستخدام مفتاح أو سلسلة اتصال.",
          "azureOboAiSearch": "الوصول إلى Azure AI Search نيابة عن المستخدم الذي سجّل الدخول (مصادقة مفوضة).",
          "azureOboBlob": "الوصول إلى تخزين Azure Blob نيابة عن المستخدم الذي سجّل الدخول (مصادقة مفوضة).",
          "azureOboDefault": "الوصول إلى هذا المورد نيابة عن المستخدم الذي سجّل الدخول (مصادقة مفوضة).",
          "azureOboDocIntelligence": "الوصول إلى Azure Document Intelligence نيابة عن المستخدم الذي سجّل الدخول (مصادقة مفوضة).",
          "azureOboSharePoint": "الوصول إلى SharePoint نيابة عن المستخدم الذي سجّل الدخول (مصادقة مفوضة).",
          "azureSharePointKey": "الاتصال بـ SharePoint باستخدام سر العميل.",
          "azureSpAiSearch": "الوصول إلى Azure AI Search في {brand} باستخدام مدير خدمة مسجّل.",
          "azureSpBlob": "الوصول إلى تخزين Azure Blob باستخدام مدير خدمة مسجّل.",
          "azureSpDefault": "الوصول إلى هذا المورد في {brand} باستخدام مدير خدمة مسجّل.",
          "azureSpDocIntelligence": "الوصول إلى Azure Document Intelligence في {brand} باستخدام مدير خدمة مسجّل.",
          "azureSpRlsDeprecated": "وضع مدير الخدمة هذا أصبح مهملاً. يُرجى التبديل إلى وضع مصادقة مدعوم.",
          "azureSpSharePoint": "الوصول إلى SharePoint باستخدام مدير خدمة مسجّل.",
          "gcpDefault": "قدّم بيانات اعتماد GCP لهذا الموصل.",
          "gcpKey": "الاتصال باستخدام مفتاح حساب خدمة GCP.",
          "gcpSaDefault": "الاتصال باستخدام حساب خدمة GCP.",
          "gcpSaGcs": "الوصول إلى Google Cloud Storage باستخدام حساب خدمة GCP.",
          "gcpSaRlsDeprecated": "وضع حساب الخدمة هذا أصبح مهملاً. يُرجى التبديل إلى وضع مصادقة مدعوم.",
          "gcpWifDefault": "الاتصال باستخدام اتحاد هوية عبء العمل في GCP.",
          "gcpWifGcs": "الوصول إلى Google Cloud Storage باستخدام اتحاد هوية عبء العمل في GCP.",
          "oracleIamRequired": "إدخال Cloud IAM مطلوب لوضع مصادقة Oracle هذا.",
          "oracleUsernamePassword": "الاتصال باستخدام اسم مستخدم وكلمة مرور قاعدة بيانات Oracle.",
          "oracleWallet": "الاتصال باستخدام محفظة Oracle."
        },
        "authModeLabel": "وضع المصادقة",
        "authModePlaceholder": "حدد وضع المصادقة",
        "databaseEngineHelpText": "حدد محرك قاعدة البيانات الأساسي لاتصال Azure Managed SQL هذا.",
        "databaseEngineLabel": "محرك قاعدة البيانات",
        "databaseLabel": "قاعدة البيانات",
        "databaseUsernameEntraLabel": "اسم العرض في Entra",
        "descriptionLabel": "الوصف",
        "descriptionPlaceholder": "وصف اختياري لهذا الموصل",
        "displayNameLabel": "اسم العرض",
        "displayNamePlaceholder": "مثال: قاعدة بيانات الإنتاج",
        "docIntelVerifySslHelpText": "عطّل هذا الخيار فقط عند الاتصال بنقطة نهاية Document Intelligence التي تستخدم شهادة موقعة ذاتيًا.",
        "engineMysql": "MySQL",
        "enginePostgresql": "PostgreSQL",
        "engineSqlServer": "SQL Server",
        "entraDisplayNamePlaceholder": "مثال: john.doe@company.com",
        "entraUsernameHelpText": "أدخل اسم العرض في Entra ID أو UPN لمالك قاعدة البيانات.",
        "fromIamSuffix": "(من Cloud IAM)",
        "iamEmptyWarning": {
          "awsBasicAuth": "لم يتم العثور على إدخالات Cloud IAM للمصادقة الأساسية في AWS. أضف واحدًا قبل المتابعة.",
          "awsIamUser": "لم يتم العثور على إدخالات Cloud IAM لمستخدم AWS IAM. أضف واحدًا قبل المتابعة.",
          "awsWif": "لم يتم العثور على إدخالات Cloud IAM لاتحاد هوية عبء العمل في AWS. أضف واحدًا قبل المتابعة.",
          "azureBasicAuth": "لم يتم العثور على إدخالات Cloud IAM للمصادقة الأساسية في Azure. أضف واحدًا قبل المتابعة.",
          "azureBlobIamOnly": "لم يتم العثور على إدخالات Cloud IAM لتخزين Azure Blob. أضف واحدًا قبل المتابعة.",
          "azureBlobKey": "لم يتم العثور على إدخالات Cloud IAM لمفتاح تخزين Azure Blob. أضف واحدًا قبل المتابعة.",
          "azureServicePrincipal": "لم يتم العثور على إدخالات Cloud IAM لمدير خدمة Azure. أضف واحدًا قبل المتابعة.",
          "databricks": "لم يتم العثور على إدخالات Cloud IAM لـ Databricks. أضف رمز وصول شخصي قبل المتابعة.",
          "default": "لم يتم العثور على إدخالات Cloud IAM. أضف واحدًا قبل المتابعة.",
          "gcp": "لم يتم العثور على إدخالات Cloud IAM لـ GCP. أضف واحدًا قبل المتابعة.",
          "gcpBasicAuth": "لم يتم العثور على إدخالات Cloud IAM للمصادقة الأساسية في GCP. أضف واحدًا قبل المتابعة.",
          "gcpServiceAccount": "لم يتم العثور على إدخالات Cloud IAM لحساب خدمة GCP. أضف واحدًا قبل المتابعة.",
          "tokenBasedOnprem": "لم يتم العثور على إدخالات Cloud IAM لرمز الوصول. أضف واحدًا قبل المتابعة."
        },
        "iamHelp": {
          "awsAccessKeys": "حدد إدخال Cloud IAM الذي يحتوي على مفتاح الوصول والمفتاح السري لـ AWS.",
          "awsBasicAuth": "حدد إدخال Cloud IAM الذي يحتوي على بيانات اعتماد قاعدة بيانات AWS.",
          "awsWif": "حدد إدخال Cloud IAM المُهيأ لاتحاد هوية عبء العمل في AWS.",
          "azureBasicAuth": "حدد إدخال Cloud IAM الذي يحتوي على بيانات اعتماد المصادقة الأساسية في Azure.",
          "azureBlobIamOnly": "حدد إدخال Cloud IAM للوصول إلى تخزين Azure Blob.",
          "azureBlobKey": "حدد إدخال Cloud IAM الذي يحتوي على مفتاح حساب تخزين Azure Blob.",
          "azureServicePrincipal": "حدد إدخال Cloud IAM لمدير خدمة Azure.",
          "databricks": "حدد إدخال Cloud IAM الذي يحتوي على رمز الوصول الشخصي لـ Databricks.",
          "default": "حدد إدخال Cloud IAM لهذا الموصل.",
          "gcp": "حدد إدخال Cloud IAM لموصل GCP هذا.",
          "gcpBasicAuth": "حدد إدخال Cloud IAM الذي يحتوي على بيانات اعتماد المصادقة الأساسية في GCP.",
          "gcpServiceAccount": "حدد إدخال Cloud IAM الذي يحتوي على مفتاح حساب خدمة GCP.",
          "gcpTokenMode": "حدد إدخال Cloud IAM المُستخدم لإنشاء رموز الوصول.",
          "gcpWif": "حدد إدخال Cloud IAM المُهيأ لاتحاد هوية عبء العمل في GCP.",
          "oracleOptional": "يمكنك اختياريًا تحديد إدخال Cloud IAM بدلاً من إدخال بيانات الاعتماد مباشرةً.",
          "oracleRequired": "حدد إدخال Cloud IAM المطلوب لوضع مصادقة Oracle هذا.",
          "tokenBasedOnprem": "حدد إدخال Cloud IAM الذي يحتوي على رمز الوصول الخاص بك."
        },
        "iamLabel": {
          "accessToken": "رمز الوصول",
          "awsAccessKeys": "مفاتيح الوصول لـ AWS",
          "awsBasicAuth": "المصادقة الأساسية لـ AWS",
          "awsWif": "اتحاد هوية عبء العمل في AWS",
          "azureBasicAuth": "المصادقة الأساسية لـ Azure",
          "azureBlobStorage": "تخزين Azure Blob",
          "azureOrGraph": "Azure AD / Microsoft Graph",
          "azureServicePrincipal": "مدير خدمة Azure",
          "azureStorage": "تخزين Azure",
          "cloudIam": "Cloud IAM",
          "cloudIamOptional": "Cloud IAM (اختياري)",
          "databricksIam": "Databricks IAM (PAT أو كيان الخدمة)",
          "databricksPat": "رمز الوصول الشخصي لـ Databricks",
          "gcp": "Cloud IAM لـ GCP",
          "gcpBasicAuth": "المصادقة الأساسية لـ GCP",
          "gcpServiceAccount": "حساب خدمة GCP",
          "gcpWif": "اتحاد هوية عبء العمل في GCP"
        },
        "iamPlaceholder": {
          "accessToken": "حدد رمز وصول",
          "awsAccessKeys": "حدد مفاتيح الوصول لـ AWS",
          "awsBasicAuth": "حدد بيانات اعتماد المصادقة الأساسية لـ AWS",
          "awsWif": "حدد إدخال اتحاد هوية عبء العمل في AWS",
          "azureBasicAuth": "حدد بيانات اعتماد المصادقة الأساسية لـ Azure",
          "azureBlobIamOnly": "حدد إدخال Cloud IAM لتخزين Azure Blob",
          "azureBlobKey": "حدد مفتاح تخزين Azure Blob",
          "azureServicePrincipal": "حدد مدير خدمة Azure",
          "databricksIam": "حدد إدخال Databricks IAM (PAT أو كيان الخدمة)",
          "databricksPat": "حدد رمز الوصول الشخصي لـ Databricks",
          "default": "حدد إدخال Cloud IAM",
          "gcp": "حدد إدخال Cloud IAM لـ GCP",
          "gcpBasicAuth": "حدد بيانات اعتماد المصادقة الأساسية لـ GCP",
          "gcpServiceAccount": "حدد حساب خدمة GCP",
          "gcpWif": "حدد إدخال اتحاد هوية عبء العمل في GCP"
        },
        "loadingIamEntries": "جارٍ تحميل إدخالات Cloud IAM…",
        "passwordSecretKeyNameOptionalLabel": "اسم مفتاح سر كلمة المرور (اختياري)",
        "portLabel": "المنفذ",
        "schemaLabel": "المخطط",
        "secretKeyNameLabel": "اسم المفتاح السري",
        "secretKeyNamePlaceholder": "مثال: my-connector-password",
        "serverHostHelpMssql": "أدخل اسم مضيف SQL Server، مثال: myserver.database.windows.net",
        "serverHostHelpMysql": "أدخل اسم مضيف MySQL، مثال: myserver.mysql.database.azure.com",
        "serverHostHelpPostgres": "أدخل اسم مضيف PostgreSQL، مثال: myserver.postgres.database.azure.com",
        "serverHostLabel": "مضيف الخادم",
        "usernameLabel": "اسم المستخدم"
      },
      "testSection": {
        "cancel": "إلغاء",
        "connectionFailed": "فشل الاتصال",
        "connectionSuccessful": "نجح الاتصال",
        "latency": "زمن الاستجابة: {{ms}} مللي ثانية",
        "subtitle": "تحقق من إعدادات الاتصال قبل الحفظ",
        "testConnection": "اختبار الاتصال",
        "title": "اختبار الاتصال",
        "version": "الإصدار: {{version}}"
      }
    },
    "connectorModal": {
      "aria": {
        "backToSelection": "الرجوع إلى اختيار الموصل",
        "closeDialog": "إغلاق مربع الحوار"
      },
      "buttons": {
        "addConnector": "إضافة موصل",
        "back": "رجوع",
        "cancel": "إلغاء",
        "creating": "جارٍ الإنشاء…",
        "updateConnector": "تحديث الموصل",
        "updating": "جارٍ التحديث…"
      },
      "connectorsLabel": "الموصلات",
      "errors": {
        "aiHubSecretRequired": "اسم سر مفتاح اشتراك AI Hub مطلوب",
        "awsIamUserRequired": "حدد إدخال Cloud IAM لمستخدم AWS IAM",
        "awsWifIamRequired": "حدد إدخال Cloud IAM لاتحاد هوية عبء العمل في AWS",
        "azureBasicAuthIamRequired": "حدد إدخال Cloud IAM للمصادقة الأساسية في Azure",
        "azureBlobIamRequired": "حدد إدخال Cloud IAM لتخزين Azure Blob",
        "azureBlobIamRequiredFull": "إدخال Cloud IAM مطلوب للوصول إلى تخزين Azure Blob",
        "azureSpIamRequiredObo": "حدد إدخال Cloud IAM للوصول المفوض نيابة عن المستخدم (OBO)",
        "azureSpIamRequiredSp": "حدد إدخال Cloud IAM لمدير خدمة Azure",
        "cloudIamOrSecretRequired": "قدّم إدخال Cloud IAM أو اسم مفتاح سري",
        "cloudIamRequired": "إدخال Cloud IAM مطلوب",
        "cloudIamRequiredForMode": "إدخال Cloud IAM مطلوب لوضع المصادقة هذا",
        "displayNameRequired": "اسم العرض مطلوب",
        "fieldRequired": "{{field}} مطلوب",
        "gcpBasicAuthIamRequired": "حدد إدخال Cloud IAM للمصادقة الأساسية في GCP",
        "gcpServiceAccountIamRequired": "حدد إدخال Cloud IAM لحساب خدمة GCP",
        "hostNoUnderscores": "لا يمكن أن يحتوي المضيف على شرطات سفلية",
        "nameAlreadyExists": "يوجد بالفعل موصل بهذا الاسم",
        "oracleCloudIamRequired": "إدخال Cloud IAM مطلوب لوضع مصادقة Oracle هذا",
        "oracleSecretOrIamRequired": "{{field}} مطلوب، أو حدد إدخال Cloud IAM",
        "portRange": "يجب أن يكون المنفذ بين 1 و65535",
        "projectRequired": "حدد مشروعًا",
        "provideCloudIamOrSecret": "قدّم إدخال Cloud IAM أو سرًا قبل الاختبار",
        "schemaRequired": "المخطط مطلوب",
        "sharepointCredentialsRequired": "بيانات اعتماد SharePoint مطلوبة",
        "testFailedCheckConfig": "فشل اختبار الاتصال. تحقق من الإعدادات وحاول مرة أخرى.",
        "usernameRequired": "اسم المستخدم مطلوب",
        "walletLocationRequired": "موقع المحفظة مطلوب"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "اسم سر مفتاح اشتراك AI Hub",
        "awsIamUserCloudIamEntry": "إدخال Cloud IAM لمستخدم AWS IAM",
        "awsWifCloudIamEntry": "إدخال Cloud IAM لاتحاد هوية عبء العمل في AWS",
        "azureBasicAuthIamRequired": "إدخال Cloud IAM للمصادقة الأساسية في Azure",
        "azureBlobIamEntry": "إدخال Cloud IAM لتخزين Azure Blob",
        "azureBlobIamRequiredForMode": "إدخال Cloud IAM لتخزين Azure Blob",
        "azureSpIamObo": "إدخال Cloud IAM لمدير خدمة Azure (نيابة عن المستخدم)",
        "azureSpIamSp": "إدخال Cloud IAM لمدير خدمة Azure",
        "cloudIamEntry": "إدخال Cloud IAM",
        "cloudIamOrPasswordSecretKeyName": "إدخال Cloud IAM أو اسم مفتاح سر كلمة المرور",
        "connectorFallback": "الموصل",
        "database": "قاعدة البيانات",
        "displayName": "اسم العرض",
        "gcpIamEntryBasicAuth": "إدخال Cloud IAM للمصادقة الأساسية في GCP",
        "gcpIamEntryServiceAccount": "إدخال Cloud IAM لحساب خدمة GCP",
        "host": "المضيف",
        "passwordSecretKeyName": "اسم مفتاح سر كلمة المرور",
        "project": "المشروع",
        "secretKeyName": "اسم المفتاح السري",
        "sharepointCredentialsRequired": "بيانات اعتماد SharePoint",
        "walletLocation": "موقع المحفظة"
      },
      "loadingQuota": "جارٍ تحميل الحصة…",
      "missingFieldsTitle": "الحقول المطلوبة الناقصة: {{fields}}",
      "requiredFieldsHint": "الناقص: {{fields}}",
      "titles": {
        "configureConnector": "تكوين {{name}}",
        "editConnector": "تعديل الموصل",
        "selectConnectorType": "حدد نوع الموصل"
      },
      "toasts": {
        "createFailed": "فشل إنشاء الموصل",
        "updateFailed": "فشل تحديث الموصل"
      }
    },
    "connectorSelectionGrid": {
      "categories": {
        "aws": "AWS",
        "azure": "Azure",
        "databricks": "Databricks",
        "gcp": "GCP",
        "onprem": "محلي (On-Prem)",
        "orchestrators": "أدوات التنسيق",
        "snowflake": "Snowflake",
        "storage": "التخزين",
        "telephony": "الاتصالات الهاتفية",
        "vectorDb": "قاعدة بيانات المتجهات"
      },
      "loading": "جارٍ تحميل أنواع الموصلات…"
    },
    "connectorViewModal": {
      "aria": {
        "backToSelection": "الرجوع إلى اختيار الموصل",
        "closeDialog": "إغلاق مربع الحوار"
      },
      "buttons": {
        "addConnector": "إضافة موصل",
        "back": "رجوع",
        "cancel": "إلغاء",
        "close": "إغلاق",
        "creating": "جارٍ الإنشاء…",
        "updateConnector": "تحديث الموصل",
        "updating": "جارٍ التحديث…"
      },
      "connectorsLabel": "الموصلات",
      "errors": {
        "aiHubSecretRequired": "اسم سر مفتاح اشتراك AI Hub مطلوب",
        "awsIamUserRequired": "حدد إدخال Cloud IAM لمستخدم AWS IAM",
        "awsWifIamRequired": "حدد إدخال Cloud IAM لاتحاد هوية عبء العمل في AWS",
        "azureBasicAuthIamRequired": "حدد إدخال Cloud IAM للمصادقة الأساسية في Azure",
        "azureBlobIamRequired": "حدد إدخال Cloud IAM لتخزين Azure Blob",
        "azureBlobIamRequiredFull": "إدخال Cloud IAM مطلوب للوصول إلى تخزين Azure Blob",
        "azureSpIamRequiredObo": "حدد إدخال Cloud IAM للوصول المفوض نيابة عن المستخدم (OBO)",
        "azureSpIamRequiredSp": "حدد إدخال Cloud IAM لمدير خدمة Azure",
        "cloudIamOrSecretRequired": "قدّم إدخال Cloud IAM أو اسم مفتاح سري",
        "cloudIamRequired": "إدخال Cloud IAM مطلوب",
        "cloudIamRequiredForMode": "إدخال Cloud IAM مطلوب لوضع المصادقة هذا",
        "displayNameRequired": "اسم العرض مطلوب",
        "fieldRequired": "{{field}} مطلوب",
        "gcpBasicAuthIamRequired": "حدد إدخال Cloud IAM للمصادقة الأساسية في GCP",
        "gcpServiceAccountIamRequired": "حدد إدخال Cloud IAM لحساب خدمة GCP",
        "oracleCloudIamRequired": "إدخال Cloud IAM مطلوب لوضع مصادقة Oracle هذا",
        "oracleSecretOrIamRequired": "{{field}} مطلوب، أو حدد إدخال Cloud IAM",
        "portRange": "يجب أن يكون المنفذ بين 1 و65535",
        "provideCloudIamOrSecret": "قدّم إدخال Cloud IAM أو سرًا قبل الاختبار",
        "schemaRequired": "المخطط مطلوب",
        "sharepointCredentialsRequired": "بيانات اعتماد SharePoint مطلوبة",
        "testFailedCheckConfig": "فشل اختبار الاتصال. تحقق من الإعدادات وحاول مرة أخرى.",
        "usernameRequired": "اسم المستخدم مطلوب",
        "walletLocationRequired": "موقع المحفظة مطلوب"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "اسم سر مفتاح اشتراك AI Hub",
        "awsIamUserCloudIamEntry": "إدخال Cloud IAM لمستخدم AWS IAM",
        "awsWifCloudIamEntry": "إدخال Cloud IAM لاتحاد هوية عبء العمل في AWS",
        "azureBasicAuthIamRequired": "إدخال Cloud IAM للمصادقة الأساسية في Azure",
        "azureBlobIamEntry": "إدخال Cloud IAM لتخزين Azure Blob",
        "azureBlobIamRequiredForMode": "إدخال Cloud IAM لتخزين Azure Blob",
        "azureSpIamObo": "إدخال Cloud IAM لمدير خدمة Azure (نيابة عن المستخدم)",
        "azureSpIamSp": "إدخال Cloud IAM لمدير خدمة Azure",
        "cloudIamEntry": "إدخال Cloud IAM",
        "cloudIamOrPasswordSecretKeyName": "إدخال Cloud IAM أو اسم مفتاح سر كلمة المرور",
        "connectorFallback": "الموصل",
        "database": "قاعدة البيانات",
        "displayName": "اسم العرض",
        "gcpIamEntryBasicAuth": "إدخال Cloud IAM للمصادقة الأساسية في GCP",
        "gcpIamEntryServiceAccount": "إدخال Cloud IAM لحساب خدمة GCP",
        "host": "المضيف",
        "passwordSecretKeyName": "اسم مفتاح سر كلمة المرور",
        "secretKeyName": "اسم المفتاح السري",
        "sharepointCredentialsRequired": "بيانات اعتماد SharePoint",
        "walletLocation": "موقع المحفظة"
      },
      "loadingQuota": "جارٍ تحميل الحصة…",
      "missingFieldsTitle": "الحقول المطلوبة الناقصة: {{fields}}",
      "requiredFieldsHint": "الناقص: {{fields}}",
      "titles": {
        "configureConnector": "تكوين {{name}}",
        "editConnector": "تعديل الموصل",
        "selectConnectorType": "حدد نوع الموصل",
        "viewConnection": "عرض الاتصال"
      },
      "toasts": {
        "createFailed": "فشل إنشاء الموصل",
        "updateFailed": "فشل تحديث الموصل"
      }
    },
    "graphEvals": {
      "backToGraphAriaLabel": "العودة إلى الرسم البياني",
      "cancel": "إلغاء",
      "close": "إغلاق",
      "columnConfidence": "درجة الثقة",
      "columnDateTime": "التاريخ / الوقت",
      "columnGrade": "الدرجة",
      "columnReport": "التقرير",
      "columnSchema": "المخطط",
      "columnSemantic": "الدلالي",
      "columnStatus": "الحالة",
      "columnStructural": "الهيكلي",
      "confidenceMeta": "الثقة: {{value}}",
      "configModalAriaLabel": "إعدادات تشغيل التقييم",
      "derivationsDescFallback": "شغّل تقييمًا لمعرفة كيفية احتساب درجة الجودة.",
      "emptyRunsMessage": "لم يتم تشغيل أي تقييمات بعد.",
      "entityCompletenessLabel": "اكتمال الكيانات",
      "gradeConfidenceSummary": "الدرجة {{grade}} · الثقة {{confidence}}",
      "gradeErrorAbbreviation": "خطأ",
      "hideFormulas": "إخفاء الصيغ",
      "howScoresCalculatedTitle": "كيفية احتساب الدرجات",
      "latestScoresAriaLabel": "أحدث درجات الجودة",
      "llmModelLabel": "نموذج LLM",
      "llmModelTooltip": "النموذج المستخدم للحكم على الاتساق الدلالي",
      "loadingEvaluations": "جارٍ تحميل التقييمات…",
      "loadingModelsPlaceholder": "جارٍ تحميل النماذج…",
      "loadingReport": "جارٍ تحميل التقرير…",
      "missingGraphIdMessage": "لم يتم تحديد جدول رسم بياني.",
      "modelDefaultLabel": "{{name}} (افتراضي)",
      "noMatchingEvaluations": "لا توجد تقييمات مطابقة لبحثك.",
      "noReportAttachedMessage": "لا يوجد تقرير مرفق بهذا التشغيل.",
      "noStructuralBreakdown": "لا يوجد تفصيل هيكلي متاح.",
      "pageSubtitle": "سجل تقييمات الجودة لـ {{name}}",
      "pageTitle": "تقييمات الرسم البياني",
      "pdfFrameTitle": "تقرير التحقق",
      "qualityGradeHelp": "درجة الجودة الإجمالية، المشتقة من المزيج الموزون للسلامة الهيكلية والتوافق مع المخطط والاتساق الدلالي.",
      "qualityGradeLabel": "درجة الجودة",
      "refresh": "تحديث",
      "relationshipRichnessLabel": "ثراء العلاقات",
      "reportLoadFailedGeneric": "فشل تحميل التقرير",
      "reportLoadFailedMessage": "فشل تحميل ملف التقرير.",
      "reportModalAriaLabel": "تقرير التحقق",
      "runEvaluationButton": "تشغيل التقييم",
      "runEvaluationDescription": "اختر ما تريد التحقق منه وحجم العينة المطلوب أخذها من الرسم البياني.",
      "runEvaluationTitle": "تشغيل التقييم",
      "running": "قيد التشغيل…",
      "runningEvaluation": "التقييم قيد التشغيل…",
      "sampleSizeLabel": "حجم العينة",
      "schemaConformanceDerivationHelp": "كيفية اشتقاق درجة التوافق مع المخطط من اكتمال الكيانات والعلاقات.",
      "schemaConformanceHelp": "مدى اتباع الكيانات والعلاقات في الرسم البياني للمخطط المسجل.",
      "schemaConformanceLabel": "التوافق مع المخطط",
      "schemaFormulaFallback": "شغّل تقييمًا لمعرفة صيغة التوافق مع المخطط.",
      "schemaMetaFallback": "لا توجد بيانات مخطط بعد",
      "schemaPartsFormula": "الكيان {{entity}} × العلاقة {{relationship}} = {{result}}",
      "scopeAll": "الرسم البياني بالكامل",
      "scopeSample": "عينة",
      "scoreDerivationsAriaLabel": "اشتقاقات الدرجات",
      "searchEvaluationsPlaceholder": "البحث في التقييمات…",
      "searchModelsPlaceholder": "البحث في النماذج…",
      "selectAtLeastOneTargetError": "اختر هدف تحقق واحدًا على الأقل.",
      "selectModelPlaceholder": "اختر نموذجًا",
      "semanticCoherenceCaveat": "يُحكم على الاتساق الدلالي بناءً على عينة وقد لا يعكس الرسم البياني بأكمله.",
      "semanticCoherenceDerivationHelp": "كيفية اشتقاق درجة الاتساق الدلالي من الثلاثيات التي تم أخذ عينات منها.",
      "semanticCoherenceHelp": "ما إذا كانت العلاقات في الرسم البياني منطقية وواقعية.",
      "semanticCoherenceLabel": "الاتساق الدلالي",
      "semanticFactScopeLegend": "الحقائق المراد التحقق منها",
      "semanticFormula": "{{coherent}} متسقة / {{sampled}} معاينة = {{result}}",
      "semanticMetaCoherent": "{{coherent}} / {{sampled}} متسقة",
      "semanticMetaFallback": "لا توجد بيانات دلالية بعد",
      "semanticMetaSampled": "تم أخذ عينة {{sampled}} من أصل {{total}}",
      "semanticMetaTotal": "{{total}} ثلاثية",
      "showFormulas": "إظهار الصيغ",
      "startEvaluation": "بدء التقييم",
      "structuralFormula": "المتوسط الموزون لفحوصات سلامة العُقد/الحواف",
      "structuralHealthDerivationHelp": "كيفية اشتقاق درجة السلامة الهيكلية من فحوصات السلامة الأساسية.",
      "structuralHealthHelp": "السلامة الهيكلية للرسم البياني — المراجع المعلّقة والعُقد المعزولة والحواف المُشوَّهة.",
      "structuralHealthLabel": "السلامة الهيكلية",
      "structuralMetaFallback": "لا توجد بيانات هيكلية بعد",
      "targetSchema": "التوافق مع المخطط",
      "targetSemantic": "الاتساق الدلالي",
      "targetStructural": "السلامة الهيكلية",
      "validatingHint": "قد يستغرق هذا بضع دقائق حسب حجم الرسم البياني.",
      "validationReportTitle": "تقرير التحقق",
      "validationTargetsLegend": "أهداف التحقق",
      "view": "عرض",
      "weightBitSchema": "المخطط {{value}}",
      "weightBitSemantic": "الدلالي {{value}}",
      "weightBitStructural": "الهيكلي {{value}}",
      "weightedMixSummary": "مزيج موزون من {{bits}} = ثقة {{confidence}}"
    },
    "graphApprovalSession": {
      "addToQueue": "إضافة إلى قائمة الانتظار",
      "addTripletButton": "إضافة ثلاثية",
      "addTripletDescription": "اقترح ثلاثية جديدة من فاعل–علاقة–مفعول لهذه الجلسة.",
      "addTripletTitle": "إضافة ثلاثية",
      "approve": "الموافقة",
      "approveAll": "الموافقة على الكل",
      "backToApprovalsAriaLabel": "العودة إلى الموافقات",
      "cancel": "إلغاء",
      "collapse": "طي",
      "collapsePanelAriaLabel": "طي لوحة المراجعة",
      "collapseSchemaPanelAriaLabel": "طي لوحة المخطط",
      "collapseSchemaTooltip": "طي لوحة المخطط",
      "columnConfidence": "درجة الثقة",
      "columnObject": "المفعول به",
      "columnRelation": "العلاقة",
      "columnSubject": "الفاعل",
      "commit": "تنفيذ",
      "commitSuccessApplied": "تم تطبيق التغييرات",
      "commitSuccessCounted_one": "تم تنفيذ قرار واحد",
      "commitSuccessCounted_other": "تم تنفيذ {{count}} قرارات",
      "committing": "جارٍ التنفيذ…",
      "confidenceRangeLabel": "درجة الثقة (0–1)",
      "confidenceTooltip": "الثقة: {{value}}",
      "decisionRecorded": "تم تسجيل القرار.",
      "defaultSessionTitle": "جلسة موافقة",
      "emptyAllMessage": "لا توجد تغييرات مقترحة في هذه الجلسة.",
      "emptyFilteredMessage": "لا توجد عناصر {{kind}} مطابقة للتصفية الحالية.",
      "entityNamePlaceholder": "اسم الكيان",
      "expandPanelAriaLabel": "توسيع لوحة المراجعة",
      "expandSchemaPanelAriaLabel": "توسيع لوحة المخطط",
      "filterAll": "الكل",
      "filterEntities": "الكيانات",
      "filterProposedUpdatesAriaLabel": "تصفية التحديثات المقترحة",
      "filterTriplets": "الثلاثيات",
      "graphCanvasAriaLabel": "لوحة الرسم البياني",
      "legendConflict": "تعارض",
      "legendExisting": "موجود",
      "legendNew": "جديد",
      "missingIdsMessage": "لم يتم تحديد جدول أو جلسة.",
      "modify": "تعديل",
      "modifySnapshotTitle": "تعديل اللقطة",
      "noChangesStaged": "لا توجد تغييرات معلّقة",
      "noConfidenceScore": "لا توجد درجة ثقة",
      "pendingBadge_one": "قيد الانتظار: {{count}}",
      "pendingBadge_other": "قيد الانتظار: {{count}}",
      "proposedUpdatesAriaLabel": "التحديثات المقترحة",
      "proposedUpdatesTitle": "التحديثات المقترحة",
      "refresh": "تحديث",
      "refreshSessionTooltip": "تحديث الجلسة",
      "reject": "رفض",
      "rejectAll": "رفض الكل",
      "relationPlaceholder": "نوع العلاقة",
      "reviewerNotePlaceholder": "أضف ملاحظة (اختياري)",
      "schemaLabel": "المخطط",
      "schemaSidebarAriaLabel": "مخطط الرسم البياني",
      "sessionContextAriaLabel": "سياق الجلسة",
      "sessionSummary": "الإجمالي {{total}} · قيد الانتظار {{pending}}",
      "showSchemaPanelAriaLabel": "إظهار لوحة المخطط",
      "showSchemaTooltip": "إظهار لوحة المخطط",
      "stageAllApproveTooltip": "تعليق الموافقة على جميع العناصر المعلّقة",
      "stageAllRejectTooltip": "تعليق الرفض لجميع العناصر المعلّقة",
      "stageFilteredApproveTooltip_one": "تعليق الموافقة على العنصر المرئي ({{count}})",
      "stageFilteredApproveTooltip_other": "تعليق الموافقة على {{count}} عناصر مرئية",
      "stageFilteredRejectTooltip_one": "تعليق الرفض للعنصر المرئي ({{count}})",
      "stageFilteredRejectTooltip_other": "تعليق الرفض لـ {{count}} عناصر مرئية",
      "stageModification": "تعليق التعديل",
      "stagedApprove": "موافقة",
      "stagedCount_one": "تغيير واحد معلّق",
      "stagedCount_other": "{{count}} تغييرات معلّقة",
      "stagedModify": "تعديل",
      "stagedReject": "رفض",
      "unappliedCount_one": "تغيير واحد تمت الموافقة عليه ولم يُكتب بعد",
      "unappliedCount_other": "{{count}} تغييرات تمت الموافقة عليها ولم تُكتب بعد",
      "undo": "تراجع",
      "undoAll": "تراجع عن الكل",
      "undoAllTooltip": "تجاهل جميع القرارات المعلّقة"
    },
    "graphApprovals": {
      "auditLog": "سجل التدقيق",
      "auditTrailTitle": "مسار التدقيق",
      "backToGraphAriaLabel": "العودة إلى الرسم البياني",
      "columnAction": "الإجراء",
      "columnActions": "الإجراءات",
      "columnActor": "الجهة الفاعلة",
      "columnChangeRun": "تشغيل التغيير",
      "columnCommit": "التنفيذ",
      "columnCreatedAt": "تاريخ الإنشاء",
      "columnCreatedBy": "أنشأه",
      "columnMessage": "الرسالة",
      "columnMode": "الوضع",
      "columnPending": "قيد الانتظار",
      "columnSource": "المصدر",
      "columnStatus": "الحالة",
      "columnTriplet": "الثلاثية",
      "columnUpdatedAt": "تاريخ التحديث",
      "columnVersion": "الإصدار",
      "columnWhen": "الوقت",
      "commitHistoryTitle": "سجل التنفيذات",
      "commits": "التنفيذات",
      "emptyAuditMessage": "لا توجد إدخالات تدقيق بعد.",
      "emptyCommitsMessage": "لا توجد تنفيذات بعد.",
      "emptyRunsMessage": "لا توجد عمليات تشغيل تغييرات بعد.",
      "exportAuditAriaLabel": "تصدير سجل التدقيق بصيغة CSV",
      "exportCsv": "تصدير CSV",
      "filterAll": "الكل",
      "filterModeLabel": "الوضع",
      "filterStatusLabel": "الحالة",
      "footnoteText": "تتم كتابة التغييرات المعتمدة إلى الرسم البياني المباشر. ",
      "hideAudit": "إخفاء سجل التدقيق",
      "hideCommits": "إخفاء التنفيذات",
      "missingTableIdMessage": "لم يتم تحديد جدول رسم بياني.",
      "modeApprovalRequired": "الموافقة مطلوبة",
      "modeBypassed": "تم التجاوز",
      "openLivePreview": "فتح المعاينة المباشرة",
      "openSession": "فتح الجلسة",
      "pageSubtitle": "قائمة انتظار المراجعة لـ {{name}}",
      "pageTitle": "موافقات الرسم البياني",
      "refresh": "تحديث",
      "review": "مراجعة",
      "runCount_one": "تشغيل واحد",
      "runCount_other": "{{count}} عمليات تشغيل",
      "searchAuditPlaceholder": "البحث في سجل التدقيق…",
      "searchChangeRunsPlaceholder": "البحث في عمليات تشغيل التغييرات…",
      "searchCommitsPlaceholder": "البحث في التنفيذات…",
      "statusApplied": "مُطبَّق",
      "statusAutoApplied": "مُطبَّق تلقائيًا",
      "statusPartiallyApplied": "مُطبَّق جزئيًا",
      "statusPending": "قيد الانتظار",
      "statusRejected": "مرفوض",
      "systemActor": "النظام",
      "unknownUser": "مستخدم غير معروف",
      "wholeRun": "التشغيل بالكامل"
    },
    "graphTablePreview": {
      "addedInVersionLegend": "أُضيف في الإصدار {{version}}",
      "alreadyThereLegend": "موجود بالفعل",
      "askTheGraphDescription": "اطرح سؤالاً باللغة الطبيعية وسيتم تحويله إلى استعلام على الرسم البياني.",
      "askTheGraphTitle": "اسأل الرسم البياني",
      "back": "رجوع",
      "backToDataAriaLabel": "العودة إلى البيانات",
      "chatAssistantAriaLabel": "مساعد محادثة الرسم البياني",
      "chatDisabledLabel": "المحادثة غير متاحة",
      "chatDisabledTooltip": "لا توجد نماذج LLM مُهيَّأة لهذا المستأجر، لذا فإن محادثة الرسم البياني غير متاحة.",
      "chatInputPlaceholder": "اطرح سؤالاً حول هذا الرسم البياني…",
      "chatWelcomeMessage": "اطرح عليّ سؤالاً حول هذا الرسم البياني وسأستعلم عنه نيابةً عنك.",
      "collapse": "طي",
      "collapseChatAriaLabel": "طي المحادثة",
      "commitLegendAriaLabel": "مفتاح إصدار التنفيذ",
      "commitOptionPlain": "الإصدار {{version}}{{whenSuffix}}",
      "commitOptionWithMessage": "الإصدار {{version}} — {{message}}{{whenSuffix}}",
      "commitVersionPlaceholder": "اختر إصدارًا",
      "couldNotBuildQueryMessage": "تعذّر تحويل ذلك إلى استعلام على الرسم البياني. حاول إعادة صياغة سؤالك.",
      "defaultGraphTitle": "معاينة الرسم البياني",
      "expandChatAriaLabel": "توسيع المحادثة",
      "graphCanvasAriaLabel": "لوحة الرسم البياني",
      "graphContextAriaLabel": "سياق الرسم البياني",
      "graphSchemaAriaLabel": "مخطط الرسم البياني",
      "highlightingMatchesMessage": "جارٍ تمييز {{nodesPart}} و{{relsPart}}.",
      "latestLiveOption": "الأحدث (مباشر)",
      "matchedNodesPart_one": "عقدة مطابقة واحدة",
      "matchedNodesPart_other": "{{count}} عقدة مطابقة",
      "matchedRelationshipsPart_one": "علاقة مطابقة واحدة",
      "matchedRelationshipsPart_other": "{{count}} علاقة مطابقة",
      "missingTableIdMessage": "لم يتم تحديد جدول رسم بياني.",
      "modelLabel": "النموذج",
      "modelLabelLoading": "جارٍ تحميل النماذج…",
      "newestCommitMatchesLatestNotice": "الإصدار {{version}} هو أحدث تنفيذ، لذا يطابق هذا العرض الرسم البياني المباشر.",
      "noCommitStampsNotice": "لا يحتوي هذا الرسم البياني على أختام إصدار تنفيذ، لذا لا يمكن تطبيق التصفية حسب الإصدار.",
      "noModelsConfiguredPlaceholder": "لا توجد نماذج مُهيَّأة",
      "noNodesMatchedMessage": "لم تُطابق أي عقدة سؤالك.",
      "nothingToResetTooltip": "لا يوجد ما يمكن إعادة ضبطه",
      "reset": "إعادة ضبط",
      "resetViewTooltip": "إعادة الضبط إلى عرض الرسم البياني الكامل",
      "schemaLabel": "المخطط",
      "searchModelsPlaceholder": "البحث في النماذج…",
      "selectModelPlaceholder": "اختر نموذجًا",
      "send": "إرسال",
      "showSchemaPanelAriaLabel": "إظهار لوحة المخطط",
      "showSchemaTooltip": "إظهار لوحة المخطط",
      "statusAsOfVersion": "اعتبارًا من الإصدار {{version}}",
      "statusHighlighted": "مميّز",
      "statusSample": "عينة",
      "thinking": "جارٍ التفكير…",
      "unexpectedResponseMessage": "لم يُرجع هذا الاستعلام بيانات رسم بياني. حاول إعادة صياغة سؤالك.",
      "updatedGraphFallbackMessage": "إليك الرسم البياني المُحدَّث.",
      "viewCommitVersionTooltip": "عرض إصدار تنفيذ محدد",
      "wrongTableTypeError": "هذا الجدول ليس جدول رسم بياني."
    },
    "graphSchemaPanel": {
      "collapseAriaLabel": "طي لوحة المخطط",
      "collapseTooltip": "طي لوحة المخطط",
      "defaultEngineName": "قاعدة بيانات الرسم البياني",
      "deselectAll": "إلغاء تحديد الكل",
      "edgesLabel": "الحواف",
      "emptyLabelTooltip": "لا توجد عُقد {{label}} في هذا الإصدار",
      "engineLabel": "المحرك",
      "graphDetailsTitle": "تفاصيل الرسم البياني",
      "labelCountTooltip_one": "عقدة {{label}} واحدة",
      "labelCountTooltip_other": "{{count}} عقدة من {{label}}",
      "labelsTitle": "التسميات",
      "nodesLabel": "العُقد",
      "notAvailable": "غير متاح",
      "relationshipsTitle_one": "العلاقات ({{count}})",
      "relationshipsTitle_other": "العلاقات ({{count}})",
      "schemaTitle": "المخطط",
      "selectAll": "تحديد الكل",
      "selectLabelsEmptyState": "اختر تسمية واحدة على الأقل لعرض علاقاتها.",
      "snapshotLabel": "اللقطة"
    },
    "graphWebglCanvas": {
      "layingOutGraphAriaLabel": "جارٍ ترتيب الرسم البياني…"
    },
    "neo4jGraphView": {
      "canvasControlsAriaLabel": "عناصر تحكم اللوحة",
      "clearSearchAriaLabel": "مسح البحث",
      "closeDetailsAriaLabel": "إغلاق التفاصيل",
      "closeDetailsKeepHighlightTooltip": "إغلاق (مع الاحتفاظ بالتمييز)",
      "closeDetailsTooltip": "إغلاق",
      "fitToViewTooltip": "ملاءمة العرض",
      "focusHintAfter": "لإعادة ضبط التركيز.",
      "focusHintBefore": "التركيز على عقدة واحدة — استخدم",
      "genericNodeLabel": "عقدة",
      "hiddenPropertiesFoot_one": "خاصية واحدة إضافية غير معروضة",
      "hiddenPropertiesFoot_other": "{{count}} خصائص إضافية غير معروضة",
      "lodHintDefault": "قرّب العرض لمزيد من التفاصيل",
      "noMatchingNodes": "لا توجد عُقد مطابقة",
      "nodeDetailsAriaLabel": "تفاصيل {{name}}",
      "relationshipDetailsAriaLabel": "تفاصيل العلاقة",
      "resetFocusTooltip": "إعادة ضبط التركيز",
      "searchAriaLabel": "البحث في العُقد",
      "searchPlaceholder": "البحث في العُقد…",
      "searchingEllipsis": "جارٍ البحث…",
      "zoomInTooltip": "تكبير",
      "zoomOutTooltip": "تصغير"
    },
    "vectorTab": {
      "actionDelete": "حذف",
      "actionEdit": "تعديل",
      "actionPreviewData": "معاينة البيانات",
      "actionRemoveAsDefault": "إزالة كافتراضي",
      "actionSetAsDefault": "تعيين كافتراضي",
      "actionSync": "مزامنة",
      "actionVectorSearch": "بحث متجهي",
      "actionViewDetails": "عرض التفاصيل",
      "addVectorDbTableButton": "إضافة جدول قاعدة بيانات متجهية",
      "allLabel": "الكل",
      "andOthersLabel_one": "{{names}} و{{count}} آخر",
      "andOthersLabel_other": "{{names}} و{{count}} أخرى",
      "bulkActionDeleteSelected": "حذف المحدد",
      "bulkActionSyncMetadata": "مزامنة البيانات الوصفية",
      "bulkDeletePartialWarning": "تم حذف {{deleted}}، وتخطي {{skipped}}: {{errors}}",
      "bulkDeleteSuccessToast_one": "تم حذف {{count}} جدول",
      "bulkDeleteSuccessToast_other": "تم حذف {{count}} جداول",
      "bulkSyncStartedRequeuedToast_one": "أُعيدت جدولة مزامنة البيانات الوصفية لـ {{count}} جدول",
      "bulkSyncStartedRequeuedToast_other": "أُعيدت جدولة مزامنة البيانات الوصفية لـ {{count}} جداول",
      "bulkSyncStartedToast_one": "بدأت مزامنة البيانات الوصفية لـ {{count}} جدول",
      "bulkSyncStartedToast_other": "بدأت مزامنة البيانات الوصفية لـ {{count}} جداول",
      "clearDefaultErrorToast": "تعذّرت إزالة {{name}} كافتراضي",
      "collectionViewTooltip": "عرض المجموعة",
      "columnActions": "الإجراءات",
      "columnCreator": "المنشئ",
      "columnDatabase": "قاعدة البيانات",
      "columnEmbeddingModel": "نموذج التضمين",
      "columnIntrospection": "الفحص الداخلي",
      "columnLogs": "السجلات",
      "columnName": "الاسم",
      "columnStatus": "الحالة",
      "columnVectors": "المتجهات",
      "databaseViewTooltip": "عرض قاعدة البيانات",
      "defaultBadgeTooltip": "الجدول الافتراضي",
      "defaultSchemaLabel": "افتراضي",
      "deleteConfirmLabel": "حذف",
      "deleteNamespaceConfirmMessage_one": "هل أنت متأكد أنك تريد حذف مساحة الاسم {{schema}} وجدولها المسجل ({{count}})؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deleteNamespaceConfirmMessage_other": "هل أنت متأكد أنك تريد حذف مساحة الاسم {{schema}} وجداولها المسجلة ({{count}})؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deleteNamespacePartialWarning": "تم حذف {{deleted}} من أصل {{schemaCount}} مساحات أسماء، وتخطي {{skipped}}",
      "deleteNamespaceSuccessToast_one": "تم حذف مساحة الاسم (تمت إزالة {{count}} جدول)",
      "deleteNamespaceSuccessToast_other": "تم حذف مساحة الاسم (تمت إزالة {{count}} جداول)",
      "deleteNamespaceSuccessToastNamed_one": "تم حذف مساحة الاسم {{schema}} (تمت إزالة {{count}} جدول)",
      "deleteNamespaceSuccessToastNamed_other": "تم حذف مساحة الاسم {{schema}} (تمت إزالة {{count}} جداول)",
      "deleteNamespaceTitle": "حذف مساحة الاسم",
      "deleteNamespacesConfirmMessage_one": "هل أنت متأكد أنك تريد حذف {{namespaceCount}} مساحات أسماء وجدولها المسجل ({{count}})؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deleteNamespacesConfirmMessage_other": "هل أنت متأكد أنك تريد حذف {{namespaceCount}} مساحات أسماء وجداولها المسجلة ({{count}})؟ يؤدي هذا إلى إزالة بيانات {{brand}} الوصفية فقط ولا يمكن التراجع عنه.",
      "deleteNamespacesCountLabel_one": "حذف {{count}} مساحة اسم",
      "deleteNamespacesCountLabel_other": "حذف {{count}} مساحات أسماء",
      "deleteNamespacesSuccessToast_one": "تم حذف {{schemaCount}} مساحات أسماء (تمت إزالة {{count}} جدول)",
      "deleteNamespacesSuccessToast_other": "تم حذف {{schemaCount}} مساحات أسماء (تمت إزالة {{count}} جداول)",
      "deleteNamespacesTitle": "حذف مساحات الأسماء",
      "deleteSelectedTablesConfirmMessage_one": "هل أنت متأكد أنك تريد حذف الجدول المحدد ({{count}})؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteSelectedTablesConfirmMessage_other": "هل أنت متأكد أنك تريد حذف الجداول المحددة ({{count}})؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteSelectedTablesTitle": "حذف الجداول المحددة",
      "deleteTableConfirmMessage": "هل أنت متأكد أنك تريد حذف {{name}}؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteTableConfirmTitle": "حذف الجدول",
      "deleteTablesCountLabel_one": "حذف {{count}} جدول",
      "deleteTablesCountLabel_other": "حذف {{count}} جداول",
      "deletingLabel": "جارٍ الحذف…",
      "favoritesLabel": "المفضلة",
      "filterAllCreatorsPlaceholder": "جميع المنشئين",
      "filterAllEnginesPlaceholder": "جميع المحركات",
      "filterCreatorLabel": "المنشئ",
      "filterEngineLabel": "المحرك",
      "namespacesTitle": "مساحات الأسماء",
      "noConnectorsYet": "لا توجد موصلات بعد",
      "notConfigured": "غير مُهيأ",
      "setDefaultErrorToast": "تعذّر تعيين {{name}} كافتراضي",
      "syncMetadataErrorToast": "تعذّرت مزامنة البيانات الوصفية لـ {{name}}",
      "syncStatus": {
        "active": "نشط",
        "failed": "فشل",
        "inactive": "غير نشط",
        "queued": "في الانتظار",
        "running": "قيد التشغيل",
        "synced": "تمت المزامنة"
      },
      "unknownConnectorType": "غير معروف",
      "unknownCreator": "غير معروف",
      "vectorDbExplorerAriaLabel": "مستكشف قاعدة البيانات المتجهية",
      "vectorTablesLeafTitle": "الجداول المتجهية",
      "vectorTablesLeafTitleWithSchema": "الجداول المتجهية — {{schema}}",
      "viewLink": "عرض",
      "viewSyncLogsTooltip": "عرض سجلات المزامنة",
      "resourceVectorDatabases": "قواعد بيانات المتجهات",
      "resourceVectorDatabase": "قاعدة بيانات متجهات"
    },
    "vectorSearchModal": {
      "advancedRagLabel": "RAG متقدم",
      "closeDialogAriaLabel": "إغلاق",
      "contentLabel": "المحتوى",
      "coverageLabel": "التغطية",
      "embeddingModelLabel": "نموذج التضمين",
      "enhancementsLabel": "التحسينات",
      "foundResultsPrefix": "تم العثور على",
      "hideButton": "إخفاء",
      "hydeEnhancementLabel": "HyDE (تضمينات المستندات الافتراضية)",
      "idFallbackLabel": "النتيجة {{id}}",
      "latencyMs": "{{ms}} مللي ثانية",
      "loadingOption": "جارٍ التحميل…",
      "metadataLabel": "البيانات الوصفية",
      "missingAspectsLabel": "الجوانب الناقصة: {{aspects}}",
      "modelDefaultLabel": "{{name}} (افتراضي)",
      "modelLabel": "النموذج: {{name}}",
      "modelsWordBold": "نماذج",
      "multiQueryExpansionLabel": "توسيع الاستعلامات المتعددة",
      "noEmbeddingModelsOption": "لا توجد نماذج تضمين متاحة",
      "noModelRegisteredBody": "لتشغيل البحث المتجهي على هذا الجدول، سجّل واحدًا أو أكثر من",
      "noModelRegisteredBold": "لا يوجد نموذج تضمين مسجل.",
      "noModelRegisteredSuffix": "للتضمينات، أو بدّل إلى RAG المتقدم.",
      "noResultsBasicHint": "جرّب استعلام بحث مختلفًا أو تحقق من نموذج التضمين الخاص بك.",
      "noResultsFoundTitle": "لم يتم العثور على نتائج",
      "noResultsRagHint": "جرّب إعادة صياغة استعلامك أو ضبط استراتيجية RAG.",
      "qualityLabel": "الجودة:",
      "ragSearchButton": "بحث RAG",
      "ragSearchingButton": "جارٍ البحث…",
      "ragStrategyConfigTitle": "إعداد استراتيجية RAG",
      "registerModelFirstTooltip": "سجّل نموذج تضمين أولاً",
      "relevanceLabel": "الملاءمة:",
      "rerankingLabel": "إعادة الترتيب",
      "resultFallbackLabel": "النتيجة {{index}}",
      "resultsInLatencyMiddle": "نتيجة خلال",
      "resultsLabel": "النتائج:",
      "resultsSuffix": "نتيجة",
      "searchButton": "بحث",
      "searchFailedTitle": "فشل البحث",
      "searchModelsPlaceholder": "ابحث عن النماذج…",
      "searchPlaceholder": "أدخل استعلام البحث…",
      "searchingButton": "جارٍ البحث…",
      "selfCorrectedBadge_one": "تم التصحيح الذاتي (محاولة واحدة)",
      "selfCorrectedBadge_other": "تم التصحيح الذاتي ({{count}} محاولات)",
      "selfRagCorrectionLabel": "تصحيح Self-RAG",
      "semanticSearchBody": "أدخل استعلامًا أعلاه للبحث في تضمينات هذا الجدول المتجهية.",
      "semanticSearchTitle": "البحث الدلالي",
      "settingsButton": "الإعدادات",
      "strategyAutoOption": "تلقائي",
      "strategyDecompositionOption": "التفكيك",
      "strategyDescriptionAuto": "يختار تلقائيًا أفضل استراتيجية استرجاع لاستعلامك.",
      "strategyDescriptionDecomposition": "يقسّم الاستعلامات المعقّدة إلى أسئلة فرعية ويسترجع لكل منها.",
      "strategyDescriptionDirect": "يبحث مباشرة باستخدام نص الاستعلام الأصلي.",
      "strategyDescriptionHyde": "يولّد إجابة افتراضية أولاً، ثم يبحث باستخدام تضمينها.",
      "strategyDescriptionMultiQuery": "يولّد عدة صيغ للاستعلام لتوسيع نطاق الاسترجاع.",
      "strategyDirectOption": "مباشر",
      "strategyHydeOption": "HyDE",
      "strategyLabel": "الاستراتيجية",
      "strategyMultiQueryOption": "استعلامات متعددة",
      "title": "البحث المتجهي",
      "useDefaultOption": "استخدام الافتراضي"
    },
    "storageTab": {
      "actionDelete": "حذف",
      "actionExport": "تصدير",
      "actionPreviewFiles": "معاينة الملفات",
      "actionSetAsDefault": "تعيين كافتراضي",
      "actionSync": "مزامنة",
      "actionSyncing": "جارٍ المزامنة…",
      "actionViewDetails": "عرض التفاصيل",
      "addStorageButton": "إضافة تخزين",
      "allLabel": "الكل",
      "columnActions": "الإجراءات",
      "columnConnector": "الموصل",
      "columnContainer": "الحاوية",
      "columnCreated": "تاريخ الإنشاء",
      "columnFolder": "المجلد",
      "columnLogs": "السجلات",
      "columnStatus": "الحالة",
      "columnUpdated": "تاريخ التحديث",
      "defaultBadgeTooltip": "المجلد الافتراضي",
      "defaultBucketLabel": "افتراضي",
      "defaultConnectorName": "موصل غير معروف",
      "deleteConfirmLabel": "حذف",
      "deleteConfirmMessage": "هل أنت متأكد أنك تريد حذف {{name}}؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteConfirmTitle": "حذف مجلد التخزين",
      "emptyMessage": "لم يتم العثور على مجلدات تخزين",
      "exportSelectedAction": "تصدير المحدد",
      "favoritesLabel": "المفضلة",
      "filterAllCreatorsPlaceholder": "جميع المنشئين",
      "filterAllTypesPlaceholder": "جميع الأنواع",
      "filterCreatorLabel": "المنشئ",
      "filterStorageTypeLabel": "نوع التخزين",
      "foldersLeafTitle": "المجلدات",
      "foldersLeafTitleWithBucket": "المجلدات — {{bucket}}",
      "listViewTooltip": "عرض القائمة",
      "noConnectorsYet": "لا توجد موصلات بعد",
      "pendingBadge": "معلّق",
      "setDefaultErrorToast": "تعذّر تعيين {{name}} كافتراضي",
      "setDefaultSuccessToast": "تم تعيين {{name}} كافتراضي",
      "splitViewTooltip": "عرض مقسّم",
      "statusActive": "نشط",
      "statusApproved": "مُعتمد",
      "statusRequested": "مطلوب",
      "statusUnknown": "غير معروف",
      "storageExplorerAriaLabel": "مستكشف التخزين",
      "unknownConnectorType": "غير معروف",
      "viewLink": "عرض",
      "viewSyncLogsTooltip": "عرض سجلات المزامنة"
    },
    "storageViewModal": {
      "auditInformationSectionTitle": "معلومات التدقيق",
      "basicInformationSectionTitle": "المعلومات الأساسية",
      "closeButton": "إغلاق",
      "closeDialogAriaLabel": "إغلاق",
      "errorInformationSectionTitle": "معلومات الخطأ",
      "fieldBucketName": "اسم الحزمة (Bucket)",
      "fieldConnector": "الموصل",
      "fieldCreatedAt": "تاريخ الإنشاء",
      "fieldCreatedBy": "أنشأه",
      "fieldErrorMessage": "رسالة الخطأ",
      "fieldFileCount": "عدد الملفات",
      "fieldFolderPath": "مسار المجلد",
      "fieldId": "المعرّف",
      "fieldStatus": "الحالة",
      "fieldTotalSize": "الحجم الإجمالي",
      "fieldUpdatedAt": "تاريخ التحديث",
      "fieldUpdatedBy": "حدّثه",
      "metadataSectionTitle": "البيانات الوصفية",
      "noErrors": "لا توجد أخطاء",
      "notAvailable": "غير متاح",
      "status": {
        "active": "نشط",
        "error": "خطأ",
        "syncing": "جارٍ المزامنة",
        "unknown": "غير معروف"
      },
      "storageInformationSectionTitle": "معلومات التخزين",
      "title": "تفاصيل مجلد التخزين"
    },
    "storageFolderPreview": {
      "actionsTooltip": "الإجراءات",
      "cancelButton": "إلغاء",
      "clearSearchAriaLabel": "مسح البحث",
      "clearSelectionAriaLabel": "مسح التحديد",
      "closeDialogAriaLabel": "إغلاق",
      "columnActions": "الإجراءات",
      "columnModified": "تاريخ التعديل",
      "columnName": "الاسم",
      "columnSize": "الحجم",
      "columnType": "النوع",
      "downloadErrorToast": "فشل تنزيل الملف",
      "downloadResultAllFailed": "تعذر تنزيل أي من الملفات المحددة.",
      "downloadResultAllSuccess": "تم تنزيل جميع الملفات البالغ عددها {{count}} بنجاح.",
      "downloadResultOk": "حسنًا",
      "downloadResultPartial": "تم تنزيل {{successCount}} من {{total}} ملفات بنجاح. فشل: {{failedNames}}",
      "downloadResultTitleFailed": "فشل التنزيل",
      "downloadResultTitlePartial": "التنزيل غير مكتمل",
      "downloadResultTitleSuccess": "اكتمل التنزيل",
      "downloadSelectedButton": "تنزيل المحدد",
      "downloadSelectedTooltip": "تنزيل الملفات المحددة",
      "downloadingSelectedButton": "جارٍ التنزيل…",
      "emptySearchState": "لا توجد ملفات مطابقة لبحثك",
      "emptyState": "لا يحتوي هذا المجلد على ملفات",
      "exportAction": "تنزيل",
      "firstPageTooltip": "الصفحة الأولى",
      "lastPageTooltip": "الصفحة الأخيرة",
      "nextPageTooltip": "الصفحة التالية",
      "openingFileLabel": "جارٍ فتح الملف…",
      "paginationInfo": "عرض {{from}}–{{to}} من {{total}}",
      "previousPageTooltip": "الصفحة السابقة",
      "searchPlaceholder": "ابحث عن الملفات…",
      "selectAllAriaLabel": "تحديد كل الملفات",
      "selectFileAriaLabel": "تحديد {{name}}",
      "selectedCount": "تم تحديد {{count}}",
      "selectionLimitWarning": "يمكنك تحديد 10 ملفات كحد أقصى في كل مرة.",
      "syncButtonLabel": "مزامنة",
      "syncButtonTooltip": "مزامنة ملفات هذا المجلد",
      "syncingButtonLabel": "جارٍ المزامنة…",
      "viewAction": "معاينة"
    },
    "storageFilePreview": {
      "closeDialogAriaLabel": "إغلاق",
      "downloadButton": "تنزيل",
      "downloadErrorToast": "فشل تنزيل الملف",
      "emptyTable": "لا توجد صفوف للعرض",
      "imagePreviewAlt": "معاينة الصورة",
      "loadErrorToast": "فشل معاينة الملف",
      "nullValueLabel": "NULL",
      "rowsUnit": "صفوف",
      "textPreviewAriaLabel": "محتوى الملف",
      "tryAgainButton": "إعادة المحاولة",
      "unableToLoadTitle": "تعذر معاينة الملف",
      "unsupportedHint": "لا يمكن عرض هذا النوع من الملفات في المتصفح. نزّل الملف لفتحه.",
      "unsupportedTitle": "المعاينة غير متاحة"
    },
    "groupedStorageView": {
      "bucketPathTooltip": "{{bucket}}/{{path}}",
      "createdTooltip": "تاريخ الإنشاء",
      "emptyState": "لم يتم العثور على مجلدات تخزين",
      "emptyStateHint": "جرّب مصطلح بحث مختلفًا",
      "fileCount_one": "{{count}} ملف",
      "fileCount_other": "{{count}} ملفات",
      "folderCount_one": "{{count}} مجلد",
      "folderCount_other": "{{count}} مجلدات",
      "loadingFolders": "جارٍ تحميل المجلدات…",
      "unknownConnectorName": "موصل غير معروف",
      "updatedTooltip": "تاريخ التحديث"
    },
    "metadataSyncLogsModal": {
      "bulkJobLabel": "مهمة مجمّعة",
      "closeAriaLabel": "إغلاق",
      "collapseDetailAriaLabel": "طي التفاصيل",
      "columnMessage": "الرسالة",
      "columnStatus": "الحالة",
      "columnWhen": "الوقت",
      "emptyState": "لم يتم العثور على سجلات مزامنة",
      "entryCount_one": "{{count}} إدخال",
      "entryCount_other": "{{count}} إدخالات",
      "expandDetailAriaLabel": "توسيع التفاصيل",
      "loadingLogs": "جارٍ تحميل السجلات…",
      "title": "سجلات مزامنة البيانات الوصفية",
      "triggerLabel": "المحفّز:"
    },
    "bulkMetadataSyncModal": {
      "closeAriaLabel": "إغلاق",
      "columnDetail": "التفاصيل",
      "columnStatus": "الحالة",
      "columnTable": "الجدول",
      "jobLabel": "المهمة",
      "loadingStatus": "جارٍ تحميل حالة المزامنة…",
      "noJobData": "لا تتوفر بيانات للمهمة",
      "requeuedToast_one": "أُعيد إدراج عنصر واحد ({{count}}) في قائمة الانتظار لإعادة المحاولة",
      "requeuedToast_other": "أُعيد إدراج {{count}} عناصر في قائمة الانتظار لإعادة المحاولة",
      "retryFailedButton_one": "إعادة محاولة {{count}} فاشل",
      "retryFailedButton_other": "إعادة محاولة {{count}} فاشلة",
      "title": "مزامنة مجمّعة للبيانات الوصفية"
    },
    "tableDataPreview": {
      "loadErrorToast": "فشل تحميل بيانات الجدول",
      "nullValueLabel": "NULL",
      "columnEdit": "تعديل",
      "editGoldenAnswerAriaLabel": "تعديل الإجابة المرجعية",
      "csvExportedToast_other": "تم تصدير {{count}} صفوف إلى CSV",
      "jsonExportedToast_other": "تم تصدير {{count}} صفوف إلى JSON",
      "previewNotAvailable": "المعاينة غير متاحة لمصدر البيانات هذا",
      "vertexAiDataStoreHint": "يعتمد هذا الجدول على مخزن بيانات Vertex AI Search. احصل على المعاينة بالاستعلام عن مخزن البيانات مباشرة.",
      "vertexAiVectorSearchHint": "يعتمد هذا الجدول على فهرس Vertex AI Vector Search. احصل على المعاينة بتشغيل استعلام بحث متجهي.",
      "closeDialogAriaLabel": "إغلاق",
      "unableToLoadTitle": "تعذّر تحميل البيانات",
      "dataUnavailableTitle": "البيانات غير متاحة",
      "syncingButton": "جارٍ المزامنة…",
      "refreshMetadataButton": "تحديث البيانات الوصفية",
      "tryAgainButton": "إعادة المحاولة",
      "documentsUnit": "مستندات",
      "rowsUnit": "صفوف",
      "elasticsearchSearchPlaceholder": "ابحث باستخدام صياغة استعلام Lucene…",
      "searchPlaceholder": "بحث…",
      "clearSearchAriaLabel": "مسح البحث",
      "luceneQueryHintTitle": "يدعم صياغة استعلام Lucene، مثل field:value AND other:value",
      "paginationFullTextSearchHint": "يُطبَّق البحث النصي الكامل على جميع الأعمدة",
      "tableViewTitle": "عرض الجدول",
      "tableTab": "جدول",
      "graphViewTitle": "عرض الرسم البياني",
      "graphTab": "رسم بياني",
      "documentViewJsonTitle": "عرض المستند (JSON)",
      "documentsTab": "مستندات",
      "tabularViewTitle": "عرض جدولي",
      "exportJsonButton": "تصدير JSON",
      "exportingButton": "جارٍ التصدير…",
      "exportCsvButton": "تصدير CSV",
      "documentFallbackLabel": "مستند {{index}}",
      "statusLabel": "الحالة: {{status}}",
      "hideJsonButton": "إخفاء JSON",
      "showJsonButton": "إظهار JSON",
      "noPreviewFieldsHint": "لم يتم تكوين حقول معاينة لهذا المستند.",
      "pageOfLabel": "صفحة {{page}} من {{totalPages}}",
      "pageSizeLabel": "عدد الصفوف في الصفحة",
      "previousButton": "السابق",
      "nextButton": "التالي",
      "noDataFoundEmptyMessage": "لم يتم العثور على بيانات"
    },
    "ontology": {
      "retrievalConfigPanel": {
        "strategyAuto": "تلقائي",
        "strategyAutoDescription": "يختار تلقائيًا أفضل استراتيجية استرجاع بناءً على الاستعلام",
        "strategyVector": "البحث المتجهي",
        "strategyVectorDescription": "استرجاع النتائج باستخدام بحث التشابه الدلالي عبر المتجهات",
        "strategySql": "SQL",
        "strategySqlDescription": "استرجاع النتائج بتوليد وتشغيل استعلامات SQL على الجدول",
        "strategyHybrid": "مختلط",
        "strategyHybridDescription": "الجمع بين البحث المتجهي والبحث بالكلمات المفتاحية/SQL للحصول على نتائج أدق",
        "fusionMethodRrf": "دمج الرتب التبادلية (RRF)",
        "fusionMethodRrfDescription": "دمج قوائم النتائج المرتبة باستخدام دمج الرتب التبادلية",
        "fusionMethodWeighted": "المجموع الموزون",
        "fusionMethodWeightedDescription": "دمج الدرجات عبر مجموع موزون لنتائج البحث المتجهي والكلمات المفتاحية",
        "fusionMethodCascade": "تسلسلي",
        "fusionMethodCascadeDescription": "تشغيل البحث بالكلمات المفتاحية أولاً، ثم إعادة الترتيب باستخدام البحث المتجهي",
        "distanceMetricCosine": "جيب التمام",
        "distanceMetricEuclidean": "إقليدية",
        "distanceMetricDotProduct": "الضرب النقطي",
        "title": "إعدادات الاسترجاع",
        "resetToDefaultsTitle": "إعادة التعيين إلى الإعدادات الافتراضية",
        "resetButton": "إعادة تعيين",
        "defaultStrategyLabel": "استراتيجية الاسترجاع الافتراضية",
        "vectorSearchSettingsLabel": "إعدادات البحث المتجهي",
        "idColumnLabel": "عمود المعرّف",
        "autoDetectOption": "اكتشاف تلقائي",
        "contentColumnLabel": "عمود المحتوى",
        "embeddingColumnLabel": "عمود التضمين",
        "distanceMetricLabel": "مقياس المسافة",
        "hybridFusionSettingsLabel": "إعدادات الدمج المختلط",
        "fusionMethodLabel": "طريقة الدمج",
        "weightDistributionLabel": "توزيع الأوزان",
        "vectorSliderLabel": "وزن المتجه",
        "keywordSliderLabel": "وزن الكلمة المفتاحية",
        "sqlSettingsLabel": "إعدادات SQL",
        "maxRowsLabel": "الحد الأقصى لعدد الصفوف المُرجعة",
        "enableFullTextSearchLabel": "تفعيل البحث النصي الكامل",
        "rerankingLabel": "إعادة الترتيب",
        "enableCrossEncoderRerankingLabel": "تفعيل إعادة الترتيب باستخدام Cross-Encoder",
        "rerankingModelLabel": "نموذج إعادة الترتيب",
        "loadingModelsOption": "جارٍ تحميل النماذج…",
        "noRegisteredModelsOption": "لا توجد نماذج مسجَّلة",
        "rerankTopKLabel": "أعلى K لإعادة الترتيب",
        "infoCardText": "تتحكم هذه الإعدادات في كيفية استرجاع هذا الجدول أثناء استعلامات RAG. تُطبَّق التغييرات في المرة التالية التي يُستعلَم فيها عن هذا الجدول."
      },
      "columnEditor": {
        "semanticTypeId": "معرّف",
        "semanticTypeIdDescription": "يحدد السجل بشكل فريد (مثل المفتاح الأساسي)",
        "semanticTypeEntity": "كيان",
        "semanticTypeEntityDescription": "يشير إلى شخص أو مكان أو شيء له اسم",
        "semanticTypeMetric": "مقياس",
        "semanticTypeMetricDescription": "قيمة رقمية تُستخدم للتجميع أو القياس",
        "semanticTypeDimension": "بُعد",
        "semanticTypeDimensionDescription": "سمة تصنيفية تُستخدم للتجميع أو التصفية",
        "semanticTypeTimestamp": "الطابع الزمني",
        "semanticTypeTimestampDescription": "قيمة تاريخ أو وقت",
        "semanticTypeText": "نص",
        "semanticTypeTextDescription": "محتوى نصي حر",
        "closeEditorTitle": "إغلاق المحرر",
        "businessNameLabel": "الاسم التجاري",
        "businessNameHint": "اسم سهل الفهم لهذا العمود",
        "businessNamePlaceholder": "مثال: اسم العميل",
        "descriptionLabel": "الوصف",
        "descriptionHint": "اشرح ما يمثله هذا العمود",
        "descriptionPlaceholder": "مثال: الاسم القانوني الكامل للعميل",
        "semanticTypeLabel": "النوع الدلالي",
        "semanticTypeHint": "صنّف نوع البيانات التي يحتويها هذا العمود",
        "exampleValuesLabel": "قيم نموذجية",
        "exampleValuesHint": "قيم نموذجية تساعد الآخرين على فهم هذا العمود",
        "addExamplePlaceholder": "إضافة قيمة نموذجية",
        "constraintsLabel": "القيود",
        "constraintsHint": "قواعد العمل أو قيود التحقق لهذا العمود",
        "constraintsPlaceholder": "مثال: يجب ألا يكون فارغًا",
        "relationshipsLabel": "العلاقات",
        "relationshipsHint": "الجداول أو الأعمدة الأخرى المرتبطة بهذا العمود",
        "tableNamePlaceholder": "اسم الجدول",
        "columnNamePlaceholder": "اسم العمود",
        "relationshipTypeForeignKey": "مفتاح خارجي",
        "relationshipTypeReference": "مرجع",
        "addRelationshipButton": "إضافة علاقة",
        "searchSettingsLabel": "إعدادات البحث",
        "searchSettingsHint": "التحكم في كيفية استخدام هذا العمود في البحث والاسترجاع",
        "searchableLabel": "قابل للبحث",
        "searchableHint": "تضمين هذا العمود في البحث النصي الكامل وبحث الكلمات المفتاحية",
        "embedForVectorSearchLabel": "تضمين للبحث المتجهي",
        "embedForVectorSearchHint": "إنشاء تضمينات لهذا العمود لدعم البحث الدلالي"
      },
      "tableDescriptionEditor": {
        "tablePurposeLabel": "الغرض من الجدول",
        "tablePurposeHelp": "صِف الغرض الذي يُستخدم من أجله هذا الجدول",
        "tablePurposePlaceholder": "مثال: يخزّن سجل طلبات العملاء لأغراض إعداد التقارير",
        "businessContextLabel": "السياق التجاري",
        "businessContextHelp": "اشرح السياق التجاري وكيفية اندماج هذا الجدول ضمن نموذج البيانات الأوسع",
        "businessContextPlaceholder": "مثال: يستخدمه فريق المبيعات لتتبع تنفيذ الطلبات",
        "sampleQuestionsLabel": "أسئلة نموذجية",
        "sampleQuestionsHelp": "أمثلة على الأسئلة التي يمكن لهذا الجدول المساعدة في الإجابة عنها",
        "removeQuestionTitle": "إزالة السؤال",
        "addQuestionPlaceholder": "إضافة سؤال نموذجي",
        "addQuestionTitle": "إضافة سؤال",
        "addButton": "إضافة",
        "tipsTitle": "نصائح",
        "tip1": "كن محددًا بشأن ما يحتويه الجدول ومن يستخدمه.",
        "tip2": "أضف المصطلحات التجارية التي قد يبحث عنها المستخدمون.",
        "tip3": "أضف أسئلة نموذجية لمساعدة نموذج الاسترجاع على مطابقة الاستعلامات ذات الصلة.",
        "tip4": "اجعل الأوصاف موجزة لكنها غنية بالمعلومات."
      },
      "schemaVisualizer": {
        "semanticTypeId": "معرّف",
        "semanticTypeTimestamp": "الطابع الزمني",
        "semanticTypeMetric": "مقياس",
        "semanticTypeDimension": "بُعد",
        "semanticTypeEntity": "كيان",
        "semanticTypeText": "نص",
        "groupPrimaryKeys": "المفاتيح الأساسية",
        "groupForeignKeys": "المفاتيح الخارجية",
        "groupTimestamps": "الطوابع الزمنية",
        "groupMetrics": "المقاييس",
        "groupDimensions": "الأبعاد",
        "groupOther": "أخرى",
        "subtitle": "نظرة عامة مرئية على أعمدة الجدول وعلاقاتها",
        "columnCount": "{{count}} عمود",
        "columnCount_other": "{{count}} أعمدة",
        "hasOntologyLegend": "له أنطولوجيا مُعرَّفة",
        "foreignKeyLegend": "مفتاح خارجي"
      }
    },
    "tableOntologyPage": {
      "noTableIdError": "لم يتم تقديم معرّف جدول",
      "saveSuccessToast": "تم حفظ الأنطولوجيا بنجاح",
      "saveErrorToast": "فشل حفظ الأنطولوجيا: {{message}}",
      "unsavedChangesConfirm": "لديك تغييرات غير محفوظة. هل تريد المغادرة فعلاً؟",
      "loadingMessage": "جارٍ تحميل أنطولوجيا الجدول…",
      "schemaEditorUnavailableTitle": "محرر المخطط غير متاح",
      "schemaEditorUnavailableMessage": "محرر المخطط غير متاح لنوع الموصل الخاص بهذا الجدول.",
      "failedToLoadTitle": "فشل تحميل الجدول",
      "tableNotFoundMessage": "تعذر العثور على الجدول المطلوب.",
      "goBack": "رجوع",
      "backToKnowledgeTooltip": "العودة إلى Knowledge",
      "breadcrumbKnowledge": "Knowledge",
      "breadcrumbTables": "الجداول",
      "breadcrumbOntology": "الأنطولوجيا",
      "vectorBadge": "متجه",
      "unsavedChangesBadge": "تغييرات غير محفوظة",
      "resetToSavedTooltip": "إعادة التعيين إلى آخر نسخة محفوظة",
      "reset": "إعادة تعيين",
      "saving": "جارٍ الحفظ…",
      "saveChanges": "حفظ التغييرات",
      "schemaPanelTitle": "المخطط",
      "databaseLabel": "قاعدة البيانات",
      "schemaLabel": "المخطط",
      "tableLabel": "الجدول",
      "rowsLabel": "الصفوف",
      "embeddingModelTitle": "نموذج التضمين",
      "loadingModels": "جارٍ تحميل النماذج…",
      "noEmbeddingModelsWarning": "لا توجد نماذج تضمين مسجَّلة. سجِّل نموذجًا لتفعيل البحث المتجهي لهذا الجدول.",
      "selectModelOption": "اختر نموذجًا",
      "modelOptionDefaultLabel": "{{name}} (افتراضي)",
      "modelOptionLabel": "{{name}}",
      "noModelSelectedWarning": "لم يتم تحديد نموذج تضمين. لن يكون البحث المتجهي متاحًا لهذا الجدول.",
      "columnsHeader": "الأعمدة",
      "hasOntologyDefinedTooltip": "الأنطولوجيا مُعرَّفة لهذا العمود",
      "tabDescription": "الوصف",
      "tabRetrieval": "الاسترجاع",
      "tabTest": "اختبار",
      "queryTestingTitle": "اختبار الاستعلامات",
      "queryTestingDescription": "اختبر كيفية استرجاع الاستعلامات وفقًا لإعدادات هذا الجدول.",
      "comingSoon": "قريبًا"
    },
    "mongoCompassDocumentView": {
      "documentViewTitle": "عرض المستند",
      "documentsTab": "مستندات",
      "tabularViewTitle": "عرض جدولي",
      "tableTab": "جدول",
      "exportDataButton": "تصدير البيانات",
      "closeAriaLabel": "إغلاق",
      "filterLabel": "تصفية",
      "filterPlaceholder": "مثال: { status: \"active\" }",
      "filterInputAriaLabel": "استعلام التصفية",
      "clearFilterAriaLabel": "مسح التصفية",
      "applyFilterTitle": "تطبيق التصفية",
      "findButton": "بحث",
      "queryHint": "أدخل مرشّح استعلام MongoDB بصيغة JSON",
      "documentCountLabel": "{{count}} مستند",
      "documentCountLabel_other": "{{count}} مستندات",
      "zeroResults": "لا توجد نتائج",
      "pageRangeHint": "{{from}}–{{to}} من {{total}}",
      "documentFallbackLabel": "مستند {{index}}",
      "hideDocumentAriaLabel": "إخفاء المستند",
      "showDocumentAriaLabel": "إظهار المستند",
      "skipLimitLabel": "التخطي: {{skip}}، الحد: {{limit}}",
      "pageSizeLabel": "حجم الصفحة",
      "pageSizeSelectAriaLabel": "اختيار حجم الصفحة",
      "previousButton": "السابق",
      "nextButton": "التالي"
    }
  },
  "accessRequests": {
    "manageAccessTitle": "إدارة صلاحيات الوصول إلى {{assetLabel}}",
    "assetTypeLabels": {
      "models": "النماذج",
      "tools": "الأدوات",
      "knowledge": "المعرفة",
      "storage": "التخزين",
      "skills": "المهارات",
      "orchestrators": "المنسقون",
      "default": "الأصول"
    },
    "statusLabels": {
      "requested": "معلق",
      "approved": "تمت الموافقة",
      "open": "ملغى"
    },
    "loadingRequests": "جارٍ تحميل طلبات الوصول...",
    "clearSearch": "مسح البحث",
    "emptyStateAll": "لا توجد طلبات وصول لـ {{assetType}}.",
    "emptyStateFiltered": "لا توجد طلبات وصول {{status}} لـ {{assetType}}.",
    "selectedCount": "تم تحديد {{count}}",
    "selectAll": "تحديد الكل",
    "deselectAll": "إلغاء تحديد الكل",
    "approveSelected": "الموافقة على المحدد ({{count}})",
    "rejectSelected": "رفض المحدد ({{count}})",
    "columnAssetName": "اسم الأصل",
    "columnProject": "المشروع",
    "columnRequestedBy": "طلب بواسطة",
    "columnStatus": "الحالة",
    "columnCreated": "تاريخ الإنشاء",
    "columnLastUpdated": "آخر تحديث",
    "columnActions": "الإجراءات",
    "approve": "موافقة",
    "reject": "رفض",
    "reApprove": "إعادة الموافقة",
    "revokeAccess": "إلغاء الوصول",
    "rowsPerPage": "الصفوف في الصفحة:",
    "showingRange": "عرض {{start}}-{{end}} من {{total}}",
    "goToFirstPage": "الانتقال إلى الصفحة الأولى",
    "goToPreviousPage": "الانتقال إلى الصفحة السابقة",
    "goToPage": "الانتقال إلى الصفحة {{page}}",
    "goToNextPage": "الانتقال إلى الصفحة التالية",
    "goToLastPage": "الانتقال إلى الصفحة الأخيرة",
    "firstPage": "الصفحة الأولى",
    "previousPage": "الصفحة السابقة",
    "nextPage": "الصفحة التالية",
    "lastPage": "الصفحة الأخيرة",
    "endOfTableReached": "تم الوصول إلى نهاية الجدول",
    "statusFilterLabel": "الحالة",
    "statusFilterPlaceholder": "الحالة",
    "projectFilterLabel": "المشروع",
    "projectFilterPlaceholder": "المشروع",
    "requestedByFilterLabel": "طلب بواسطة",
    "requestedByFilterPlaceholder": "طلب بواسطة",
    "bulkApprovePartial": "تمت الموافقة على {{processed}}؛ فشل {{skipped}}: {{errors}}",
    "bulkRejectPartial": "تم رفض {{processed}}؛ فشل {{skipped}}: {{errors}}"
  },
  "skills": {
    "title": "المهارات (Skills)",
    "subtitle": "المهارات عبارة عن حزم تعليمات معيارية تعزز قدرات الوكيل.",
    "list": {
      "columns": {
        "name": "اسم المهارة",
        "category": "الفئة",
        "type": "النوع",
        "model": "النموذج",
        "visibility": "الرؤية",
        "version": "الإصدار",
        "access": "الوصول",
        "updated": "تم التحديث",
        "actions": "الإجراءات"
      },
      "actions": {
        "view": "عرض",
        "edit": "تعديل",
        "delete": "حذف",
        "export": "تصدير",
        "clone": "استنساخ إلى المشروع",
        "manageAccess": "إدارة الوصول",
        "exportSelected": "تصدير المحدد",
        "deleteSelected": "حذف المحدد"
      },
      "badges": {
        "builtin": "مدمج",
        "platform": "المنصة",
        "allModels": "جميع النماذج"
      },
      "bulkDelete": {
        "title": "حذف المهارات المحددة",
        "noSelection": "لم يتم تحديد أي مهارات",
        "cannotDeleteBuiltin": "لا يمكن حذف مهارات المنصة المدمجة",
        "skippedBuiltin": "سيتم تخطي {{count}} من المهارات المدمجة.",
        "success": "تم حذف {{count}} مهارة بنجاح",
        "partial": "تم حذف {{deleted}} مهارة، وفشل {{skipped}}: {{errors}}",
        "error": "فشل حذف المهارات"
      }
    },
    "categories": {
      "data_processing": "معالجة البيانات",
      "data_analysis": "تحليل البيانات",
      "reasoning": "التفكير",
      "code_generation": "إنشاء الكود",
      "document_analysis": "تحليل المستندات",
      "web_interaction": "التفاعل مع الويب",
      "communication": "التواصل",
      "research": "البحث",
      "automation": "الأتمتة",
      "custom": "مخصص"
    },
    "types": {
      "behavioral": "سلوكي",
      "procedural": "إجرائي",
      "knowledge": "معرفة",
      "guardrail": "حاجز حماية",
      "custom": "مخصص"
    },
    "visibility": {
      "project": "مشروع",
      "tenant": "مؤسسة",
      "public": "منصة"
    },
    "filters": {
      "category": "الفئة",
      "type": "النوع",
      "visibility": "الرؤية",
      "project": "المشروع",
      "all": "الكل",
      "favorites": "المفضلة"
    },
    "newSkill": "مهارة جديدة",
    "loading": "جاري تحميل المهارات...",
    "empty": {
      "message": "لم يتم العثور على مهارات. أنشئ مهارتك الأولى لتعزيز قدرات الوكيل."
    },
    "delete": {
      "title": "حذف المهارة",
      "message": "هل أنت متأكد أنك تريد حذف \"{{name}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkMessage": "هل أنت متأكد أنك تريد حذف {{count}} مهارة؟ لا يمكن التراجع عن هذا الإجراء.",
      "bulkConfirm": "حذف {{count}} مهارة",
      "bulkDepsOthers": "{{names}} و {{count}} آخرين"
    },
    "messages": {
      "dependencyCheckFailed": "فشل في التحقق من تبعيات المهارة",
      "deleteFailed": "فشل حذف المهارة"
    },
    "edit": {
      "subtitle": {
        "new": "إنشاء قدرة معيارية",
        "readonly": "تكوين المهارة (للقراءة فقط)",
        "edit": "تعديل تكوين المهارة"
      },
      "sidebar": {
        "settings": "إعدادات المهارة",
        "tags": "العلامات",
        "loadingQuota": "جاري تحميل الحصة..."
      },
      "placeholders": {
        "name": "اسم المهارة",
        "description": "وصف موجز لما تفعله هذه المهارة",
        "instructions": "# تعليمات المهارة\nصف القدرة المحددة التي توفرها هذه المهارة.\n\n## القواعد الأساسية\n1. حدد كيف يجب أن يتصرف الوكيل\n2. سرد الإجراءات خطوة بخطوة\n3. حدد أي قيود\n\n## أمثلة\nقدم أمثلة على المخرجات المتوقعة...",
        "project": "حدد المشروع",
        "modelAgnostic": "مستقل عن النموذج (جميع النماذج)"
      },
      "hints": {
        "targetModel": "قم بوضع علامة على هذه المهارة لنموذج معين (اختياري). المهارات غير الموسومة متوافقة مع جميع النماذج.",
        "visibilityProject": "ستكون المهارة متاحة فقط للمشروع المحدد.",
        "visibilityPlatform": "ستكون المهارة متاحة لجميع المشاريع عبر سير عمل الموافقة."
      },
      "editor": {
        "instructions": "التعليمات (SKILL.md)",
        "markdownSupported": "Markdown مدعوم",
        "noInstructions": "لا توجد تعليمات للمعاينة بعد."
      },
      "header": {
        "quotaExceeded": "تم تجاوز حصة المهارات",
        "createSkill": "إنشاء مهارة",
        "saveChanges": "حفظ التغييرات"
      }
    }
  },
  "agentAutoTune": {
    "meta": {
      "breadcrumb": "مسار التنقل",
      "agentStudio": "استوديو الوكيل",
      "autoTuneRunsList": "قائمة تشغيل الضبط التلقائي",
      "metaDashboard": "لوحة القيادة الوصفية"
    },
    "compare": {
      "phaseStep": "مرحلة / خطوة",
      "score": "النتيجة",
      "metric": "المقياس",
      "baselineScore": "النتيجة الأساسية",
      "optimizedScore": "النتيجة المحسنة",
      "improvementPct": "نسبة التحسن %",
      "holdoutScore": "النتيجة المستبعدة",
      "costUsd": "التكلفة (دولار)",
      "iterations": "التكرارات",
      "nodesOptimized": "العقد المحسنة",
      "nodesTotal": "إجمالي العقد",
      "version": "الإصدار",
      "node": "عقدة",
      "loadingSessions": "جاري تحميل الجلسات للمقارنة...",
      "selectSessions": "حدد جلستين على الأقل للمقارنة.",
      "backToRuns": "العودة إلى التشغيل",
      "runComparisonTitle": "مقارنة التشغيل",
      "comparingSessions": "مقارنة {{count}} جلسات ضبط تلقائي",
      "summaryComparison": "مقارنة الملخص",
      "noDataToCompare": "لا توجد بيانات للمقارنة",
      "scoreTrajectoryOverlay": "تراكب مسار النتيجة",
      "comparingRuns": "مقارنة التشغيل",
      "chartExplainer1": "ليس للإسناد على مستوى العقدة. تمتلئ السلاسل بالفجوات.",
      "chartExplainer2": "أطوال المسار تتوافق مع الفهرس.",
      "labelsMatch": "تتطابق التسميات مع أطول جلسة",
      "phasesBaseline": "مراحل لكي تصطف القاعدة /",
      "validationLinesUp": "التحقق عبر عمليات التشغيل المختلفة.",
      "notEnoughTrajectory": "لا توجد بيانات مسار كافية (يتطلب نقطتين على الأقل).",
      "nodeLevelScore": "مقارنة النتيجة على مستوى العقدة",
      "noNodeDataToCompare": "لا توجد بيانات عقدة للمقارنة",
      "overlayExplainer": "يتراكب مع منحنيات النتيجة المركبة لكل عملية تشغيل محددة."
    },
    "runs": {
      "title": "موزن الوكيل التلقائي",
      "subtitle": "تشغيل عمليات التحسين الشاملة عبر وكلائك",
      "newAutoTune": "ضبط تلقائي جديد",
      "newAutoTuneButton": "ضبط تلقائي جديد",
      "selectProjectAgent": "اختر مشروعًا ووكيلاً لبدء التحسين",
      "project": "المشروع",
      "agent": "الوكيل",
      "proceed": "متابعة",
      "proceedButton": "متابعة",
      "startAutoTune": "بدء الضبط التلقائي",
      "metaDashboard": "لوحة القيادة الوصفية",
      "metaDashboardButton": "لوحة القيادة الوصفية",
      "compareSelected": "مقارنة المحددة",
      "status": "الحالة",
      "approval": "الموافقة",
      "optimizer": "المحسن",
      "searchPlaceholder": "البحث عن الجلسات...",
      "backToAgentsAria": "العودة إلى الوكلاء",
      "loadingMessage": "جاري تحميل عمليات الضبط التلقائي...",
      "emptyMessage": "لا توجد عمليات ضبط تلقائي بعد. انقر فوق 'ضبط تلقائي جديد' للبدء.",
      "statuses": {
        "all": "كل الحالات",
        "queued": "في الانتظار",
        "running": "قيد التشغيل",
        "baseline_running": "الخط المرجعي",
        "optimizing": "جاري التحسين",
        "validating": "جاري التحقق",
        "completed": "مكتمل",
        "completed_partial": "جزئي",
        "failed": "فاشل",
        "cancelled": "ملغى"
      },
      "approvals": {
        "all": "كل الموافقات",
        "pending": "معلق",
        "approved": "مقبول",
        "rejected": "مرفوض"
      },
      "optimizers": {
        "all": "كل المحسنات"
      },
      "picker": {
        "loadingProjects": "جاري تحميل المشاريع...",
        "selectProject": "اختر مشروعًا...",
        "selectAgent": "اختر وكيلاً...",
        "selectProjectFirst": "اختر مشروعًا أولاً...",
        "loadingAgents": "جاري تحميل الوكلاء...",
        "noAgents": "لا يوجد وكلاء في هذا المشروع"
      },
      "columns": {
        "agentName": "اسم الوكيل",
        "dataset": "مجموعة البيانات",
        "optimizer": "المحسن",
        "version": "الإصدار",
        "status": "الحالة",
        "approval": "الموافقة",
        "baselineScore": "درجة الخط المرجعي",
        "postTuneScore": "درجة ما بعد الضبط",
        "holdout": "الاحتياطي",
        "improvement": "التحسن",
        "trajectory": "المسار",
        "cost": "التكلفة",
        "nodes": "العقد",
        "healing": "الاستشفاء",
        "duration": "المدة",
        "createdBy": "أنشئ بواسطة",
        "createdAt": "أنشئ في",
        "actions": "الإجراءات",
        "optimizedNodes": "تم تحسين {{optimized}} من أصل {{total}}"
      },
      "actions": {
        "compareSelected": "مقارنة المحددة",
        "retry": "إعادة المحاولة",
        "stopRun": "إيقاف التشغيل",
        "delete": "حذف",
        "stopConfirm": "إلغاء الضبط التلقائي لـ \"{{label}}\"؟ سيؤدي ذلك إلى إيقاف العملية فورًا.",
        "cancelSuccess": "تم إلغاء الضبط التلقائي.",
        "cancelError": "فشل إلغاء عملية الضبط التلقائي. يرجى المحاولة مرة أخرى.",
        "deleteConfirm": "حذف جلسة الضبط التلقائي لـ \"{{label}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
        "deleteSuccess": "تم حذف جلسة الضبط التلقائي.",
        "deleteError": "فشل حذف الجلسة."
      },
      "retryDialog": {
        "title": "إعادة محاولة الضبط التلقائي",
        "message": "بدء ضبط تلقائي جديد لـ",
        "messageSuffix": " باستخدام نفس مجموعة البيانات والخيارات الخاصة بهذا التشغيل؟",
        "confirmLabel": "إعادة المحاولة",
        "successToast": "تم بدء تشغيل ضبط تلقائي جديد.",
        "errorToast": "فشل إعادة محاولة الضبط التلقائي."
      }
    },
    "detail": {
      "agentStudio": "استوديو الوكيل",
      "autoTuneRunsList": "قائمة تشغيل الضبط التلقائي",
      "backToList": "العودة إلى القائمة",
      "sessionOverview": "نظرة عامة على الجلسة",
      "configuration": "التكوين",
      "evaluationDetail": "تفاصيل التقييم",
      "nodeFeedback": "ملاحظات العقدة",
      "nodeComparison": "مقارنة العقد",
      "iterationHistory": "تاريخ التكرار",
      "approveDeploy": "الموافقة والنشر",
      "applyChanges": "تطبيق التغييرات على المسودة",
      "rejectOptimization": "رفض التحسين",
      "sessionStatus": "حالة الجلسة",
      "optimizerConfig": "تكوين المحسن",
      "evaluation": "التقييم",
      "originalSystemPrompt": "موجه النظام الأصلي",
      "optimizedSystemPrompt": "موجه النظام المحسن",
      "loading": {
        "opening": "جاري فتح عمليات الضبط التلقائي...",
        "session": "جاري تحميل جلسة التحسين..."
      },
      "notFound": {
        "message": "لم يتم العثور على جلسة الضبط التلقائي",
        "backButton": "العودة إلى تشغيل الضبط التلقائي"
      },
      "header": {
        "defaultTitle": "مركز ذكاء التحسين",
        "workflow": "سير العمل",
        "created": "أنشئ في",
        "backToRunsAria": "العودة إلى عمليات التشغيل"
      },
      "banner": {
        "failedTitle": "فشل التحسين",
        "rejectedTitle": "تم رفض المطالبة المحسنة",
        "noReason": "لم يتم تقديم سبب للرفض."
      },
      "tabs": {
        "overview": "نظرة عامة",
        "objectives": "دوال الأهداف",
        "nodes": "تحليل العقد",
        "prompts": "مختبر المطالبات",
        "regression": "تحليل الانحدار",
        "execution": "آثار التنفيذ",
        "audit": "المراجعة والاستشفاء"
      },
      "applyPanel": {
        "title": "استراتيجية التطبيق",
        "applyCurrent": "تطبيق على الوكيل الحالي",
        "newVersion": "حفظ كإصدار جديد",
        "previewOnly": "معاينة فقط",
        "versionBump": "ترقية الإصدار:",
        "saveAsNewProject": "حفظ كمشروع جديد",
        "projectName": "اسم المشروع",
        "placeholderReason": "سبب اختياري...",
        "reject": "رفض",
        "approveApply": "موافقة وتطبيق",
        "noPermission": "ليس لديك صلاحية لإنشاء مشاريع.",
        "previewUnavailable": "غير متاح للمعاينة فقط — اختر استراتيجية تطبيق أولاً."
      },
      "overview": {
        "pairedBaseline": "الخط المرجعي المقترن (تدريب)",
        "pairedPostMean": "المتوسط البعدي المقترن",
        "evalAccuracyImprovement": "تحسن دقة التقييم",
        "baselineTrain": "الخط المرجعي (تدريب)",
        "baselineHoldout": "الخط المرجعي (اختبار)",
        "optimizedScoreTrain": "الدرجة المحسنة (تدريب)",
        "optimizedScoreHoldout": "الدرجة المحسنة (اختبار)",
        "improvementTrain": "التحسن (تدريب)",
        "improvementHoldout": "التحسن (اختبار)",
        "estimatedCost": "التكلفة التقديرية",
        "duration": "المدة",
        "totalIterations": "إجمالي التكرارات",
        "optimizer": "المحسن",
        "nodesTotal": "إجمالي العقد",
        "tokensSession": "الرموز (الجلسة)",
        "metricsUsed": "المقاييس المستخدمة",
        "orchestrator": "المنسق",
        "openWorkflowRun": "فتح تشغيل سير العمل",
        "lightningRuns": "عمليات تشغيل رسم بياني لايتنينج للوكيل",
        "runId": "معرف التشغيل",
        "start": "البدء",
        "end": "الانتهاء",
        "optimizedScore": "الدرجة المحسنة",
        "improvement": "التحسن",
        "iterations": "التكرارات",
        "holdoutPostTune": "الاحتياطي (بعد الضبط)",
        "cost": "التكلفة",
        "version": "الإصدار",
        "configurationSummary": "ملخص التكوين",
        "runTimeline": "الخط الزمني للتشغيل",
        "timeline": {
          "created": "أنشئ في",
          "started": "بدأ في",
          "completed": "اكتمل في",
          "approvedBy": "تمت الموافقة بواسطة {{user}}"
        },
        "noMetricBreakdown": "لا يتوفر تفصيل لكل مقياس لهذه الجلسة (على سبيل المثال، لم يتم حفظ الدرجات لكل مقياس). افتح تفاصيل التسجيل (رمز المعلومات) لمعرفة كيفية تحديد درجات العناوين الرئيسية.",
        "metricBreakdownTitle": "تفصيل المقياس",
        "columnMetric": "المقياس",
        "columnBaseline": "الخط المرجعي",
        "columnOptimized": "المحسن",
        "columnDelta": "تغير",
        "columnChange": "تغيير",
        "explainerLead": "الدرجات عبارة عن مركب واحد في نطاق 0-1 مبني من مقاييس التقييم الخاصة بك، ثم يتم تجميعها عبر صفوف المؤشر.",
        "explainerStep1Title": "مركب لكل صف (الهدف)",
        "explainerStep1Desc": "لكل صف في مجموعة البيانات، يُشغّل النظام المقيمين المكوّنين (انظر المقاييس أدناه)، وينتج درجة واحدة لكل مقياس. يتم تعيين المقاييس التي تكون فيها القيم الأولية الأقل أفضل (على سبيل المثال السمية) بحيث يعني الأعلى دائمًا الأفضل قبل الخلط.",
        "explainerWeightedSumPrefix": "درجة الصف هي",
        "explainerWeightedSum": "مجموع مرجح",
        "explainerWeightedSumMid": "لهذه الدرجات المعدلة:",
        "explainerWeightedSumSuffix1": "، باستخدام",
        "explainerWeightedSumSuffix2": "من هذه الجلسة (تمت تسويتها ليكون المجموع 1).",
        "explainerUnweightedPrefix": "لم يتم تعيين",
        "explainerUnweightedMid": "، لذا فإن درجة الصف هي",
        "explainerUnweighted": "متوسط غير مرجح",
        "explainerUnweightedSuffix": "لدرجات المقياس المعدلة لهذا الصف.",
        "explainerStep2Title": "درجة الخط المرجعي (قسم التدريب)",
        "explainerStep2Desc": "الخط المرجعي الرئيسي هو المتوسط الحسابي لدرجات المركب لكل صف في قسم التدريب (باستثناء صفوف الاختبار)، باستخدام مقاييس الجلسة المكونة فقط، فوق الصفوف التي انتهت دون خطأ في التنفيذ:",
        "explainerStep3Title": "الدرجة المحسنة والمسار",
        "explainerStep3Desc": "يتم استخدام نفس تعريف المركب عند تقييم الوكيل بعد تغييرات المطالبة؛ تستخدم الدرجة المحسنة الرئيسية ومنحنى التكرار نفس هذا المقياس.",
        "explainerMultiObjEnabled": "تم تمكين الوضع متعدد الأهداف.",
        "explainerMultiObjMid": "(أدناه) قد توجه التحسين متعدد الأهداف؛ لا يزال الخط المرجعي ومركبات الصفوف تتبع",
        "explainerMultiObjSuffix": "عند تعيينها، وإلا فإن الوزن متساوٍ كما هو موضح أعلاه.",
        "explainerMetricsEvaluated": "المقاييس التي تم تقييمها في هذه الجلسة",
        "explainerRowWeights": "أوزان مركب الصف",
        "explainerMultiObjWeights": "الأوزان متعددة الأهداف",
        "columnRawWeight": "الوزن الأولي",
        "columnNormalized": "تسوية",
        "columnMetricObjective": "المقياس / الهدف",
        "explainerThisSession": "هذه الجلسة:",
        "explainerBaselineTrain": "الخط المرجعي (تدريب) =",
        "explainerOptimizedEquals": "المحسن ="
      },
      "objectives": {
        "noObjectives": "لم يتم تحديد أي أهداف",
        "columnName": "اسم الهدف",
        "columnWeight": "الوزن",
        "columnFormula": "المعادلة",
        "columnDescription": "الوصف"
      },
      "nodes": {
        "noNodes": "لا توجد نتائج عقد متاحة",
        "columnId": "معرف العقدة",
        "columnOptimizer": "المحسن",
        "columnBaseline": "درجة الخط المرجعي",
        "columnOptimized": "الدرجة المحسنة",
        "columnImprovement": "التحسن",
        "columnTrajectory": "المسار",
        "columnHoldout": "درجة الاختبار",
        "columnHoldoutImp": "تحسن الاختبار",
        "customPrompt": "المطالبة المخصصة للنظام",
        "modelOverride": "تجاوز النموذج",
        "instructionsOverride": "تجاوز تعليمات DSPy",
        "columnNode": "العقدة",
        "columnIter": "التكرار",
        "columnBlame": "اللوم",
        "columnOriginalTrain": "الأصلي (تدريب)",
        "columnOptimizedTrain": "المحسن (تدريب)",
        "columnHealing": "الاستشفاء",
        "columnCost": "التكلفة",
        "collapse": "طي",
        "showConfig": "إظهار تفاصيل التكوين / المحسن",
        "noNodeAnalysisData": "لا تتوفر بيانات تحليل العقد لهذه الجلسة."
      },
      "prompts": {
        "nodeLabel": "العقدة:",
        "selectNode": "حدد عقدة لفحص مطالباتها...",
        "originalSystemPrompt": "المطالبة الأصلية للنظام",
        "optimizedSystemPrompt": "المطالبة المحسنة للنظام",
        "originalInstructions": "التعليمات الأصلية (DSPy)",
        "optimizedInstructions": "التعليمات المحسنة (DSPy)",
        "versionBase": "أساسي",
        "versionLatest": "أحدث تحسين",
        "selectVersion": "اختر الإصدار",
        "fallbackLeft": "يسار",
        "fallbackRight": "يمين",
        "noData": "لا تتوفر بيانات مطالبة أو معلمات لهذه الجلسة."
      },
      "regression": {
        "noData": "لا تتوفر بيانات تحليل الانحدار.",
        "columnRowIndex": "فهرس الصف",
        "columnBaseline": "الخط المرجعي",
        "columnOptimized": "المحسن",
        "columnChange": "التغيير",
        "columnInput": "معاينة الإدخال",
        "columnError": "خطأ",
        "columnOutput": "معاينة الإخراج",
        "improvedRows": "الصفوف المحسنة",
        "degradedRows": "الصفوف المتراجعة",
        "quarantinedRows": "الصفوف المعزولة",
        "columnRowNumber": "رقم الصف",
        "columnQuestionInput": "سؤال / إدخال",
        "columnDelta": "تغير",
        "columnWhatChanged": "ما الذي تغير",
        "columnInputPreview": "معاينة الإدخال",
        "columnOutputPreview": "معاينة الإخراج",
        "metricNetImprovement": "التحسن الصافي",
        "metricImprovedRows": "الصفوف المحسنة",
        "metricDegradedRows": "الصفوف المتراجعة",
        "metricUnchangedRows": "الصفوف غير المتغيرة",
        "metricTotalRows": "إجمالي الصفوف",
        "metricHoldoutEvaluated": "صفوف الاختبار المقيمة",
        "noDegradedRows": "لا توجد صفوف متراجعة",
        "noImprovedRows": "لا توجد صفوف محسنة",
        "noQuarantinedRows": "لا توجد صفوف معزولة",
        "noReport": "لا يوجد تقرير انحدار أو صفوف معزولة لهذه الجلسة."
      },
      "execution": {
        "title": "الخط الزمني لتنفيذ التدفق",
        "noData": "لا توجد بيانات متاحة للخط الزمني للتنفيذ.",
        "columnTask": "المهمة / المرحلة",
        "columnDuration": "المدة",
        "columnStatus": "الحالة",
        "columnDetails": "التفاصيل / المخرجات",
        "activeRun": "تشغيل نشط",
        "currentProcess": "العملية الحالية",
        "activeNode": "العقدة النشطة",
        "optimizingNode": "تحسين العقدة: {{node}}",
        "nodeId": "معرف العقدة",
        "lastProcess": "العملية الأخيرة",
        "phaseDurationWaterfall": "شلال مدة المرحلة",
        "phaseDurationDesc": "فترات مرحلة التشغيل المكتملة بالثواني (ترتيب زمني).",
        "phaseDurationExplainer": "كل شريط يمثل مرحلة سير عمل مكتملة (الخط المرجعي، مشترك/Lightning، تحسين كل عقدة، تحقق). الارتفاعات تمثل المدة بالثواني؛ يجمع شريط الإجمالي النهائي جميع المراحل المكتملة.",
        "phaseDurationsPending": "ستظهر فترات المرحلة هنا عند اكتمال المراحل.",
        "phaseDurationsEmpty": "لم يتم تسجيل أي سجل لمدة المرحلة لهذا التشغيل.",
        "phaseLog": "سجل المرحلة",
        "fallbackPhase": "المرحلة {{num}}"
      },
      "audit": {
        "healingEvents": "أحداث الاستشفاء",
        "auditTrail": "سجل المراجعة",
        "noData": "لا تتوفر بيانات مراجعة أو استشفاء لهذه الجلسة.",
        "auditTrailCount": "سجل المراجعة"
      },
      "charts": {
        "scoreTrajectory": "مسار الدرجات",
        "baselineObjective": "الخط المرجعي وتسجيل الأهداف",
        "metricComparison": "مقارنة المقاييس: الخط المرجعي مقابل المحسن",
        "convergenceAnalysis": "تحليل التقارب",
        "blameWaterfall": "شلال اللوم",
        "costTokenBreakdown": "تفصيل التكلفة والرموز لكل عقدة",
        "scatterBaselineOpt": "تشتت الخط المرجعي مقابل المحسن (صفوف التدريب)",
        "phaseDuration": "شلال مدة المرحلة",
        "howToRead": "كيفية قراءة هذا المخطط",
        "xAxisPhase": "المرحلة",
        "yAxisDuration": "المدة (ثوانٍ)",
        "summaryScoreTrajectory": "الدرجة المركبة في كل معلم تشغيل (الخط المرجعي، Lightning الاختياري، تكرارات التحسين، التحقق)، مع تباينات من خطوة إلى أخرى على المحور الثاني.",
        "summaryBaselineObjective": "درجات مركبة 0-1 من مقاييسك؛ متوسطات الخط المرجعي فوق الصفوف الناجحة. استخدم رمز المعلومات للمعادلات والأوزان وقيم هذه الجلسة.",
        "summaryMetricComparison": "أعمدة مجمعة تقارن الخط المرجعي لكل مقياس مكوّن مقابل المتوسط بعد الضبط.",
        "summaryConvergenceAnalysis": "|Δ درجة| بين نقاط المسار المتتالية—تساعد في اكتشاف متى تتباطأ التحسينات أو تستقر.",
        "summaryBlameWaterfall": "درجات اللوم النسبية لكل عقدة قماشية—تشير الأعمدة الأعلى إلى العقد التي ساهمت أكثر في نتائج الخط المرجعي الضعيفة وتميل إلى أن تعطى الأولوية للتحسين.",
        "summaryCostTokenBreakdown": "إجمالي رموز المطالبة والإكمال (المحور الأيسر) والتكلفة المقدرة (المحور الأيمن) المنسوبة إلى كل عقدة عبر جميع التقييمات.",
        "summaryScatterBaselineOpt": "كل نقطة تمثل صف تدريب واحد بعد التحقق: x = الدرجة المركبة قبل الضبط، y = الدرجة المركبة مع المطالبات المضبوطة. الخط القطري المتقطع هو خط عدم التغيير (y = x)."
      }
    }
  },
  "aiTransparency": {
    "title": "شفافية الذكاء الاصطناعي",
    "loadingInventory": "جاري تحميل مخزون شفافية الذكاء الاصطناعي...",
    "allSystemAgents": "جميع وكلاء النظام",
    "systemAgent": "وكيل النظام",
    "registeredBy": "مسجل بواسطة",
    "project": "المشروع",
    "agentSubAgent": "الوكيل / الوكيل الفرعي",
    "env": "البيئة",
    "subAgentCount": "عدد الوكلاء الفرعيين",
    "actions": "الإجراءات",
    "viewMetadata": "عرض البيانات الوصفية",
    "searchAgents": "البحث عن الوكلاء...",
    "emptyMessage": "لا يوجد وكلاء مسجلون بعد. قم بتسجيل الوكلاء المنشورين من استوديو الوكلاء لرؤيتهم هنا.",
    "unknown": "غير معروف",
    "status": "الحالة",
    "metadata": "البيانات الوصفية",
    "expandAgent": "توسيع {{name}}",
    "collapseAgent": "طي {{name}}",
    "subAgentFallback": "وكيل فرعي {{index}}",
    "subAgentTypes": {
      "agent": "وكيل فرعي",
      "supervisor": "مشرف",
      "intent_classifier": "مصنف النية",
      "disambiguation": "إزالة الغموض",
      "external_agent": "وكيل خارجي",
      "rlm": "RLM",
      "router": "موجّه",
      "hitl": "موافقة بشرية",
      "sub_agent": "وكيل فرعي"
    }
  },
  "registry": {
    "agents": {
      "columnAgentName": "Agent Name",
      "registerAgent": "تسجيل الوكيل",
      "searchRegisteredAgents": "البحث عن الوكلاء المسجلين...",
      "searchArchivedAgents": "البحث عن الوكلاء المؤرشفين...",
      "emptyActiveAgentsDesc": "لم يتم تسجيل أي وكلاء بعد. قم بتسجيل الوكلاء المنشورين من استوديو الوكلاء لرؤيتهم هنا.",
      "emptyArchivedAgentsDesc": "لا يوجد وكلاء مؤرشفين. سيظهر الوكلاء المؤرشفين من السجل هنا.",
      "registeredAgentsTitle": "الوكلاء المسجلون",
      "archivedAgentsTitle": "الوكلاء المؤرشفون",
      "agentsLabel": "الوكلاء",
      "agentRegistryTitle": "سجل الوكلاء",
      "filterSystemAgent": "وكيل النظام",
      "filterAllSystemAgents": "جميع وكلاء النظام",
      "loadingAgents": "جاري تحميل الوكلاء...",
      "searchAgents": "البحث عن وكلاء...",
      "dynamicFilter_agent_type": "يكتب",
      "columnAgent": "وكيل",
      "editAgentTitle": "Edit Agent",
      "configureAgentTitle": "Configure {{platformName}}",
      "registerAgentBtn": "Register Agent",
      "selectAgentPlatformDesc": "حدد المنصة التي تم إنشاء وكيلك عليها",
      "importAgentsTitle": "استيراد الوكلاء من CSV",
      "importAgentsDesc": "ينشئ وكلاء خارجيين فقط. يتم تخطي الصفوف التي تطابق اسمًا وإصدارًا موجودين. لا تتم قراءة بيانات الاعتماد أبدًا من CSV.",
      "agentEntity": "وكيل"
    },
    "workflows": {
      "columnWorkflow": "اسم سير العمل",
      "workflowsLabel": "سير العمل",
      "searchRegisteredWorkflows": "البحث في سير العمل المسجلة...",
      "searchArchivedWorkflows": "البحث في سير العمل المؤرشفة...",
      "loadingRegisteredWorkflows": "جارٍ تحميل سير العمل المسجلة...",
      "loadingArchivedWorkflows": "جارٍ تحميل سير العمل المؤرشفة...",
      "emptyRegisteredWorkflows": "لا توجد سير عمل مسجلة بعد.",
      "emptyArchivedWorkflows": "لا توجد سير عمل مؤرشفة.",
      "bulkArchiveWorkflows": "أرشفة المحدد",
      "bulkRestoreWorkflows": "استعادة المحدد",
      "workflowRegistryTitle": "سجل سير العمل",
      "registeredWorkflowsTitle": "سير العمل المسجلة",
      "archivedWorkflowsTitle": "سير العمل المؤرشفة",
      "registerExternalWorkflowTitle": "Register External Workflow",
      "selectWorkflowPlatformDesc": "حدد المنصة التي تم بناء سير العمل عليها. هذا التسجيل للكتالوج فقط.",
      "importWorkflowsTitle": "استيراد مسارات العمل من CSV",
      "importWorkflowsDesc": "إنشاء مسودات مسارات العمل فقط. مفتاح المطابقة هو الاسم + الإصدار.",
      "workflowEntity": "سير العمل",
      "loading": "جاري تحميل مسارات العمل..."
    },
    "guardrails": {
      "guardrailsLabel": "حواجز الحماية",
      "actionGuardrails": "حواجز الحماية",
      "guardrailsRepository": "مستودع حواجز الحماية",
      "agentGuardrails": "حواجز حماية الوكيل",
      "guardrailsCoverage": "التغطية",
      "searchProfiles": "البحث في الملفات الشخصية...",
      "newProfile": "ملف شخصي جديد",
      "noGuardrailsAccess": "ليس لديك حق الوصول إلى أي من ميزات حواجز الحماية.",
      "loadingProfiles": "جاري تحميل الملفات الشخصية...",
      "columnAttachedProfiles": "الملفات الشخصية المرفقة",
      "coverageBanner": "التغطية المكونة فقط — لا تغير التنفيذ. الفجوات هي إشارات الجرد.",
      "exportCoverageCsv": "تصدير CSV",
      "loadingCoverage": "جاري تحميل خريطة التغطية...",
      "coverageCovered": "مغطى",
      "coverageGap": "فجوة",
      "coverageNA": "غير متوفر",
      "coverageUnknown": "غير معروف",
      "createProfileBtn": "إنشاء ملف تعريف",
      "savingProfileBtn": "جاري الحفظ...",
      "updateProfileBtn": "تحديث ملف التعريف",
      "editProfileTitle": "تعديل ملف التعريف",
      "newGuardrailProfileTitle": "ملف تعريف Guardrail جديد",
      "profileNameLabel": "اسم ملف التعريف *",
      "profileNamePlaceholder": "مثال: معيار حماية معلومات التعريف الشخصية",
      "profileNameHint": "أحرف وأرقام ومسافات وواصلات وشرطات سفلية فقط",
      "profileDescLabel": "الوصف",
      "profileDescPlaceholder": "صف ملف تعريف Guardrail هذا...",
      "profileDescHint": "نص عادي فقط — لا رموز تعبيرية أو أحرف خاصة",
      "guardrailsEnabled": "تم تمكين Guardrails",
      "guardrailsDisabled": "تم تعطيل Guardrails",
      "noEnginesConfigured": "لم يتم تكوين محركات Guardrail",
      "enginesActive": "{{enabledCount}}/{{totalCount}} محركات نشطة",
      "inactiveDeploymentBanner": "نشر هذا الوكيل غير نشط. التكوين مقيد.",
      "devFrozenBanner": "تم نشر هذا الوكيل. تم تجميد حواجز DEV — قم بتحرير حواجز نشر QA/UAT/PROD بدلاً من ذلك.",
      "adminOnlyBanner": "Deployment guardrails can only be modified by administrators.",
      "recentViolations": "Recent Violations",
      "metricsSummaryTitle": "ملخص المقاييس",
      "metricTotalChecks": "إجمالي الفحوصات",
      "metricBlocked": "محظور",
      "metricWarned": "تحذير",
      "metricPassed": "ناجح",
      "metricErrors": "أخطاء",
      "metricLatency": "وقت الاستجابة",
      "searchViolationsPlaceholder": "البحث عن الانتهاكات...",
      "noRecentViolations": "لا توجد انتهاكات حديثة",
      "violationTimestamp": "الطابع الزمني",
      "violationUser": "المستخدم",
      "violationEngine": "المحرك",
      "violationStatus": "الحالة",
      "violationDetails": "التفاصيل",
      "violationAction": "الإجراء",
      "violationRule": "القاعدة",
      "columnEngines": "Engines",
      "loading": "جاري تحميل حواجز الحماية...",
      "configMode": "الوضع",
      "configExecution": "التنفيذ",
      "configTimeout": "المهلة الافتراضية (ثواني)",
      "configSafeMessage": "رسالة آمنة",
      "configCircuitBreaker": "قاطع الدائرة",
      "configFailureThreshold": "حد الفشل",
      "configCooldown": "وقت التهدئة (ثواني)",
      "modeBlock": "حظر — حظر المحتوى المميز",
      "modeObserve": "مراقبة — تسجيل فقط، لا تحظر",
      "execSequential": "متسلسل",
      "execParallel": "متوازي",
      "safeMessagePlaceholder": "لا يمكنني معالجة هذا الطلب بسبب قيود سياسة المحتوى.",
      "mode_block": "حظر — حظر المحتوى المميز",
      "mode_warn": "تحذير — تسجيل تحذير، والسماح بالمحتوى",
      "mode_shadow": "مراقبة — تسجيل فقط، لا تحظر",
      "exec_sequential": "متسلسل",
      "exec_parallel": "متوازي"
    },
    "common": {
      "columnProject": "المشروع",
      "columnVersion": "الإصدار",
      "exportCsvTitle": "تصدير CSV (يتضمن تكوين الأعمدة)",
      "exportCsvAria": "تصدير CSV",
      "importCsvTitle": "استيراد CSV",
      "importCsvAria": "استيراد CSV",
      "columnEnv": "البيئة",
      "columnOrchestrator": "المنسق",
      "columnFramework": "الإطار",
      "columnRegisteredBy": "مُسجَّل بواسطة",
      "columnRegisteredAt": "تاريخ التسجيل",
      "columnArchivedAt": "تاريخ الأرشفة",
      "columnActions": "الإجراءات",
      "columnStatus": "الحالة",
      "filterBarTitle": "الفلاتر",
      "filterFramework": "الإطار",
      "filterProject": "المشروع",
      "filterRegisteredBy": "مُسجَّل بواسطة",
      "filterType": "النوع",
      "filterStatus": "الحالة",
      "loadingRegistered": "جارٍ تحميل الوكلاء المسجلين...",
      "loadingArchived": "جارٍ تحميل الوكلاء المؤرشفين...",
      "bulkArchive": "أرشفة المحدد",
      "bulkRestore": "استعادة المحدد",
      "bulkDelete": "حذف المحدد",
      "deleteSelected": "حذف المحدد",
      "showLess": "عرض أقل",
      "actionTest": "اختبار",
      "actionEdit": "Edit",
      "actionViewMetadata": "عرض البيانات الوصفية",
      "actionEditMetadata": "تعديل البيانات الوصفية",
      "actionEvaluate": "تقييم",
      "actionViewEvalRuns": "عرض تشغيلات التقييم",
      "actionTraces": "التتبعات",
      "actionLogs": "السجلات",
      "actionApiDocs": "وثائق API",
      "actionClone": "نسخ",
      "actionDeploy": "نشر",
      "actionDelete": "Delete",
      "actionArchive": "أرشفة من السجل",
      "actionRestore": "استعادة إلى السجل",
      "actionOpen": "فتح",
      "actionPromoteToStore": "الترويج إلى المتجر",
      "actionRuns": "التشغيلات",
      "actionOpenCanvas": "فتح اللوحة",
      "registerExternal": "تسجيل خارجي",
      "allCreators": "جميع المنشئين",
      "searchCreators": "البحث عن المنشئين...",
      "creatorLabel": "المنشئ",
      "tableRows": "الصفوف:",
      "tableShowing": "عرض {{startItem}}-{{endItem}} من {{totalItems}}",
      "filterResultsOf": "{{resultCount}} من {{totalCount}}",
      "filterResultsCount": "{{count}} نتيجة",
      "filterLess": "أقل",
      "filterMore": "المزيد",
      "filterClearAll": "مسح جميع الفلاتر",
      "filterClear": "مسح",
      "filterSavePreset": "حفظ إعداد الفلتر المسبق",
      "noDataAvailable": "لا توجد بيانات متاحة",
      "actionView": "View",
      "filterAllEnvironments": "جميع البيئات",
      "dynamicFilter_status": "حالة",
      "dynamicFilter_catalog_status": "حالة",
      "dynamicFilter_type": "يكتب",
      "columnEnvShort": "بيئة",
      "columnChat": "دردشة",
      "columnAPI": "API",
      "columnVoice": "صوت",
      "columnRAG": "RAG",
      "columnTools": "أدوات",
      "columnEnabled": "مفعل",
      "columnMode": "وضع",
      "columnContentSafety": "سلامة المحتوى",
      "columnJailbreak": "كسر الحماية / Prompt Shields",
      "columnDLP": "DLP / PII",
      "columnProfileAttached": "ملف مرفق",
      "columnWorkflowChannel": "سير العمل",
      "cancelBtn": "إلغاء",
      "globalSettings": "الإعدادات العامة",
      "architectureTitle": "Architecture",
      "reviewSaveTitle": "Review & Save",
      "reviewRegisterTitle": "Review & Register",
      "stepReview": "مراجعة",
      "stepPlatform": "المنصة",
      "stepConfigure": "تكوين",
      "stepArchitecture": "البنية",
      "savingBtn": "Saving...",
      "registeringBtn": "Registering...",
      "saveChangesBtn": "Save changes",
      "statusActive": "active",
      "statusInactive": "inactive",
      "statusPublished": "PUBLISHED",
      "actionDeleteSelected": "Delete Selected",
      "columnName": "Name",
      "columnDescription": "Description",
      "expectedColumns": "الأعمدة المتوقعة",
      "platformAdminConfigureFields": "حقول تكوين مسؤول المنصة",
      "downloadTemplate": "تنزيل القالب",
      "chooseCsv": "اختر CSV",
      "importBtn": "استيراد",
      "importingBtn": "جاري الاستيراد...",
      "dynamicOption_agent": "وكيل",
      "dynamicOption_sub-agent": "وكيل فرعي",
      "closeBtn": "إغلاق",
      "statRows": "الصفوف",
      "statCreated": "تم الإنشاء",
      "statDuplicates": "التكرارات",
      "statErrors": "الأخطاء",
      "viewDuplicates": "عرض التكرارات",
      "dupTitle": "تم تخطي تكرارات الاستيراد",
      "dupRowsProcessed": "الصفوف المعالجة",
      "dupCreated": "تم الإنشاء",
      "dupSkipped": "التكرارات التي تم تخطيها",
      "dupHint2": "لديها بالفعل هذا الاسم في قاعدة البيانات ولكن لم يتم عرضها في السجل؛ أعد التسمية أو قم بزيادة الإصدار",
      "dupNoMatch": "لا توجد تكرارات تطابق عامل التصفية هذا.",
      "dupSearchPlaceholder": "البحث في التكرارات...",
      "dupRowsPerPage": "الصفوف لكل صفحة:",
      "hideAll": "إخفاء الكل",
      "showAll": "إظهار الكل",
      "loading": "جاري التحميل..."
    }
  },
  "exportImport": {
    "import": {
      "dialogTitle": "استيراد YAML",
      "bulkDialogTitle": "استيراد جماعي",
      "filesCount": "{{count}} ملف",
      "filesCount_plural": "{{count}} ملفات",
      "validFilesCount": "{{count}} ملف صالح",
      "validFilesCount_plural": "{{count}} ملفات صالحة",
      "withErrorsCount": "{{count}} به أخطاء",
      "withErrorsCount_plural": "{{count}} بها أخطاء",
      "switchToSingle": "التبديل إلى ملف فردي",
      "switchToBulk": "التبديل إلى الاستيراد الجماعي",
      "targetProject": "المشروع المستهدف",
      "optional": "(اختياري)",
      "selectTargetProject": "حدد المشروع المستهدف...",
      "selectProjectOptional": "حدد مشروعاً (اختياري)...",
      "selectProjectWarning": "يرجى تحديد مشروع لاستيراد {{entity}}",
      "thisEntity": "هذا الكيان",
      "dropzoneBulk": "أسقط ملفات YAML أو انقر للاستعراض (يسمح بملفات متعددة)",
      "dropzoneSingle": "أسقط ملف YAML أو انقر للاستعراض",
      "fileTypes": ".yaml, .yml",
      "importingProgress": "جارٍ استيراد {{current}} من {{total}}...",
      "yamlContentLabel": "محتوى YAML",
      "yamlPlaceholderComment": "الصق محتوى YAML أو قم بتعديله هنا",
      "importBehavior": "سلوك الاستيراد",
      "matchOrCreate": "مطابقة أو إنشاء",
      "matchOrCreateDesc": "الربط بالكيانات الحالية، وإنشاء جديد إذا لم يتم العثور عليه",
      "matchOnly": "مطابقة فقط",
      "matchOnlyDesc": "الربط بالكيانات الحالية فقط، والتخطي إذا لم يتم العثور عليه",
      "createNew": "إنشاء جديد",
      "createNewDesc": "إنشاء جديد دائماً، والفشل إذا كان موجوداً بالفعل",
      "previewResults": "نتائج المعاينة",
      "newBadge": "+{{count}} جديد",
      "skippedBadge": "{{count}} تم تخطيه",
      "failedBadge": "{{count}} فشل",
      "createdBadge": "+{{count}} تم إنشاؤه",
      "moreEntities": "+{{count}} كيانات إضافية",
      "moreErrors": "+{{count}} أخطاء إضافية",
      "moreWarnings": "+{{count}} المزيد",
      "importSuccessful": "تم الاستيراد بنجاح",
      "bulkImportComplete": "اكتمل الاستيراد الجماعي",
      "importFailed": "فشل الاستيراد",
      "bulkImportCompletedWithErrors": "اكتمل الاستيراد الجماعي مع وجود أخطاء",
      "notes": "ملاحظات:",
      "errors": "أخطاء:",
      "done": "تم",
      "cancel": "إلغاء",
      "preview": "معاينة",
      "import": "استيراد",
      "importing": "جارٍ الاستيراد...",
      "importAll": "استيراد الكل ({{count}})",
      "removeFile": "إزالة الملف",
      "buttonTitle": "استيراد YAML",
      "buttonAria": "استيراد YAML",
      "buttonLabel": "استيراد",
      "failedToReadFile": "فشل في قراءة الملف",
      "invalidYaml": "ملف YAML غير صالح",
      "importFailedGeneric": "فشل الاستيراد",
      "typeMismatchError": "يحتوي هذا الملف على {{detectedName}}، لكنك في صفحة {{expectedName}}. يرجى استيراد هذا الملف من الصفحة الصحيحة."
    },
    "configWarnings": {
      "title": "التكوين مطلوب",
      "subtitle": "قد لا يعمل الكيان المستورد بشكل صحيح حتى يتم تكوين العناصر التالية:",
      "actionRequired": "إجراء مطلوب:",
      "actionRequiredDesc": "تم العثور على {{criticalCount}} {{criticalLabel}} حرج و {{warningCount}} {{warningLabel}}. قد لا يعمل الوكيل دون معالجة المشكلات الحرجة.",
      "actionRequiredOnlyCritical": "تم العثور على {{criticalCount}} {{criticalLabel}} حرج. قد لا يعمل الوكيل دون معالجة المشكلات الحرجة.",
      "issue": "مشكلة",
      "issues": "مشكلات",
      "warning": "تحذير",
      "warnings": "تحذيرات",
      "critical": "حرج",
      "categories": {
        "model": "نماذج الذكاء الاصطناعي",
        "models": "نماذج الذكاء الاصطناعي",
        "prompt": "المطالبات",
        "prompts": "المطالبات",
        "tool": "الأدوات",
        "tools": "الأدوات",
        "knowledge": "مصادر المعرفة",
        "skill": "المهارات",
        "skills": "المهارات",
        "connector": "الموصلات",
        "connectors": "الموصلات",
        "iam": "تكوينات إدارة الهوية والوصول (IAM)",
        "other": "أخرى"
      }
    },
    "export": {
      "export": "تصدير",
      "exportSelected": "تصدير المحدد",
      "exportYaml": "تصدير YAML",
      "exportAgent": "تصدير الوكيل",
      "agentAlwaysIncluded": "الوكيل (مضمن دائماً)",
      "included": "مضمن",
      "dependencies": "التبعيات",
      "selectedOf": "تم تحديد {{selected}} من {{total}}",
      "selectAll": "تحديد الكل",
      "deselectAll": "إلغاء تحديد الكل",
      "loadingDeps": "جارٍ تحميل التبعيات...",
      "noDeps": "لم يتم العثور على تبعيات. سيتم تصدير الوكيل فقط.",
      "permissionDenied": "ليس لديك إذن لتصدير هذا الوكيل. يرجى الاتصال بالمسؤول.",
      "failedToLoadDeps": "فشل تحميل التبعيات",
      "filesWillBeExported": "سيتم تصدير {{count}} ملف YAML",
      "filesWillBeExported_plural": "سيتم تصدير {{count}} ملفات YAML",
      "cancel": "إلغاء",
      "confirmExport": "تأكيد التصدير",
      "exporting": "جارٍ التصدير..."
    },
    "entityTypes": {
      "model": "نموذج",
      "tool": "أداة",
      "prompt": "مطالبة",
      "skill": "مهارة",
      "agent": "وكيل",
      "knowledge": "مصدر المعرفة",
      "storage_folder": "مجلد التخزين",
      "connector": "موصل",
      "iam": "تكوين IAM",
      "bundle": "حزمة",
      "workflow": "سير العمل"
    }
  }
}